import { jsx as U, Fragment as co, jsxs as Qt } from "react/jsx-runtime";
import * as Ke from "react";
import it, { createContext as Et, useRef as j, useLayoutEffect as uo, useEffect as ht, useId as Yn, useContext as _, useInsertionEffect as Xn, useMemo as vt, useCallback as fe, Children as ho, isValidElement as Sa, useState as ct, Fragment as fo, createElement as ba, forwardRef as Ft, Component as Pa, useImperativeHandle as Aa, cloneElement as Ea } from "react";
import { o as Ca } from "./index-CcECYkhV.mjs";
import { createPortal as Va } from "react-dom";
import { u as Da } from "./use-isomorphic-layout-effect-m4WLzKHG.mjs";
import { u as Ma, g as Di, P as Ra } from "./portal-scope-avllZKuk.mjs";
import { c as Te } from "./tw-cn-mXgPecoF.mjs";
import "react-dom/client";
import { t as La } from "./throttle-CbOTDqvg.mjs";
const qn = Et({});
function de(t) {
  const e = j(null);
  return e.current === null && (e.current = t()), e.current;
}
const ka = typeof window < "u", Zn = ka ? uo : ht, ze = /* @__PURE__ */ Et(null);
function Jn(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function Ut(t, e) {
  const n = t.indexOf(e);
  n > -1 && t.splice(n, 1);
}
const gt = (t, e, n) => n > e ? e : n < t ? t : n;
function Sn(t, e) {
  return e ? `${t}. For more information and steps for solving, visit https://motion.dev/troubleshooting/${e}` : t;
}
let zt = () => {
}, ft = () => {
};
var lo;
typeof process < "u" && ((lo = process.env) == null ? void 0 : lo.NODE_ENV) !== "production" && (zt = (t, e, n) => {
  !t && typeof console < "u" && console.warn(Sn(e, n));
}, ft = (t, e, n) => {
  if (!t)
    throw new Error(Sn(e, n));
});
const Pt = {}, mo = (t) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(t);
function po(t) {
  return typeof t == "object" && t !== null;
}
const go = (t) => /^0[^.\s]+$/u.test(t);
// @__NO_SIDE_EFFECTS__
function yo(t) {
  let e;
  return () => (e === void 0 && (e = t()), e);
}
const rt = /* @__NO_SIDE_EFFECTS__ */ (t) => t, Ia = (t, e) => (n) => e(t(n)), me = (...t) => t.reduce(Ia), _t = /* @__NO_SIDE_EFFECTS__ */ (t, e, n) => {
  const i = e - t;
  return i === 0 ? 1 : (n - t) / i;
};
class Qn {
  constructor() {
    this.subscriptions = [];
  }
  add(e) {
    return Jn(this.subscriptions, e), () => Ut(this.subscriptions, e);
  }
  notify(e, n, i) {
    const s = this.subscriptions.length;
    if (s)
      if (s === 1)
        this.subscriptions[0](e, n, i);
      else
        for (let r = 0; r < s; r++) {
          const o = this.subscriptions[r];
          o && o(e, n, i);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const tt = /* @__NO_SIDE_EFFECTS__ */ (t) => t * 1e3, ot = /* @__NO_SIDE_EFFECTS__ */ (t) => t / 1e3;
function vo(t, e) {
  return e ? t * (1e3 / e) : 0;
}
const Mi = /* @__PURE__ */ new Set();
function Ge(t, e, n) {
  t || Mi.has(e) || (console.warn(Sn(e, n)), Mi.add(e));
}
const Ba = (t, e, n) => {
  const i = e - t;
  return ((n - t) % i + i) % i + t;
}, To = (t, e, n) => (((1 - 3 * n + 3 * e) * t + (3 * n - 6 * e)) * t + 3 * e) * t, Fa = 1e-7, Oa = 12;
function Na(t, e, n, i, s) {
  let r, o, a = 0;
  do
    o = e + (n - e) / 2, r = To(o, i, s) - t, r > 0 ? n = o : e = o;
  while (Math.abs(r) > Fa && ++a < Oa);
  return o;
}
function pe(t, e, n, i) {
  if (t === e && n === i)
    return rt;
  const s = (r) => Na(r, 0, 1, t, n);
  return (r) => r === 0 || r === 1 ? r : To(s(r), e, i);
}
const xo = (t) => (e) => e <= 0.5 ? t(2 * e) / 2 : (2 - t(2 * (1 - e))) / 2, wo = (t) => (e) => 1 - t(1 - e), So = /* @__PURE__ */ pe(0.33, 1.53, 0.69, 0.99), ti = /* @__PURE__ */ wo(So), bo = /* @__PURE__ */ xo(ti), Po = (t) => t >= 1 ? 1 : (t *= 2) < 1 ? 0.5 * ti(t) : 0.5 * (2 - Math.pow(2, -10 * (t - 1))), ei = (t) => 1 - Math.sin(Math.acos(t)), Ao = wo(ei), Eo = xo(ei), ja = /* @__PURE__ */ pe(0.42, 0, 1, 1), Wa = /* @__PURE__ */ pe(0, 0, 0.58, 1), Co = /* @__PURE__ */ pe(0.42, 0, 0.58, 1), Vo = (t) => Array.isArray(t) && typeof t[0] != "number";
function Do(t, e) {
  return Vo(t) ? t[Ba(0, t.length, e)] : t;
}
const Mo = (t) => Array.isArray(t) && typeof t[0] == "number", Ri = {
  linear: rt,
  easeIn: ja,
  easeInOut: Co,
  easeOut: Wa,
  circIn: ei,
  circInOut: Eo,
  circOut: Ao,
  backIn: ti,
  backInOut: bo,
  backOut: So,
  anticipate: Po
}, Ha = (t) => typeof t == "string", Li = (t) => {
  if (Mo(t)) {
    ft(t.length === 4, "Cubic bezier arrays must contain four numerical values.", "cubic-bezier-length");
    const [e, n, i, s] = t;
    return pe(e, n, i, s);
  } else if (Ha(t))
    return ft(Ri[t] !== void 0, `Invalid easing type '${t}'`, "invalid-easing-type"), Ri[t];
  return t;
}, xe = [
  "setup",
  // Compute
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "preUpdate",
  // Compute
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
];
function $a(t, e) {
  let n = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set(), s = !1, r = !1;
  const o = /* @__PURE__ */ new WeakSet();
  let a = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function l(c) {
    o.has(c) && (u.schedule(c), t()), c(a);
  }
  const u = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (c, h = !1, f = !1) => {
      const m = f && s ? n : i;
      return h && o.add(c), m.add(c), c;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (c) => {
      i.delete(c), o.delete(c);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (c) => {
      if (a = c, s) {
        r = !0;
        return;
      }
      s = !0;
      const h = n;
      n = i, i = h, n.forEach(l), n.clear(), s = !1, r && (r = !1, u.process(c));
    }
  };
  return u;
}
const Ua = 40;
function Ro(t, e) {
  let n = !1, i = !0;
  const s = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, r = () => n = !0, o = xe.reduce((T, x) => (T[x] = $a(r), T), {}), { setup: a, read: l, resolveKeyframes: u, preUpdate: c, update: h, preRender: f, render: d, postRender: m } = o, y = () => {
    const T = Pt.useManualTiming, x = T ? s.timestamp : performance.now();
    n = !1, T || (s.delta = i ? 1e3 / 60 : Math.max(Math.min(x - s.timestamp, Ua), 1)), s.timestamp = x, s.isProcessing = !0, a.process(s), l.process(s), u.process(s), c.process(s), h.process(s), f.process(s), d.process(s), m.process(s), s.isProcessing = !1, n && e && (i = !1, t(y));
  }, p = () => {
    n = !0, i = !0, s.isProcessing || t(y);
  };
  return { schedule: xe.reduce((T, x) => {
    const S = o[x];
    return T[x] = (E, V = !1, P = !1) => (n || p(), S.schedule(E, V, P)), T;
  }, {}), cancel: (T) => {
    for (let x = 0; x < xe.length; x++)
      o[xe[x]].cancel(T);
  }, state: s, steps: o };
}
const { schedule: B, cancel: Tt, state: Y, steps: sn } = /* @__PURE__ */ Ro(typeof requestAnimationFrame < "u" ? requestAnimationFrame : rt, !0);
let Ce;
function _a() {
  Ce = void 0;
}
const J = {
  now: () => (Ce === void 0 && J.set(Y.isProcessing || Pt.useManualTiming ? Y.timestamp : performance.now()), Ce),
  set: (t) => {
    Ce = t, queueMicrotask(_a);
  }
}, Lo = (t) => (e) => typeof e == "string" && e.startsWith(t), ko = /* @__PURE__ */ Lo("--"), Ka = /* @__PURE__ */ Lo("var(--"), ni = (t) => Ka(t) ? za.test(t.split("/*")[0].trim()) : !1, za = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;
function ki(t) {
  return typeof t != "string" ? !1 : t.split("/*")[0].includes("var(--");
}
const Gt = {
  test: (t) => typeof t == "number",
  parse: parseFloat,
  transform: (t) => t
}, re = {
  ...Gt,
  transform: (t) => gt(0, 1, t)
}, we = {
  ...Gt,
  default: 1
}, ee = (t) => Math.round(t * 1e5) / 1e5, ii = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function Ga(t) {
  return t == null;
}
const Ya = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, si = (t, e) => (n) => !!(typeof n == "string" && Ya.test(n) && n.startsWith(t) || e && !Ga(n) && Object.prototype.hasOwnProperty.call(n, e)), Io = (t, e, n) => (i) => {
  if (typeof i != "string")
    return i;
  const [s, r, o, a] = i.match(ii);
  return {
    [t]: parseFloat(s),
    [e]: parseFloat(r),
    [n]: parseFloat(o),
    alpha: a !== void 0 ? parseFloat(a) : 1
  };
}, Xa = (t) => gt(0, 255, t), on = {
  ...Gt,
  transform: (t) => Math.round(Xa(t))
}, Lt = {
  test: /* @__PURE__ */ si("rgb", "red"),
  parse: /* @__PURE__ */ Io("red", "green", "blue"),
  transform: ({ red: t, green: e, blue: n, alpha: i = 1 }) => "rgba(" + on.transform(t) + ", " + on.transform(e) + ", " + on.transform(n) + ", " + ee(re.transform(i)) + ")"
};
function qa(t) {
  let e = "", n = "", i = "", s = "";
  return t.length > 5 ? (e = t.substring(1, 3), n = t.substring(3, 5), i = t.substring(5, 7), s = t.substring(7, 9)) : (e = t.substring(1, 2), n = t.substring(2, 3), i = t.substring(3, 4), s = t.substring(4, 5), e += e, n += n, i += i, s += s), {
    red: parseInt(e, 16),
    green: parseInt(n, 16),
    blue: parseInt(i, 16),
    alpha: s ? parseInt(s, 16) / 255 : 1
  };
}
const bn = {
  test: /* @__PURE__ */ si("#"),
  parse: qa,
  transform: Lt.transform
}, ge = /* @__NO_SIDE_EFFECTS__ */ (t) => ({
  test: (e) => typeof e == "string" && e.endsWith(t) && e.split(" ").length === 1,
  parse: parseFloat,
  transform: (e) => `${e}${t}`
}), xt = /* @__PURE__ */ ge("deg"), pt = /* @__PURE__ */ ge("%"), b = /* @__PURE__ */ ge("px"), Za = /* @__PURE__ */ ge("vh"), Ja = /* @__PURE__ */ ge("vw"), Ii = {
  ...pt,
  parse: (t) => pt.parse(t) / 100,
  transform: (t) => pt.transform(t * 100)
}, jt = {
  test: /* @__PURE__ */ si("hsl", "hue"),
  parse: /* @__PURE__ */ Io("hue", "saturation", "lightness"),
  transform: ({ hue: t, saturation: e, lightness: n, alpha: i = 1 }) => "hsla(" + Math.round(t) + ", " + pt.transform(ee(e)) + ", " + pt.transform(ee(n)) + ", " + ee(re.transform(i)) + ")"
}, $ = {
  test: (t) => Lt.test(t) || bn.test(t) || jt.test(t),
  parse: (t) => Lt.test(t) ? Lt.parse(t) : jt.test(t) ? jt.parse(t) : bn.parse(t),
  transform: (t) => typeof t == "string" ? t : t.hasOwnProperty("red") ? Lt.transform(t) : jt.transform(t),
  getAnimatableNone: (t) => {
    const e = $.parse(t);
    return e.alpha = 0, $.transform(e);
  }
}, Qa = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function tl(t) {
  var e, n;
  return isNaN(t) && typeof t == "string" && (((e = t.match(ii)) == null ? void 0 : e.length) || 0) + (((n = t.match(Qa)) == null ? void 0 : n.length) || 0) > 0;
}
const Bo = "number", Fo = "color", el = "var", nl = "var(", Bi = "${}", il = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function Kt(t) {
  const e = t.toString(), n = [], i = {
    color: [],
    number: [],
    var: []
  }, s = [];
  let r = 0;
  const a = e.replace(il, (l) => ($.test(l) ? (i.color.push(r), s.push(Fo), n.push($.parse(l))) : l.startsWith(nl) ? (i.var.push(r), s.push(el), n.push(l)) : (i.number.push(r), s.push(Bo), n.push(parseFloat(l))), ++r, Bi)).split(Bi);
  return { values: n, split: a, indexes: i, types: s };
}
function sl(t) {
  return Kt(t).values;
}
function Oo({ split: t, types: e }) {
  const n = t.length;
  return (i) => {
    let s = "";
    for (let r = 0; r < n; r++)
      if (s += t[r], i[r] !== void 0) {
        const o = e[r];
        o === Bo ? s += ee(i[r]) : o === Fo ? s += $.transform(i[r]) : s += i[r];
      }
    return s;
  };
}
function ol(t) {
  return Oo(Kt(t));
}
const rl = (t) => typeof t == "number" ? 0 : $.test(t) ? $.getAnimatableNone(t) : t, al = (t, e) => typeof t == "number" ? e != null && e.trim().endsWith("/") ? t : 0 : rl(t);
function ll(t) {
  const e = Kt(t);
  return Oo(e)(e.values.map((i, s) => al(i, e.split[s])));
}
const ut = {
  test: tl,
  parse: sl,
  createTransformer: ol,
  getAnimatableNone: ll
};
function rn(t, e, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + (e - t) * 6 * n : n < 1 / 2 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t;
}
function cl({ hue: t, saturation: e, lightness: n, alpha: i }) {
  t /= 360, e /= 100, n /= 100;
  let s = 0, r = 0, o = 0;
  if (!e)
    s = r = o = n;
  else {
    const a = n < 0.5 ? n * (1 + e) : n + e - n * e, l = 2 * n - a;
    s = rn(l, a, t + 1 / 3), r = rn(l, a, t), o = rn(l, a, t - 1 / 3);
  }
  return {
    red: Math.round(s * 255),
    green: Math.round(r * 255),
    blue: Math.round(o * 255),
    alpha: i
  };
}
function Fe(t, e) {
  return (n) => n > 0 ? e : t;
}
const F = (t, e, n) => t + (e - t) * n, an = (t, e, n) => {
  const i = t * t, s = n * (e * e - i) + i;
  return s < 0 ? 0 : Math.sqrt(s);
}, ul = [bn, Lt, jt], hl = (t) => ul.find((e) => e.test(t));
function Fi(t) {
  const e = hl(t);
  if (zt(!!e, `'${t}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable"), !e)
    return !1;
  let n = e.parse(t);
  return e === jt && (n = cl(n)), n;
}
const Oi = (t, e) => {
  const n = Fi(t), i = Fi(e);
  if (!n || !i)
    return Fe(t, e);
  const s = { ...n };
  return (r) => (s.red = an(n.red, i.red, r), s.green = an(n.green, i.green, r), s.blue = an(n.blue, i.blue, r), s.alpha = F(n.alpha, i.alpha, r), Lt.transform(s));
}, Pn = /* @__PURE__ */ new Set(["none", "hidden"]);
function fl(t, e) {
  return Pn.has(t) ? (n) => n <= 0 ? t : e : (n) => n >= 1 ? e : t;
}
function dl(t, e) {
  return (n) => F(t, e, n);
}
function oi(t) {
  return typeof t == "number" ? dl : typeof t == "string" ? ni(t) ? Fe : $.test(t) ? Oi : gl : Array.isArray(t) ? No : typeof t == "object" ? $.test(t) ? Oi : ml : Fe;
}
function No(t, e) {
  const n = [...t], i = n.length, s = t.map((r, o) => oi(r)(r, e[o]));
  return (r) => {
    for (let o = 0; o < i; o++)
      n[o] = s[o](r);
    return n;
  };
}
function ml(t, e) {
  const n = { ...t, ...e }, i = {};
  for (const s in n)
    t[s] !== void 0 && e[s] !== void 0 && (i[s] = oi(t[s])(t[s], e[s]));
  return (s) => {
    for (const r in i)
      n[r] = i[r](s);
    return n;
  };
}
function pl(t, e) {
  const n = [], i = { color: 0, var: 0, number: 0 };
  for (let s = 0; s < e.values.length; s++) {
    const r = e.types[s], o = t.indexes[r][i[r]], a = t.values[o] ?? 0;
    n[s] = a, i[r]++;
  }
  return n;
}
const gl = (t, e) => {
  const n = ut.createTransformer(e), i = Kt(t), s = Kt(e);
  return i.indexes.var.length === s.indexes.var.length && i.indexes.color.length === s.indexes.color.length && i.indexes.number.length >= s.indexes.number.length ? Pn.has(t) && !s.values.length || Pn.has(e) && !i.values.length ? fl(t, e) : me(No(pl(i, s), s.values), n) : (zt(!0, `Complex values '${t}' and '${e}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different"), Fe(t, e));
};
function jo(t, e, n) {
  return typeof t == "number" && typeof e == "number" && typeof n == "number" ? F(t, e, n) : oi(t)(t, e);
}
const yl = (t) => {
  const e = ({ timestamp: n }) => t(n);
  return {
    start: (n = !0) => B.update(e, n),
    stop: () => Tt(e),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => Y.isProcessing ? Y.timestamp : J.now()
  };
}, Wo = (t, e, n = 10) => {
  let i = "";
  const s = Math.max(Math.round(e / n), 2);
  for (let r = 0; r < s; r++)
    i += Math.round(t(r / (s - 1)) * 1e4) / 1e4 + ", ";
  return `linear(${i.substring(0, i.length - 2)})`;
}, Oe = 2e4;
function ri(t) {
  let e = 0;
  const n = 50;
  let i = t.next(e);
  for (; !i.done && e < Oe; )
    e += n, i = t.next(e);
  return e >= Oe ? 1 / 0 : e;
}
function Ho(t, e = 100, n) {
  const i = n({ ...t, keyframes: [0, e] }), s = Math.min(ri(i), Oe);
  return {
    type: "keyframes",
    ease: (r) => i.next(s * r).value / e,
    duration: /* @__PURE__ */ ot(s)
  };
}
const O = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
};
function An(t, e) {
  return t * Math.sqrt(1 - e * e);
}
const vl = 12;
function Tl(t, e, n) {
  let i = n;
  for (let s = 1; s < vl; s++)
    i = i - t(i) / e(i);
  return i;
}
const ln = 1e-3;
function xl({ duration: t = O.duration, bounce: e = O.bounce, velocity: n = O.velocity, mass: i = O.mass }) {
  let s, r;
  zt(t <= /* @__PURE__ */ tt(O.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
  let o = 1 - e;
  o = gt(O.minDamping, O.maxDamping, o), t = gt(O.minDuration, O.maxDuration, /* @__PURE__ */ ot(t)), o < 1 ? (s = (u) => {
    const c = u * o, h = c * t, f = c - n, d = An(u, o), m = Math.exp(-h);
    return ln - f / d * m;
  }, r = (u) => {
    const h = u * o * t, f = h * n + n, d = Math.pow(o, 2) * Math.pow(u, 2) * t, m = Math.exp(-h), y = An(Math.pow(u, 2), o);
    return (-s(u) + ln > 0 ? -1 : 1) * ((f - d) * m) / y;
  }) : (s = (u) => {
    const c = Math.exp(-u * t), h = (u - n) * t + 1;
    return -ln + c * h;
  }, r = (u) => {
    const c = Math.exp(-u * t), h = (n - u) * (t * t);
    return c * h;
  });
  const a = 5 / t, l = Tl(s, r, a);
  if (t = /* @__PURE__ */ tt(t), isNaN(l))
    return {
      stiffness: O.stiffness,
      damping: O.damping,
      duration: t
    };
  {
    const u = Math.pow(l, 2) * i;
    return {
      stiffness: u,
      damping: o * 2 * Math.sqrt(i * u),
      duration: t
    };
  }
}
const wl = ["duration", "bounce"], Sl = ["stiffness", "damping", "mass"];
function Ni(t, e) {
  return e.some((n) => t[n] !== void 0);
}
function bl(t) {
  let e = {
    velocity: O.velocity,
    stiffness: O.stiffness,
    damping: O.damping,
    mass: O.mass,
    isResolvedFromDuration: !1,
    ...t
  };
  if (!Ni(t, Sl) && Ni(t, wl))
    if (e.velocity = 0, t.visualDuration) {
      const n = t.visualDuration, i = 2 * Math.PI / (n * 1.2), s = i * i, r = 2 * gt(0.05, 1, 1 - (t.bounce || 0)) * Math.sqrt(s);
      e = {
        ...e,
        mass: O.mass,
        stiffness: s,
        damping: r
      };
    } else {
      const n = xl({ ...t, velocity: 0 });
      e = {
        ...e,
        ...n,
        mass: O.mass
      }, e.isResolvedFromDuration = !0;
    }
  return e;
}
function ae(t = O.visualDuration, e = O.bounce) {
  const n = typeof t != "object" ? {
    visualDuration: t,
    keyframes: [0, 1],
    bounce: e
  } : t;
  let { restSpeed: i, restDelta: s } = n;
  const r = n.keyframes[0], o = n.keyframes[n.keyframes.length - 1], a = { done: !1, value: r }, { stiffness: l, damping: u, mass: c, duration: h, velocity: f, isResolvedFromDuration: d } = bl({
    ...n,
    velocity: -/* @__PURE__ */ ot(n.velocity || 0)
  }), m = f || 0, y = u / (2 * Math.sqrt(l * c)), p = o - r, g = /* @__PURE__ */ ot(Math.sqrt(l / c)), v = Math.abs(p) < 5;
  i || (i = v ? O.restSpeed.granular : O.restSpeed.default), s || (s = v ? O.restDelta.granular : O.restDelta.default);
  let T, x, S, E, V, P;
  if (y < 1)
    S = An(g, y), E = (m + y * g * p) / S, T = (w) => {
      const C = Math.exp(-y * g * w);
      return o - C * (E * Math.sin(S * w) + p * Math.cos(S * w));
    }, V = y * g * E + p * S, P = y * g * p - E * S, x = (w) => Math.exp(-y * g * w) * (V * Math.sin(S * w) + P * Math.cos(S * w));
  else if (y === 1) {
    T = (C) => o - Math.exp(-g * C) * (p + (m + g * p) * C);
    const w = m + g * p;
    x = (C) => Math.exp(-g * C) * (g * w * C - m);
  } else {
    const w = g * Math.sqrt(y * y - 1);
    T = (X) => {
      const q = Math.exp(-y * g * X), R = Math.min(w * X, 300);
      return o - q * ((m + y * g * p) * Math.sinh(R) + w * p * Math.cosh(R)) / w;
    };
    const C = (m + y * g * p) / w, D = y * g * C - p * w, W = y * g * p - C * w;
    x = (X) => {
      const q = Math.exp(-y * g * X), R = Math.min(w * X, 300);
      return q * (D * Math.sinh(R) + W * Math.cosh(R));
    };
  }
  const A = {
    calculatedDuration: d && h || null,
    velocity: (w) => /* @__PURE__ */ tt(x(w)),
    next: (w) => {
      if (!d && y < 1) {
        const D = Math.exp(-y * g * w), W = Math.sin(S * w), X = Math.cos(S * w), q = o - D * (E * W + p * X), R = /* @__PURE__ */ tt(D * (V * W + P * X));
        return a.done = Math.abs(R) <= i && Math.abs(o - q) <= s, a.value = a.done ? o : q, a;
      }
      const C = T(w);
      if (d)
        a.done = w >= h;
      else {
        const D = /* @__PURE__ */ tt(x(w));
        a.done = Math.abs(D) <= i && Math.abs(o - C) <= s;
      }
      return a.value = a.done ? o : C, a;
    },
    toString: () => {
      const w = Math.min(ri(A), Oe), C = Wo((D) => A.next(w * D).value, w, 30);
      return w + "ms " + C;
    },
    toTransition: () => {
    }
  };
  return A;
}
ae.applyToOptions = (t) => {
  const e = Ho(t, 100, ae);
  return t.ease = e.ease, t.duration = /* @__PURE__ */ tt(e.duration), t.type = "keyframes", t;
};
const Pl = 5;
function $o(t, e, n) {
  const i = Math.max(e - Pl, 0);
  return vo(n - t(i), e - i);
}
function En({ keyframes: t, velocity: e = 0, power: n = 0.8, timeConstant: i = 325, bounceDamping: s = 10, bounceStiffness: r = 500, modifyTarget: o, min: a, max: l, restDelta: u = 0.5, restSpeed: c }) {
  const h = t[0], f = {
    done: !1,
    value: h
  }, d = (P) => a !== void 0 && P < a || l !== void 0 && P > l, m = (P) => a === void 0 ? l : l === void 0 || Math.abs(a - P) < Math.abs(l - P) ? a : l;
  let y = n * e;
  const p = h + y, g = o === void 0 ? p : o(p);
  g !== p && (y = g - h);
  const v = (P) => -y * Math.exp(-P / i), T = (P) => g + v(P), x = (P) => {
    const A = v(P), w = T(P);
    f.done = Math.abs(A) <= u, f.value = f.done ? g : w;
  };
  let S, E;
  const V = (P) => {
    d(f.value) && (S = P, E = ae({
      keyframes: [f.value, m(f.value)],
      velocity: $o(T, P, f.value),
      // TODO: This should be passing * 1000
      damping: s,
      stiffness: r,
      restDelta: u,
      restSpeed: c
    }));
  };
  return V(0), {
    calculatedDuration: null,
    next: (P) => {
      let A = !1;
      return !E && S === void 0 && (A = !0, x(P), V(P)), S !== void 0 && P >= S ? E.next(P - S) : (!A && x(P), f);
    }
  };
}
function Al(t, e, n) {
  const i = [], s = n || Pt.mix || jo, r = t.length - 1;
  for (let o = 0; o < r; o++) {
    let a = s(t[o], t[o + 1]);
    if (e) {
      const l = Array.isArray(e) ? e[o] || rt : e;
      a = me(l, a);
    }
    i.push(a);
  }
  return i;
}
function Uo(t, e, { clamp: n = !0, ease: i, mixer: s } = {}) {
  const r = t.length;
  if (ft(r === e.length, "Both input and output ranges must be the same length", "range-length"), r === 1)
    return () => e[0];
  if (r === 2 && e[0] === e[1])
    return () => e[1];
  const o = t[0] === t[1];
  t[0] > t[r - 1] && (t = [...t].reverse(), e = [...e].reverse());
  const a = Al(e, i, s), l = a.length, u = (c) => {
    if (o && c < t[0])
      return e[0];
    let h = 0;
    if (l > 1)
      for (; h < t.length - 2 && !(c < t[h + 1]); h++)
        ;
    const f = /* @__PURE__ */ _t(t[h], t[h + 1], c);
    return a[h](f);
  };
  return n ? (c) => u(gt(t[0], t[r - 1], c)) : u;
}
function _o(t, e) {
  const n = t[t.length - 1];
  for (let i = 1; i <= e; i++) {
    const s = /* @__PURE__ */ _t(0, e, i);
    t.push(F(n, 1, s));
  }
}
function Ko(t) {
  const e = [0];
  return _o(e, t.length - 1), e;
}
function El(t, e) {
  return t.map((n) => n * e);
}
function Cl(t, e) {
  return t.map(() => e || Co).splice(0, t.length - 1);
}
function Wt({ duration: t = 300, keyframes: e, times: n, ease: i = "easeInOut" }) {
  const s = Vo(i) ? i.map(Li) : Li(i), r = {
    done: !1,
    value: e[0]
  }, o = El(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === e.length ? n : Ko(e),
    t
  ), a = Uo(o, e, {
    ease: Array.isArray(s) ? s : Cl(e, s)
  });
  return {
    calculatedDuration: t,
    next: (l) => (r.value = a(l), r.done = l >= t, r)
  };
}
const Vl = (t) => t !== null;
function Ye(t, { repeat: e, repeatType: n = "loop" }, i, s = 1) {
  const r = t.filter(Vl), a = s < 0 || e && n !== "loop" && e % 2 === 1 ? 0 : r.length - 1;
  return !a || i === void 0 ? r[a] : i;
}
const Dl = {
  decay: En,
  inertia: En,
  tween: Wt,
  keyframes: Wt,
  spring: ae
};
function zo(t) {
  typeof t.type == "string" && (t.type = Dl[t.type]);
}
class ai {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((e) => {
      this.resolve = e;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(e, n) {
    return this.finished.then(e, n);
  }
}
const Ml = (t) => t / 100;
class Ne extends ai {
  constructor(e) {
    super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.delayState = {
      done: !1,
      value: void 0
    }, this.stop = () => {
      var i, s;
      const { motionValue: n } = this.options;
      n && n.updatedAt !== J.now() && this.tick(J.now()), this.isStopped = !0, this.state !== "idle" && (this.teardown(), (s = (i = this.options).onStop) == null || s.call(i));
    }, this.options = e, this.initAnimation(), this.play(), e.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const { options: e } = this;
    zo(e);
    const { type: n = Wt, repeat: i = 0, repeatDelay: s = 0, repeatType: r, velocity: o = 0 } = e;
    let { keyframes: a } = e;
    const l = n || Wt;
    process.env.NODE_ENV !== "production" && l !== Wt && ft(a.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${a}`, "spring-two-frames"), l !== Wt && typeof a[0] != "number" && (this.mixKeyframes = me(Ml, jo(a[0], a[1])), a = [0, 100]);
    const u = l({ ...e, keyframes: a });
    r === "mirror" && (this.mirroredGenerator = l({
      ...e,
      keyframes: [...a].reverse(),
      velocity: -o
    })), u.calculatedDuration === null && (u.calculatedDuration = ri(u));
    const { calculatedDuration: c } = u;
    this.calculatedDuration = c, this.resolvedDuration = c + s, this.totalDuration = this.resolvedDuration * (i + 1) - s, this.generator = u;
  }
  updateTime(e) {
    const n = Math.round(e - this.startTime) * this.playbackSpeed;
    this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = n;
  }
  tick(e, n = !1) {
    const { generator: i, totalDuration: s, mixKeyframes: r, mirroredGenerator: o, resolvedDuration: a, calculatedDuration: l } = this;
    if (this.startTime === null)
      return i.next(0);
    const { delay: u = 0, keyframes: c, repeat: h, repeatType: f, repeatDelay: d, type: m, onUpdate: y, finalKeyframe: p } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, e) : this.speed < 0 && (this.startTime = Math.min(e - s / this.speed, this.startTime)), n ? this.currentTime = e : this.updateTime(e);
    const g = this.currentTime - u * (this.playbackSpeed >= 0 ? 1 : -1), v = this.playbackSpeed >= 0 ? g < 0 : g > s;
    this.currentTime = Math.max(g, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = s);
    let T = this.currentTime, x = i;
    if (h) {
      const P = Math.min(this.currentTime, s) / a;
      let A = Math.floor(P), w = P % 1;
      !w && P >= 1 && (w = 1), w === 1 && A--, A = Math.min(A, h + 1), !!(A % 2) && (f === "reverse" ? (w = 1 - w, d && (w -= d / a)) : f === "mirror" && (x = o)), T = gt(0, 1, w) * a;
    }
    let S;
    v ? (this.delayState.value = c[0], S = this.delayState) : S = x.next(T), r && !v && (S.value = r(S.value));
    let { done: E } = S;
    !v && l !== null && (E = this.playbackSpeed >= 0 ? this.currentTime >= s : this.currentTime <= 0);
    const V = this.holdTime === null && (this.state === "finished" || this.state === "running" && E);
    return V && m !== En && (S.value = Ye(c, this.options, p, this.speed)), y && y(S.value), V && this.finish(), S;
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(e, n) {
    return this.finished.then(e, n);
  }
  get duration() {
    return /* @__PURE__ */ ot(this.calculatedDuration);
  }
  get iterationDuration() {
    const { delay: e = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ ot(e);
  }
  get time() {
    return /* @__PURE__ */ ot(this.currentTime);
  }
  set time(e) {
    e = /* @__PURE__ */ tt(e), this.currentTime = e, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = e : this.driver && (this.startTime = this.driver.now() - e / this.playbackSpeed), this.driver ? this.driver.start(!1) : (this.startTime = 0, this.state = "paused", this.holdTime = e, this.tick(e));
  }
  /**
   * Returns the generator's velocity at the current time in units/second.
   * Uses the analytical derivative when available (springs), avoiding
   * the MotionValue's frame-dependent velocity estimation.
   */
  getGeneratorVelocity() {
    const e = this.currentTime;
    if (e <= 0)
      return this.options.velocity || 0;
    if (this.generator.velocity)
      return this.generator.velocity(e);
    const n = this.generator.next(e).value;
    return $o((i) => this.generator.next(i).value, e, n);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(e) {
    const n = this.playbackSpeed !== e;
    n && this.driver && this.updateTime(J.now()), this.playbackSpeed = e, n && this.driver && (this.time = /* @__PURE__ */ ot(this.currentTime));
  }
  play() {
    var s, r;
    if (this.isStopped)
      return;
    const { driver: e = yl, startTime: n } = this.options;
    this.driver || (this.driver = e((o) => this.tick(o))), (r = (s = this.options).onPlay) == null || r.call(s);
    const i = this.driver.now();
    this.state === "finished" ? (this.updateFinished(), this.startTime = i) : this.holdTime !== null ? this.startTime = i - this.holdTime : this.startTime || (this.startTime = n ?? i), this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    this.state = "paused", this.updateTime(J.now()), this.holdTime = this.currentTime;
  }
  complete() {
    this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
  }
  finish() {
    var e, n;
    this.notifyFinished(), this.teardown(), this.state = "finished", (n = (e = this.options).onComplete) == null || n.call(e);
  }
  cancel() {
    var e, n;
    this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), (n = (e = this.options).onCancel) == null || n.call(e);
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(e) {
    return this.startTime = 0, this.tick(e, !0);
  }
  attachTimeline(e) {
    var n;
    return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), (n = this.driver) == null || n.stop(), e.observe(this);
  }
}
function Rl(t) {
  for (let e = 1; e < t.length; e++)
    t[e] ?? (t[e] = t[e - 1]);
}
const kt = (t) => t * 180 / Math.PI, Cn = (t) => {
  const e = kt(Math.atan2(t[1], t[0]));
  return Vn(e);
}, Ll = {
  x: 4,
  y: 5,
  translateX: 4,
  translateY: 5,
  scaleX: 0,
  scaleY: 3,
  scale: (t) => (Math.abs(t[0]) + Math.abs(t[3])) / 2,
  rotate: Cn,
  rotateZ: Cn,
  skewX: (t) => kt(Math.atan(t[1])),
  skewY: (t) => kt(Math.atan(t[2])),
  skew: (t) => (Math.abs(t[1]) + Math.abs(t[2])) / 2
}, Vn = (t) => (t = t % 360, t < 0 && (t += 360), t), ji = Cn, Wi = (t) => Math.sqrt(t[0] * t[0] + t[1] * t[1]), Hi = (t) => Math.sqrt(t[4] * t[4] + t[5] * t[5]), kl = {
  x: 12,
  y: 13,
  z: 14,
  translateX: 12,
  translateY: 13,
  translateZ: 14,
  scaleX: Wi,
  scaleY: Hi,
  scale: (t) => (Wi(t) + Hi(t)) / 2,
  rotateX: (t) => Vn(kt(Math.atan2(t[6], t[5]))),
  rotateY: (t) => Vn(kt(Math.atan2(-t[2], t[0]))),
  rotateZ: ji,
  rotate: ji,
  skewX: (t) => kt(Math.atan(t[4])),
  skewY: (t) => kt(Math.atan(t[1])),
  skew: (t) => (Math.abs(t[1]) + Math.abs(t[4])) / 2
};
function Dn(t) {
  return t.includes("scale") ? 1 : 0;
}
function Mn(t, e) {
  if (!t || t === "none")
    return Dn(e);
  const n = t.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let i, s;
  if (n)
    i = kl, s = n;
  else {
    const a = t.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    i = Ll, s = a;
  }
  if (!s)
    return Dn(e);
  const r = i[e], o = s[1].split(",").map(Bl);
  return typeof r == "function" ? r(o) : o[r];
}
const Il = (t, e) => {
  const { transform: n = "none" } = getComputedStyle(t);
  return Mn(n, e);
};
function Bl(t) {
  return parseFloat(t.trim());
}
const Yt = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], Xt = new Set(Yt), $i = (t) => t === Gt || t === b, Fl = /* @__PURE__ */ new Set(["x", "y", "z"]), Ol = Yt.filter((t) => !Fl.has(t));
function Nl(t) {
  const e = [];
  return Ol.forEach((n) => {
    const i = t.getValue(n);
    i !== void 0 && (e.push([n, i.get()]), i.set(n.startsWith("scale") ? 1 : 0));
  }), e;
}
const St = {
  // Dimensions
  width: ({ x: t }, { paddingLeft: e = "0", paddingRight: n = "0", boxSizing: i }) => {
    const s = t.max - t.min;
    return i === "border-box" ? s : s - parseFloat(e) - parseFloat(n);
  },
  height: ({ y: t }, { paddingTop: e = "0", paddingBottom: n = "0", boxSizing: i }) => {
    const s = t.max - t.min;
    return i === "border-box" ? s : s - parseFloat(e) - parseFloat(n);
  },
  top: (t, { top: e }) => parseFloat(e),
  left: (t, { left: e }) => parseFloat(e),
  bottom: ({ y: t }, { top: e }) => parseFloat(e) + (t.max - t.min),
  right: ({ x: t }, { left: e }) => parseFloat(e) + (t.max - t.min),
  // Transform
  x: (t, { transform: e }) => Mn(e, "x"),
  y: (t, { transform: e }) => Mn(e, "y")
};
St.translateX = St.x;
St.translateY = St.y;
const It = /* @__PURE__ */ new Set();
let Rn = !1, Ln = !1, kn = !1;
function Go() {
  if (Ln) {
    const t = Array.from(It).filter((i) => i.needsMeasurement), e = new Set(t.map((i) => i.element)), n = /* @__PURE__ */ new Map();
    e.forEach((i) => {
      const s = Nl(i);
      s.length && (n.set(i, s), i.render());
    }), t.forEach((i) => i.measureInitialState()), e.forEach((i) => {
      i.render();
      const s = n.get(i);
      s && s.forEach(([r, o]) => {
        var a;
        (a = i.getValue(r)) == null || a.set(o);
      });
    }), t.forEach((i) => i.measureEndState()), t.forEach((i) => {
      i.suspendedScrollY !== void 0 && window.scrollTo(0, i.suspendedScrollY);
    });
  }
  Ln = !1, Rn = !1, It.forEach((t) => t.complete(kn)), It.clear();
}
function Yo() {
  It.forEach((t) => {
    t.readKeyframes(), t.needsMeasurement && (Ln = !0);
  });
}
function jl() {
  kn = !0, Yo(), Go(), kn = !1;
}
class li {
  constructor(e, n, i, s, r, o = !1) {
    this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...e], this.onComplete = n, this.name = i, this.motionValue = s, this.element = r, this.isAsync = o;
  }
  scheduleResolve() {
    this.state = "scheduled", this.isAsync ? (It.add(this), Rn || (Rn = !0, B.read(Yo), B.resolveKeyframes(Go))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, name: n, element: i, motionValue: s } = this;
    if (e[0] === null) {
      const r = s == null ? void 0 : s.get(), o = e[e.length - 1];
      if (r !== void 0)
        e[0] = r;
      else if (i && n) {
        const a = i.readValue(n, o);
        a != null && (e[0] = a);
      }
      e[0] === void 0 && (e[0] = o), s && r === void 0 && s.set(e[0]);
    }
    Rl(e);
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete(e = !1) {
    this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, e), It.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (It.delete(this), this.state = "pending");
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const Wl = (t) => t.startsWith("--");
function Xo(t, e, n) {
  Wl(e) ? t.style.setProperty(e, n) : t.style[e] = n;
}
const Hl = {};
function qo(t, e) {
  const n = /* @__PURE__ */ yo(t);
  return () => Hl[e] ?? n();
}
const $l = /* @__PURE__ */ qo(() => window.ScrollTimeline !== void 0, "scrollTimeline"), Zo = /* @__PURE__ */ qo(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), te = ([t, e, n, i]) => `cubic-bezier(${t}, ${e}, ${n}, ${i})`, Ui = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ te([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ te([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ te([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ te([0.33, 1.53, 0.69, 0.99])
};
function Jo(t, e) {
  if (t)
    return typeof t == "function" ? Zo() ? Wo(t, e) : "ease-out" : Mo(t) ? te(t) : Array.isArray(t) ? t.map((n) => Jo(n, e) || Ui.easeOut) : Ui[t];
}
function Ul(t, e, n, { delay: i = 0, duration: s = 300, repeat: r = 0, repeatType: o = "loop", ease: a = "easeOut", times: l } = {}, u = void 0) {
  const c = {
    [e]: n
  };
  l && (c.offset = l);
  const h = Jo(a, s);
  Array.isArray(h) && (c.easing = h);
  const f = {
    delay: i,
    duration: s,
    easing: Array.isArray(h) ? "linear" : h,
    fill: "both",
    iterations: r + 1,
    direction: o === "reverse" ? "alternate" : "normal"
  };
  return u && (f.pseudoElement = u), t.animate(c, f);
}
function ci(t) {
  return typeof t == "function" && "applyToOptions" in t;
}
function _l({ type: t, ...e }) {
  return ci(t) && Zo() ? t.applyToOptions(e) : (e.duration ?? (e.duration = 300), e.ease ?? (e.ease = "easeOut"), e);
}
class Qo extends ai {
  constructor(e) {
    if (super(), this.finishedTime = null, this.isStopped = !1, this.manualStartTime = null, !e)
      return;
    const { element: n, name: i, keyframes: s, pseudoElement: r, allowFlatten: o = !1, finalKeyframe: a, onComplete: l } = e;
    this.isPseudoElement = !!r, this.allowFlatten = o, this.options = e, ft(typeof e.type != "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
    const u = _l(e);
    this.animation = Ul(n, i, s, u, r), u.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
      if (this.finishedTime = this.time, !r) {
        const c = Ye(s, this.options, a, this.speed);
        this.updateMotionValue && this.updateMotionValue(c), Xo(n, i, c), this.animation.cancel();
      }
      l == null || l(), this.notifyFinished();
    };
  }
  play() {
    this.isStopped || (this.manualStartTime = null, this.animation.play(), this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    var e, n;
    (n = (e = this.animation).finish) == null || n.call(e);
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {
    }
  }
  stop() {
    if (this.isStopped)
      return;
    this.isStopped = !0;
    const { state: e } = this;
    e === "idle" || e === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    var n, i, s;
    const e = (n = this.options) == null ? void 0 : n.element;
    !this.isPseudoElement && (e != null && e.isConnected) && ((s = (i = this.animation).commitStyles) == null || s.call(i));
  }
  get duration() {
    var n, i;
    const e = ((i = (n = this.animation.effect) == null ? void 0 : n.getComputedTiming) == null ? void 0 : i.call(n).duration) || 0;
    return /* @__PURE__ */ ot(Number(e));
  }
  get iterationDuration() {
    const { delay: e = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ ot(e);
  }
  get time() {
    return /* @__PURE__ */ ot(Number(this.animation.currentTime) || 0);
  }
  set time(e) {
    const n = this.finishedTime !== null;
    this.manualStartTime = null, this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */ tt(e), n && this.animation.pause();
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(e) {
    e < 0 && (this.finishedTime = null), this.animation.playbackRate = e;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return this.manualStartTime ?? Number(this.animation.startTime);
  }
  set startTime(e) {
    this.manualStartTime = this.animation.startTime = e;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({ timeline: e, rangeStart: n, rangeEnd: i, observe: s }) {
    var r;
    return this.allowFlatten && ((r = this.animation.effect) == null || r.updateTiming({ easing: "linear" })), this.animation.onfinish = null, e && $l() ? (this.animation.timeline = e, n && (this.animation.rangeStart = n), i && (this.animation.rangeEnd = i), rt) : s(this);
  }
}
const tr = {
  anticipate: Po,
  backInOut: bo,
  circInOut: Eo
};
function Kl(t) {
  return t in tr;
}
function zl(t) {
  typeof t.ease == "string" && Kl(t.ease) && (t.ease = tr[t.ease]);
}
const cn = 10;
class Gl extends Qo {
  constructor(e) {
    zl(e), zo(e), super(e), e.startTime !== void 0 && e.autoplay !== !1 && (this.startTime = e.startTime), this.options = e;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read committed styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */
  updateMotionValue(e) {
    const { motionValue: n, onUpdate: i, onComplete: s, element: r, ...o } = this.options;
    if (!n)
      return;
    if (e !== void 0) {
      n.set(e);
      return;
    }
    const a = new Ne({
      ...o,
      autoplay: !1
    }), l = Math.max(cn, J.now() - this.startTime), u = gt(0, cn, l - cn), c = a.sample(l).value, { name: h } = this.options;
    r && h && Xo(r, h, c), n.setWithVelocity(a.sample(Math.max(0, l - u)).value, c, u), a.stop();
  }
}
const _i = (t, e) => e === "zIndex" ? !1 : !!(typeof t == "number" || Array.isArray(t) || typeof t == "string" && // It's animatable if we have a string
(ut.test(t) || t === "0") && // And it contains numbers and/or colors
!t.startsWith("url("));
function Yl(t) {
  const e = t[0];
  if (t.length === 1)
    return !0;
  for (let n = 0; n < t.length; n++)
    if (t[n] !== e)
      return !0;
}
function Xl(t, e, n, i) {
  const s = t[0];
  if (s === null)
    return !1;
  if (e === "display" || e === "visibility")
    return !0;
  const r = t[t.length - 1], o = _i(s, e), a = _i(r, e);
  return zt(o === a, `You are trying to animate ${e} from "${s}" to "${r}". "${o ? r : s}" is not an animatable value.`, "value-not-animatable"), !o || !a ? !1 : Yl(t) || (n === "spring" || ci(n)) && i;
}
function In(t) {
  t.duration = 0, t.type = "keyframes";
}
const er = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
  // or until we implement support for linear() easing.
  // "background-color"
]), ql = /^(?:oklch|oklab|lab|lch|color|color-mix|light-dark)\(/;
function Zl(t) {
  for (let e = 0; e < t.length; e++)
    if (typeof t[e] == "string" && ql.test(t[e]))
      return !0;
  return !1;
}
const Jl = /* @__PURE__ */ new Set([
  "color",
  "backgroundColor",
  "outlineColor",
  "fill",
  "stroke",
  "borderColor",
  "borderTopColor",
  "borderRightColor",
  "borderBottomColor",
  "borderLeftColor"
]), Ql = /* @__PURE__ */ yo(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function tc(t) {
  var h;
  const { motionValue: e, name: n, repeatDelay: i, repeatType: s, damping: r, type: o, keyframes: a } = t;
  if (!(((h = e == null ? void 0 : e.owner) == null ? void 0 : h.current) instanceof HTMLElement))
    return !1;
  const { onUpdate: u, transformTemplate: c } = e.owner.getProps();
  return Ql() && n && /**
   * Force WAAPI for color properties with browser-only color formats
   * (oklch, oklab, lab, lch, etc.) that the JS animation path can't parse.
   */
  (er.has(n) || Jl.has(n) && Zl(a)) && (n !== "transform" || !c) && /**
   * If we're outputting values to onUpdate then we can't use WAAPI as there's
   * no way to read the value from WAAPI every frame.
   */
  !u && !i && s !== "mirror" && r !== 0 && o !== "inertia";
}
const ec = 40;
class nc extends ai {
  constructor({ autoplay: e = !0, delay: n = 0, type: i = "keyframes", repeat: s = 0, repeatDelay: r = 0, repeatType: o = "loop", keyframes: a, name: l, motionValue: u, element: c, ...h }) {
    var m;
    super(), this.stop = () => {
      var y, p;
      this._animation && (this._animation.stop(), (y = this.stopTimeline) == null || y.call(this)), (p = this.keyframeResolver) == null || p.cancel();
    }, this.createdAt = J.now();
    const f = {
      autoplay: e,
      delay: n,
      type: i,
      repeat: s,
      repeatDelay: r,
      repeatType: o,
      name: l,
      motionValue: u,
      element: c,
      ...h
    }, d = (c == null ? void 0 : c.KeyframeResolver) || li;
    this.keyframeResolver = new d(a, (y, p, g) => this.onKeyframesResolved(y, p, f, !g), l, u, c), (m = this.keyframeResolver) == null || m.scheduleResolve();
  }
  onKeyframesResolved(e, n, i, s) {
    var g, v;
    this.keyframeResolver = void 0;
    const { name: r, type: o, velocity: a, delay: l, isHandoff: u, onUpdate: c } = i;
    this.resolvedAt = J.now();
    let h = !0;
    Xl(e, r, o, a) || (h = !1, (Pt.instantAnimations || !l) && (c == null || c(Ye(e, i, n))), e[0] = e[e.length - 1], In(i), i.repeat = 0);
    const d = {
      startTime: s ? this.resolvedAt ? this.resolvedAt - this.createdAt > ec ? this.resolvedAt : this.createdAt : this.createdAt : void 0,
      finalKeyframe: n,
      ...i,
      keyframes: e
    }, m = h && !u && tc(d), y = (v = (g = d.motionValue) == null ? void 0 : g.owner) == null ? void 0 : v.current;
    let p;
    if (m)
      try {
        p = new Gl({
          ...d,
          element: y
        });
      } catch {
        p = new Ne(d);
      }
    else
      p = new Ne(d);
    p.finished.then(() => {
      this.notifyFinished();
    }).catch(rt), this.pendingTimeline && (this.stopTimeline = p.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = p;
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(e, n) {
    return this.finished.finally(e).then(() => {
    });
  }
  get animation() {
    var e;
    return this._animation || ((e = this.keyframeResolver) == null || e.resume(), jl()), this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get iterationDuration() {
    return this.animation.iterationDuration;
  }
  get time() {
    return this.animation.time;
  }
  set time(e) {
    this.animation.time = e;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(e) {
    this.animation.speed = e;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(e) {
    return this._animation ? this.stopTimeline = this.animation.attachTimeline(e) : this.pendingTimeline = e, () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    var e;
    this._animation && this.animation.cancel(), (e = this.keyframeResolver) == null || e.cancel();
  }
}
class ic {
  constructor(e) {
    this.stop = () => this.runAll("stop"), this.animations = e.filter(Boolean);
  }
  get finished() {
    return Promise.all(this.animations.map((e) => e.finished));
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(e) {
    return this.animations[0][e];
  }
  setAll(e, n) {
    for (let i = 0; i < this.animations.length; i++)
      this.animations[i][e] = n;
  }
  attachTimeline(e) {
    const n = this.animations.map((i) => i.attachTimeline(e));
    return () => {
      n.forEach((i, s) => {
        i && i(), this.animations[s].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(e) {
    this.setAll("time", e);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(e) {
    this.setAll("speed", e);
  }
  get state() {
    return this.getAll("state");
  }
  get startTime() {
    return this.getAll("startTime");
  }
  get duration() {
    return Ki(this.animations, "duration");
  }
  get iterationDuration() {
    return Ki(this.animations, "iterationDuration");
  }
  runAll(e) {
    this.animations.forEach((n) => n[e]());
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
function Ki(t, e) {
  let n = 0;
  for (let i = 0; i < t.length; i++) {
    const s = t[i][e];
    s !== null && s > n && (n = s);
  }
  return n;
}
class sc extends ic {
  then(e, n) {
    return this.finished.finally(e).then(() => {
    });
  }
}
function nr(t, e, n, i = 0, s = 1) {
  const r = Array.from(t).sort((u, c) => u.sortNodePosition(c)).indexOf(e), o = t.size, a = (o - 1) * i;
  return typeof n == "function" ? n(r, o) : s === 1 ? r * i : a - r * i;
}
const oc = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function rc(t) {
  const e = oc.exec(t);
  if (!e)
    return [,];
  const [, n, i, s] = e;
  return [`--${n ?? i}`, s];
}
const ac = 4;
function ir(t, e, n = 1) {
  ft(n <= ac, `Max CSS variable fallback depth detected in property "${t}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
  const [i, s] = rc(t);
  if (!i)
    return;
  const r = window.getComputedStyle(e).getPropertyValue(i);
  if (r) {
    const o = r.trim();
    return mo(o) ? parseFloat(o) : o;
  }
  return ni(s) ? ir(s, e, n + 1) : s;
}
const lc = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, cc = (t) => ({
  type: "spring",
  stiffness: 550,
  damping: t === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), uc = {
  type: "keyframes",
  duration: 0.8
}, hc = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, fc = (t, { keyframes: e }) => e.length > 2 ? uc : Xt.has(t) ? t.startsWith("scale") ? cc(e[1]) : lc : hc;
function sr(t, e) {
  if (t != null && t.inherit && e) {
    const { inherit: n, ...i } = t;
    return { ...e, ...i };
  }
  return t;
}
function ui(t, e) {
  const n = (t == null ? void 0 : t[e]) ?? (t == null ? void 0 : t.default) ?? t;
  return n !== t ? sr(n, t) : n;
}
const dc = /* @__PURE__ */ new Set([
  "when",
  "delay",
  "delayChildren",
  "staggerChildren",
  "staggerDirection",
  "repeat",
  "repeatType",
  "repeatDelay",
  "from",
  "elapsed"
]);
function mc(t) {
  for (const e in t)
    if (!dc.has(e))
      return !0;
  return !1;
}
const hi = (t, e, n, i = {}, s, r) => (o) => {
  const a = ui(i, t) || {}, l = a.delay || i.delay || 0;
  let { elapsed: u = 0 } = i;
  u = u - /* @__PURE__ */ tt(l);
  const c = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: e.getVelocity(),
    ...a,
    delay: -u,
    onUpdate: (f) => {
      e.set(f), a.onUpdate && a.onUpdate(f);
    },
    onComplete: () => {
      o(), a.onComplete && a.onComplete();
    },
    name: t,
    motionValue: e,
    element: r ? void 0 : s
  };
  mc(a) || Object.assign(c, fc(t, c)), c.duration && (c.duration = /* @__PURE__ */ tt(c.duration)), c.repeatDelay && (c.repeatDelay = /* @__PURE__ */ tt(c.repeatDelay)), c.from !== void 0 && (c.keyframes[0] = c.from);
  let h = !1;
  if ((c.type === !1 || c.duration === 0 && !c.repeatDelay) && (In(c), c.delay === 0 && (h = !0)), (Pt.instantAnimations || Pt.skipAnimations || s != null && s.shouldSkipAnimations) && (h = !0, In(c), c.delay = 0), c.allowFlatten = !a.type && !a.ease, h && !r && e.get() !== void 0) {
    const f = Ye(c.keyframes, a);
    if (f !== void 0) {
      B.update(() => {
        c.onUpdate(f), c.onComplete();
      });
      return;
    }
  }
  return a.isSync ? new Ne(c) : new nc(c);
};
function zi(t) {
  const e = [{}, {}];
  return t == null || t.values.forEach((n, i) => {
    e[0][i] = n.get(), e[1][i] = n.getVelocity();
  }), e;
}
function fi(t, e, n, i) {
  if (typeof e == "function") {
    const [s, r] = zi(i);
    e = e(n !== void 0 ? n : t.custom, s, r);
  }
  if (typeof e == "string" && (e = t.variants && t.variants[e]), typeof e == "function") {
    const [s, r] = zi(i);
    e = e(n !== void 0 ? n : t.custom, s, r);
  }
  return e;
}
function Bt(t, e, n) {
  const i = t.getProps();
  return fi(i, e, n !== void 0 ? n : i.custom, t);
}
const or = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...Yt
]), Gi = 30, pc = (t) => !isNaN(parseFloat(t)), ne = {
  current: void 0
};
class gc {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(e, n = {}) {
    this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (i) => {
      var r;
      const s = J.now();
      if (this.updatedAt !== s && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(i), this.current !== this.prev && ((r = this.events.change) == null || r.notify(this.current), this.dependents))
        for (const o of this.dependents)
          o.dirty();
    }, this.hasAnimated = !1, this.setCurrent(e), this.owner = n.owner;
  }
  setCurrent(e) {
    this.current = e, this.updatedAt = J.now(), this.canTrackVelocity === null && e !== void 0 && (this.canTrackVelocity = pc(this.current));
  }
  setPrevFrameValue(e = this.current) {
    this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(e) {
    return process.env.NODE_ENV !== "production" && Ge(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", e);
  }
  on(e, n) {
    this.events[e] || (this.events[e] = new Qn());
    const i = this.events[e].add(n);
    return e === "change" ? () => {
      i(), B.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : i;
  }
  clearListeners() {
    for (const e in this.events)
      this.events[e].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(e, n) {
    this.passiveEffect = e, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(e) {
    this.passiveEffect ? this.passiveEffect(e, this.updateAndNotify) : this.updateAndNotify(e);
  }
  setWithVelocity(e, n, i) {
    this.set(n), this.prev = void 0, this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt - i;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(e, n = !0) {
    this.updateAndNotify(e), this.prev = e, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    var e;
    (e = this.events.change) == null || e.notify(this.current);
  }
  addDependent(e) {
    this.dependents || (this.dependents = /* @__PURE__ */ new Set()), this.dependents.add(e);
  }
  removeDependent(e) {
    this.dependents && this.dependents.delete(e);
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return ne.current && ne.current.push(this), this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const e = J.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || e - this.updatedAt > Gi)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, Gi);
    return vo(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(e) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = e(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    var e, n;
    (e = this.dependents) == null || e.clear(), (n = this.events.destroy) == null || n.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function At(t, e) {
  return new gc(t, e);
}
const Bn = (t) => Array.isArray(t);
function yc(t, e, n) {
  t.hasValue(e) ? t.getValue(e).set(n) : t.addValue(e, At(n));
}
function vc(t) {
  return Bn(t) ? t[t.length - 1] || 0 : t;
}
function Tc(t, e) {
  const n = Bt(t, e);
  let { transitionEnd: i = {}, transition: s = {}, ...r } = n || {};
  r = { ...r, ...i };
  for (const o in r) {
    const a = vc(r[o]);
    yc(t, o, a);
  }
}
const K = (t) => !!(t && t.getVelocity);
function xc(t) {
  return !!(K(t) && t.add);
}
function Fn(t, e) {
  const n = t.getValue("willChange");
  if (xc(n))
    return n.add(e);
  if (!n && Pt.WillChange) {
    const i = new Pt.WillChange("auto");
    t.addValue("willChange", i), i.add(e);
  }
}
function di(t) {
  return t.replace(/([A-Z])/g, (e) => `-${e.toLowerCase()}`);
}
const wc = "framerAppearId", rr = "data-" + di(wc);
function ar(t) {
  return t.props[rr];
}
function Sc({ protectedKeys: t, needsAnimating: e }, n) {
  const i = t.hasOwnProperty(n) && e[n] !== !0;
  return e[n] = !1, i;
}
function mi(t, e, { delay: n = 0, transitionOverride: i, type: s } = {}) {
  let { transition: r, transitionEnd: o, ...a } = e;
  const l = t.getDefaultTransition();
  r = r ? sr(r, l) : l;
  const u = r == null ? void 0 : r.reduceMotion;
  i && (r = i);
  const c = [], h = s && t.animationState && t.animationState.getState()[s];
  for (const f in a) {
    const d = t.getValue(f, t.latestValues[f] ?? null), m = a[f];
    if (m === void 0 || h && Sc(h, f))
      continue;
    const y = {
      delay: n,
      ...ui(r || {}, f)
    }, p = d.get();
    if (p !== void 0 && !d.isAnimating() && !Array.isArray(m) && m === p && !y.velocity) {
      B.update(() => d.set(m));
      continue;
    }
    let g = !1;
    if (window.MotionHandoffAnimation) {
      const x = ar(t);
      if (x) {
        const S = window.MotionHandoffAnimation(x, f, B);
        S !== null && (y.startTime = S, g = !0);
      }
    }
    Fn(t, f);
    const v = u ?? t.shouldReduceMotion;
    d.start(hi(f, d, m, v && or.has(f) ? { type: !1 } : y, t, g));
    const T = d.animation;
    T && c.push(T);
  }
  if (o) {
    const f = () => B.update(() => {
      o && Tc(t, o);
    });
    c.length ? Promise.all(c).then(f) : f();
  }
  return c;
}
function On(t, e, n = {}) {
  var l;
  const i = Bt(t, e, n.type === "exit" ? (l = t.presenceContext) == null ? void 0 : l.custom : void 0);
  let { transition: s = t.getDefaultTransition() || {} } = i || {};
  n.transitionOverride && (s = n.transitionOverride);
  const r = i ? () => Promise.all(mi(t, i, n)) : () => Promise.resolve(), o = t.variantChildren && t.variantChildren.size ? (u = 0) => {
    const { delayChildren: c = 0, staggerChildren: h, staggerDirection: f } = s;
    return bc(t, e, u, c, h, f, n);
  } : () => Promise.resolve(), { when: a } = s;
  if (a) {
    const [u, c] = a === "beforeChildren" ? [r, o] : [o, r];
    return u().then(() => c());
  } else
    return Promise.all([r(), o(n.delay)]);
}
function bc(t, e, n = 0, i = 0, s = 0, r = 1, o) {
  const a = [];
  for (const l of t.variantChildren)
    l.notify("AnimationStart", e), a.push(On(l, e, {
      ...o,
      delay: n + (typeof i == "function" ? 0 : i) + nr(t.variantChildren, l, i, s, r)
    }).then(() => l.notify("AnimationComplete", e)));
  return Promise.all(a);
}
function Pc(t, e, n = {}) {
  t.notify("AnimationStart", e);
  let i;
  if (Array.isArray(e)) {
    const s = e.map((r) => On(t, r, n));
    i = Promise.all(s);
  } else if (typeof e == "string")
    i = On(t, e, n);
  else {
    const s = typeof e == "function" ? Bt(t, e, n.custom) : e;
    i = Promise.all(mi(t, s, n));
  }
  return i.then(() => {
    t.notify("AnimationComplete", e);
  });
}
const Ac = {
  test: (t) => t === "auto",
  parse: (t) => t
}, lr = (t) => (e) => e.test(t), cr = [Gt, b, pt, xt, Ja, Za, Ac], Yi = (t) => cr.find(lr(t));
function Ec(t) {
  return typeof t == "number" ? t === 0 : t !== null ? t === "none" || t === "0" || go(t) : !0;
}
const Cc = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function Vc(t) {
  const [e, n] = t.slice(0, -1).split("(");
  if (e === "drop-shadow")
    return t;
  const [i] = n.match(ii) || [];
  if (!i)
    return t;
  const s = n.replace(i, "");
  let r = Cc.has(e) ? 1 : 0;
  return i !== n && (r *= 100), e + "(" + r + s + ")";
}
const Dc = /\b([a-z-]*)\(.*?\)/gu, Nn = {
  ...ut,
  getAnimatableNone: (t) => {
    const e = t.match(Dc);
    return e ? e.map(Vc).join(" ") : t;
  }
}, jn = {
  ...ut,
  getAnimatableNone: (t) => {
    const e = ut.parse(t);
    return ut.createTransformer(t)(e.map((i) => typeof i == "number" ? 0 : typeof i == "object" ? { ...i, alpha: 1 } : i));
  }
}, Xi = {
  ...Gt,
  transform: Math.round
}, Mc = {
  rotate: xt,
  rotateX: xt,
  rotateY: xt,
  rotateZ: xt,
  scale: we,
  scaleX: we,
  scaleY: we,
  scaleZ: we,
  skew: xt,
  skewX: xt,
  skewY: xt,
  distance: b,
  translateX: b,
  translateY: b,
  translateZ: b,
  x: b,
  y: b,
  z: b,
  perspective: b,
  transformPerspective: b,
  opacity: re,
  originX: Ii,
  originY: Ii,
  originZ: b
}, pi = {
  // Border props
  borderWidth: b,
  borderTopWidth: b,
  borderRightWidth: b,
  borderBottomWidth: b,
  borderLeftWidth: b,
  borderRadius: b,
  borderTopLeftRadius: b,
  borderTopRightRadius: b,
  borderBottomRightRadius: b,
  borderBottomLeftRadius: b,
  // Positioning props
  width: b,
  maxWidth: b,
  height: b,
  maxHeight: b,
  top: b,
  right: b,
  bottom: b,
  left: b,
  inset: b,
  insetBlock: b,
  insetBlockStart: b,
  insetBlockEnd: b,
  insetInline: b,
  insetInlineStart: b,
  insetInlineEnd: b,
  // Spacing props
  padding: b,
  paddingTop: b,
  paddingRight: b,
  paddingBottom: b,
  paddingLeft: b,
  paddingBlock: b,
  paddingBlockStart: b,
  paddingBlockEnd: b,
  paddingInline: b,
  paddingInlineStart: b,
  paddingInlineEnd: b,
  margin: b,
  marginTop: b,
  marginRight: b,
  marginBottom: b,
  marginLeft: b,
  marginBlock: b,
  marginBlockStart: b,
  marginBlockEnd: b,
  marginInline: b,
  marginInlineStart: b,
  marginInlineEnd: b,
  // Typography
  fontSize: b,
  // Misc
  backgroundPositionX: b,
  backgroundPositionY: b,
  ...Mc,
  zIndex: Xi,
  // SVG
  fillOpacity: re,
  strokeOpacity: re,
  numOctaves: Xi
}, Rc = {
  ...pi,
  // Color props
  color: $,
  backgroundColor: $,
  outlineColor: $,
  fill: $,
  stroke: $,
  // Border props
  borderColor: $,
  borderTopColor: $,
  borderRightColor: $,
  borderBottomColor: $,
  borderLeftColor: $,
  filter: Nn,
  WebkitFilter: Nn,
  mask: jn,
  WebkitMask: jn
}, ur = (t) => Rc[t], Lc = /* @__PURE__ */ new Set([Nn, jn]);
function hr(t, e) {
  let n = ur(t);
  return Lc.has(n) || (n = ut), n.getAnimatableNone ? n.getAnimatableNone(e) : void 0;
}
const kc = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function Ic(t, e, n) {
  let i = 0, s;
  for (; i < t.length && !s; ) {
    const r = t[i];
    typeof r == "string" && !kc.has(r) && Kt(r).values.length && (s = t[i]), i++;
  }
  if (s && n)
    for (const r of e)
      t[r] = hr(n, s);
}
class Bc extends li {
  constructor(e, n, i, s, r) {
    super(e, n, i, s, r, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, element: n, name: i } = this;
    if (!n || !n.current)
      return;
    super.readKeyframes();
    for (let c = 0; c < e.length; c++) {
      let h = e[c];
      if (typeof h == "string" && (h = h.trim(), ni(h))) {
        const f = ir(h, n.current);
        f !== void 0 && (e[c] = f), c === e.length - 1 && (this.finalKeyframe = h);
      }
    }
    if (this.resolveNoneKeyframes(), !or.has(i) || e.length !== 2)
      return;
    const [s, r] = e, o = Yi(s), a = Yi(r), l = ki(s), u = ki(r);
    if (l !== u && St[i]) {
      this.needsMeasurement = !0;
      return;
    }
    if (o !== a)
      if ($i(o) && $i(a))
        for (let c = 0; c < e.length; c++) {
          const h = e[c];
          typeof h == "string" && (e[c] = parseFloat(h));
        }
      else St[i] && (this.needsMeasurement = !0);
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: e, name: n } = this, i = [];
    for (let s = 0; s < e.length; s++)
      (e[s] === null || Ec(e[s])) && i.push(s);
    i.length && Ic(e, i, n);
  }
  measureInitialState() {
    const { element: e, unresolvedKeyframes: n, name: i } = this;
    if (!e || !e.current)
      return;
    i === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = St[i](e.measureViewportBox(), window.getComputedStyle(e.current)), n[0] = this.measuredOrigin;
    const s = n[n.length - 1];
    s !== void 0 && e.getValue(i, s).jump(s, !1);
  }
  measureEndState() {
    var a;
    const { element: e, name: n, unresolvedKeyframes: i } = this;
    if (!e || !e.current)
      return;
    const s = e.getValue(n);
    s && s.jump(this.measuredOrigin, !1);
    const r = i.length - 1, o = i[r];
    i[r] = St[n](e.measureViewportBox(), window.getComputedStyle(e.current)), o !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = o), (a = this.removedTransforms) != null && a.length && this.removedTransforms.forEach(([l, u]) => {
      e.getValue(l).set(u);
    }), this.resolveNoneKeyframes();
  }
}
function gi(t, e, n) {
  if (t == null)
    return [];
  if (t instanceof EventTarget)
    return [t];
  if (typeof t == "string") {
    let i = document;
    e && (i = e.current);
    const s = (n == null ? void 0 : n[t]) ?? i.querySelectorAll(t);
    return s ? Array.from(s) : [];
  }
  return Array.from(t).filter((i) => i != null);
}
const fr = (t, e) => e && typeof t == "number" ? e.transform(t) : t;
function Ve(t) {
  return po(t) && "offsetHeight" in t && !("ownerSVGElement" in t);
}
const { schedule: yi } = /* @__PURE__ */ Ro(queueMicrotask, !1), lt = {
  x: !1,
  y: !1
};
function dr() {
  return lt.x || lt.y;
}
function Fc(t) {
  return t === "x" || t === "y" ? lt[t] ? null : (lt[t] = !0, () => {
    lt[t] = !1;
  }) : lt.x || lt.y ? null : (lt.x = lt.y = !0, () => {
    lt.x = lt.y = !1;
  });
}
function mr(t, e) {
  const n = gi(t), i = new AbortController(), s = {
    passive: !0,
    ...e,
    signal: i.signal
  };
  return [n, s, () => i.abort()];
}
function Oc(t) {
  return !(t.pointerType === "touch" || dr());
}
function Nc(t, e, n = {}) {
  const [i, s, r] = mr(t, n);
  return i.forEach((o) => {
    let a = !1, l = !1, u;
    const c = () => {
      o.removeEventListener("pointerleave", m);
    }, h = (p) => {
      u && (u(p), u = void 0), c();
    }, f = (p) => {
      a = !1, window.removeEventListener("pointerup", f), window.removeEventListener("pointercancel", f), l && (l = !1, h(p));
    }, d = () => {
      a = !0, window.addEventListener("pointerup", f, s), window.addEventListener("pointercancel", f, s);
    }, m = (p) => {
      if (p.pointerType !== "touch") {
        if (a) {
          l = !0;
          return;
        }
        h(p);
      }
    }, y = (p) => {
      if (!Oc(p))
        return;
      l = !1;
      const g = e(o, p);
      typeof g == "function" && (u = g, o.addEventListener("pointerleave", m, s));
    };
    o.addEventListener("pointerenter", y, s), o.addEventListener("pointerdown", d, s);
  }), r;
}
const pr = (t, e) => e ? t === e ? !0 : pr(t, e.parentElement) : !1, vi = (t) => t.pointerType === "mouse" ? typeof t.button != "number" || t.button <= 0 : t.isPrimary !== !1, jc = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function Wc(t) {
  return jc.has(t.tagName) || t.isContentEditable === !0;
}
const Hc = /* @__PURE__ */ new Set(["INPUT", "SELECT", "TEXTAREA"]);
function $c(t) {
  return Hc.has(t.tagName) || t.isContentEditable === !0;
}
const De = /* @__PURE__ */ new WeakSet();
function qi(t) {
  return (e) => {
    e.key === "Enter" && t(e);
  };
}
function un(t, e) {
  t.dispatchEvent(new PointerEvent("pointer" + e, { isPrimary: !0, bubbles: !0 }));
}
const Uc = (t, e) => {
  const n = t.currentTarget;
  if (!n)
    return;
  const i = qi(() => {
    if (De.has(n))
      return;
    un(n, "down");
    const s = qi(() => {
      un(n, "up");
    }), r = () => un(n, "cancel");
    n.addEventListener("keyup", s, e), n.addEventListener("blur", r, e);
  });
  n.addEventListener("keydown", i, e), n.addEventListener("blur", () => n.removeEventListener("keydown", i), e);
};
function Zi(t) {
  return vi(t) && !dr();
}
const Ji = /* @__PURE__ */ new WeakSet();
function _c(t, e, n = {}) {
  const [i, s, r] = mr(t, n), o = (a) => {
    const l = a.currentTarget;
    if (!Zi(a) || Ji.has(a))
      return;
    De.add(l), n.stopPropagation && Ji.add(a);
    const u = e(l, a), c = (d, m) => {
      window.removeEventListener("pointerup", h), window.removeEventListener("pointercancel", f), De.has(l) && De.delete(l), Zi(d) && typeof u == "function" && u(d, { success: m });
    }, h = (d) => {
      c(d, l === window || l === document || n.useGlobalTarget || pr(l, d.target));
    }, f = (d) => {
      c(d, !1);
    };
    window.addEventListener("pointerup", h, s), window.addEventListener("pointercancel", f, s);
  };
  return i.forEach((a) => {
    (n.useGlobalTarget ? window : a).addEventListener("pointerdown", o, s), Ve(a) && (a.addEventListener("focus", (u) => Uc(u, s)), !Wc(a) && !a.hasAttribute("tabindex") && (a.tabIndex = 0));
  }), r;
}
function Xe(t) {
  return po(t) && "ownerSVGElement" in t;
}
const Me = /* @__PURE__ */ new WeakMap();
let wt;
const gr = (t, e, n) => (i, s) => s && s[0] ? s[0][t + "Size"] : Xe(i) && "getBBox" in i ? i.getBBox()[e] : i[n], Kc = /* @__PURE__ */ gr("inline", "width", "offsetWidth"), zc = /* @__PURE__ */ gr("block", "height", "offsetHeight");
function Gc({ target: t, borderBoxSize: e }) {
  var n;
  (n = Me.get(t)) == null || n.forEach((i) => {
    i(t, {
      get width() {
        return Kc(t, e);
      },
      get height() {
        return zc(t, e);
      }
    });
  });
}
function Yc(t) {
  t.forEach(Gc);
}
function Xc() {
  typeof ResizeObserver > "u" || (wt = new ResizeObserver(Yc));
}
function qc(t, e) {
  wt || Xc();
  const n = gi(t);
  return n.forEach((i) => {
    let s = Me.get(i);
    s || (s = /* @__PURE__ */ new Set(), Me.set(i, s)), s.add(e), wt == null || wt.observe(i);
  }), () => {
    n.forEach((i) => {
      const s = Me.get(i);
      s == null || s.delete(e), s != null && s.size || wt == null || wt.unobserve(i);
    });
  };
}
const Re = /* @__PURE__ */ new Set();
let Ht;
function Zc() {
  Ht = () => {
    const t = {
      get width() {
        return window.innerWidth;
      },
      get height() {
        return window.innerHeight;
      }
    };
    Re.forEach((e) => e(t));
  }, window.addEventListener("resize", Ht);
}
function Jc(t) {
  return Re.add(t), Ht || Zc(), () => {
    Re.delete(t), !Re.size && typeof Ht == "function" && (window.removeEventListener("resize", Ht), Ht = void 0);
  };
}
function Qi(t, e) {
  return typeof t == "function" ? Jc(t) : qc(t, e);
}
function yr(t) {
  return Xe(t) && t.tagName === "svg";
}
function Le(...t) {
  const e = !Array.isArray(t[0]), n = e ? 0 : -1, i = t[0 + n], s = t[1 + n], r = t[2 + n], o = t[3 + n], a = Uo(s, r, o);
  return e ? a(i) : a;
}
const Qc = [...cr, $, ut], tu = (t) => Qc.find(lr(t)), ts = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), $t = () => ({
  x: ts(),
  y: ts()
}), es = () => ({ min: 0, max: 0 }), H = () => ({
  x: es(),
  y: es()
}), le = /* @__PURE__ */ new WeakMap();
function qe(t) {
  return t !== null && typeof t == "object" && typeof t.start == "function";
}
function ce(t) {
  return typeof t == "string" || Array.isArray(t);
}
const Ti = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], xi = ["initial", ...Ti];
function Ze(t) {
  return qe(t.animate) || xi.some((e) => ce(t[e]));
}
function vr(t) {
  return !!(Ze(t) || t.variants);
}
function eu(t, e, n) {
  for (const i in e) {
    const s = e[i], r = n[i];
    if (K(s))
      t.addValue(i, s);
    else if (K(r))
      t.addValue(i, At(s, { owner: t }));
    else if (r !== s)
      if (t.hasValue(i)) {
        const o = t.getValue(i);
        o.liveStyle === !0 ? o.jump(s) : o.hasAnimated || o.set(s);
      } else {
        const o = t.getStaticValue(i);
        t.addValue(i, At(o !== void 0 ? o : s, { owner: t }));
      }
  }
  for (const i in n)
    e[i] === void 0 && t.removeValue(i);
  return e;
}
const je = { current: null }, wi = { current: !1 }, nu = typeof window < "u";
function Tr() {
  if (wi.current = !0, !!nu)
    if (window.matchMedia) {
      const t = window.matchMedia("(prefers-reduced-motion)"), e = () => je.current = t.matches;
      t.addEventListener("change", e), e();
    } else
      je.current = !1;
}
const ns = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
let We = {};
function xr(t) {
  We = t;
}
function iu() {
  return We;
}
class wr {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(e, n, i) {
    return {};
  }
  constructor({ parent: e, props: n, presenceContext: i, reducedMotionConfig: s, skipAnimations: r, blockInitialAnimation: o, visualState: a }, l = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.shouldSkipAnimations = !1, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = li, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.hasBeenMounted = !1, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const d = J.now();
      this.renderScheduledAt < d && (this.renderScheduledAt = d, B.render(this.render, !1, !0));
    };
    const { latestValues: u, renderState: c } = a;
    this.latestValues = u, this.baseTarget = { ...u }, this.initialValues = n.initial ? { ...u } : {}, this.renderState = c, this.parent = e, this.props = n, this.presenceContext = i, this.depth = e ? e.depth + 1 : 0, this.reducedMotionConfig = s, this.skipAnimationsConfig = r, this.options = l, this.blockInitialAnimation = !!o, this.isControllingVariants = Ze(n), this.isVariantNode = vr(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(e && e.current);
    const { willChange: h, ...f } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const d in f) {
      const m = f[d];
      u[d] !== void 0 && K(m) && m.set(u[d]);
    }
  }
  mount(e) {
    var n, i;
    if (this.hasBeenMounted)
      for (const s in this.initialValues)
        (n = this.values.get(s)) == null || n.jump(this.initialValues[s]), this.latestValues[s] = this.initialValues[s];
    this.current = e, le.set(e, this), this.projection && !this.projection.instance && this.projection.mount(e), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((s, r) => this.bindToMotionValue(r, s)), this.reducedMotionConfig === "never" ? this.shouldReduceMotion = !1 : this.reducedMotionConfig === "always" ? this.shouldReduceMotion = !0 : (wi.current || Tr(), this.shouldReduceMotion = je.current), process.env.NODE_ENV !== "production" && Ge(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled"), this.shouldSkipAnimations = this.skipAnimationsConfig ?? !1, (i = this.parent) == null || i.addChild(this), this.update(this.props, this.presenceContext), this.hasBeenMounted = !0;
  }
  unmount() {
    var e;
    this.projection && this.projection.unmount(), Tt(this.notifyUpdate), Tt(this.render), this.valueSubscriptions.forEach((n) => n()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), (e = this.parent) == null || e.removeChild(this);
    for (const n in this.events)
      this.events[n].clear();
    for (const n in this.features) {
      const i = this.features[n];
      i && (i.unmount(), i.isMounted = !1);
    }
    this.current = null;
  }
  addChild(e) {
    this.children.add(e), this.enteringChildren ?? (this.enteringChildren = /* @__PURE__ */ new Set()), this.enteringChildren.add(e);
  }
  removeChild(e) {
    this.children.delete(e), this.enteringChildren && this.enteringChildren.delete(e);
  }
  bindToMotionValue(e, n) {
    if (this.valueSubscriptions.has(e) && this.valueSubscriptions.get(e)(), n.accelerate && er.has(e) && this.current instanceof HTMLElement) {
      const { factory: o, keyframes: a, times: l, ease: u, duration: c } = n.accelerate, h = new Qo({
        element: this.current,
        name: e,
        keyframes: a,
        times: l,
        ease: u,
        duration: /* @__PURE__ */ tt(c)
      }), f = o(h);
      this.valueSubscriptions.set(e, () => {
        f(), h.cancel();
      });
      return;
    }
    const i = Xt.has(e);
    i && this.onBindTransform && this.onBindTransform();
    const s = n.on("change", (o) => {
      this.latestValues[e] = o, this.props.onUpdate && B.preRender(this.notifyUpdate), i && this.projection && (this.projection.isTransformDirty = !0), this.scheduleRender();
    });
    let r;
    typeof window < "u" && window.MotionCheckAppearSync && (r = window.MotionCheckAppearSync(this, e, n)), this.valueSubscriptions.set(e, () => {
      s(), r && r(), n.owner && n.stop();
    });
  }
  sortNodePosition(e) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== e.type ? 0 : this.sortInstanceNodePosition(this.current, e.current);
  }
  updateFeatures() {
    let e = "animation";
    for (e in We) {
      const n = We[e];
      if (!n)
        continue;
      const { isEnabled: i, Feature: s } = n;
      if (!this.features[e] && s && i(this.props) && (this.features[e] = new s(this)), this.features[e]) {
        const r = this.features[e];
        r.isMounted ? r.update() : (r.mount(), r.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : H();
  }
  getStaticValue(e) {
    return this.latestValues[e];
  }
  setStaticValue(e, n) {
    this.latestValues[e] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(e, n) {
    (e.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = e, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let i = 0; i < ns.length; i++) {
      const s = ns[i];
      this.propEventSubscriptions[s] && (this.propEventSubscriptions[s](), delete this.propEventSubscriptions[s]);
      const r = "on" + s, o = e[r];
      o && (this.propEventSubscriptions[s] = this.on(s, o));
    }
    this.prevMotionValues = eu(this, this.scrapeMotionValuesFromProps(e, this.prevProps || {}, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(e) {
    return this.props.variants ? this.props.variants[e] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(e) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(e), () => n.variantChildren.delete(e);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(e, n) {
    const i = this.values.get(e);
    n !== i && (i && this.removeValue(e), this.bindToMotionValue(e, n), this.values.set(e, n), this.latestValues[e] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(e) {
    this.values.delete(e);
    const n = this.valueSubscriptions.get(e);
    n && (n(), this.valueSubscriptions.delete(e)), delete this.latestValues[e], this.removeValueFromRenderState(e, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(e) {
    return this.values.has(e);
  }
  getValue(e, n) {
    if (this.props.values && this.props.values[e])
      return this.props.values[e];
    let i = this.values.get(e);
    return i === void 0 && n !== void 0 && (i = At(n === null ? void 0 : n, { owner: this }), this.addValue(e, i)), i;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(e, n) {
    let i = this.latestValues[e] !== void 0 || !this.current ? this.latestValues[e] : this.getBaseTargetFromProps(this.props, e) ?? this.readValueFromInstance(this.current, e, this.options);
    return i != null && (typeof i == "string" && (mo(i) || go(i)) ? i = parseFloat(i) : !tu(i) && ut.test(n) && (i = hr(e, n)), this.setBaseTarget(e, K(i) ? i.get() : i)), K(i) ? i.get() : i;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(e, n) {
    this.baseTarget[e] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(e) {
    var r;
    const { initial: n } = this.props;
    let i;
    if (typeof n == "string" || typeof n == "object") {
      const o = fi(this.props, n, (r = this.presenceContext) == null ? void 0 : r.custom);
      o && (i = o[e]);
    }
    if (n && i !== void 0)
      return i;
    const s = this.getBaseTargetFromProps(this.props, e);
    return s !== void 0 && !K(s) ? s : this.initialValues[e] !== void 0 && i === void 0 ? void 0 : this.baseTarget[e];
  }
  on(e, n) {
    return this.events[e] || (this.events[e] = new Qn()), this.events[e].add(n);
  }
  notify(e, ...n) {
    this.events[e] && this.events[e].notify(...n);
  }
  scheduleRenderMicrotask() {
    yi.render(this.render);
  }
}
class Sr extends wr {
  constructor() {
    super(...arguments), this.KeyframeResolver = Bc;
  }
  sortInstanceNodePosition(e, n) {
    return e.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(e, n) {
    const i = e.style;
    return i ? i[n] : void 0;
  }
  removeValueFromRenderState(e, { vars: n, style: i }) {
    delete n[e], delete i[e];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: e } = this.props;
    K(e) && (this.childSubscription = e.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
class Ct {
  constructor(e) {
    this.isMounted = !1, this.node = e;
  }
  update() {
  }
}
function br({ top: t, left: e, right: n, bottom: i }) {
  return {
    x: { min: e, max: n },
    y: { min: t, max: i }
  };
}
function su({ x: t, y: e }) {
  return { top: e.min, right: t.max, bottom: e.max, left: t.min };
}
function ou(t, e) {
  if (!e)
    return t;
  const n = e({ x: t.left, y: t.top }), i = e({ x: t.right, y: t.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: i.y,
    right: i.x
  };
}
function hn(t) {
  return t === void 0 || t === 1;
}
function Wn({ scale: t, scaleX: e, scaleY: n }) {
  return !hn(t) || !hn(e) || !hn(n);
}
function Rt(t) {
  return Wn(t) || Pr(t) || t.z || t.rotate || t.rotateX || t.rotateY || t.skewX || t.skewY;
}
function Pr(t) {
  return is(t.x) || is(t.y);
}
function is(t) {
  return t && t !== "0%";
}
function He(t, e, n) {
  const i = t - n, s = e * i;
  return n + s;
}
function ss(t, e, n, i, s) {
  return s !== void 0 && (t = He(t, s, i)), He(t, n, i) + e;
}
function Hn(t, e = 0, n = 1, i, s) {
  t.min = ss(t.min, e, n, i, s), t.max = ss(t.max, e, n, i, s);
}
function Ar(t, { x: e, y: n }) {
  Hn(t.x, e.translate, e.scale, e.originPoint), Hn(t.y, n.translate, n.scale, n.originPoint);
}
const os = 0.999999999999, rs = 1.0000000000001;
function ru(t, e, n, i = !1) {
  var a;
  const s = n.length;
  if (!s)
    return;
  e.x = e.y = 1;
  let r, o;
  for (let l = 0; l < s; l++) {
    r = n[l], o = r.projectionDelta;
    const { visualElement: u } = r.options;
    u && u.props.style && u.props.style.display === "contents" || (i && r.options.layoutScroll && r.scroll && r !== r.root && (mt(t.x, -r.scroll.offset.x), mt(t.y, -r.scroll.offset.y)), o && (e.x *= o.x.scale, e.y *= o.y.scale, Ar(t, o)), i && Rt(r.latestValues) && ke(t, r.latestValues, (a = r.layout) == null ? void 0 : a.layoutBox));
  }
  e.x < rs && e.x > os && (e.x = 1), e.y < rs && e.y > os && (e.y = 1);
}
function mt(t, e) {
  t.min += e, t.max += e;
}
function as(t, e, n, i, s = 0.5) {
  const r = F(t.min, t.max, s);
  Hn(t, e, n, r, i);
}
function ls(t, e) {
  return typeof t == "string" ? parseFloat(t) / 100 * (e.max - e.min) : t;
}
function ke(t, e, n) {
  const i = n ?? t;
  as(t.x, ls(e.x, i.x), e.scaleX, e.scale, e.originX), as(t.y, ls(e.y, i.y), e.scaleY, e.scale, e.originY);
}
function Er(t, e) {
  return br(ou(t.getBoundingClientRect(), e));
}
function au(t, e, n) {
  const i = Er(t, n), { scroll: s } = e;
  return s && (mt(i.x, s.offset.x), mt(i.y, s.offset.y)), i;
}
const lu = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, cu = Yt.length;
function uu(t, e, n) {
  let i = "", s = !0;
  for (let r = 0; r < cu; r++) {
    const o = Yt[r], a = t[o];
    if (a === void 0)
      continue;
    let l = !0;
    if (typeof a == "number")
      l = a === (o.startsWith("scale") ? 1 : 0);
    else {
      const u = parseFloat(a);
      l = o.startsWith("scale") ? u === 1 : u === 0;
    }
    if (!l || n) {
      const u = fr(a, pi[o]);
      if (!l) {
        s = !1;
        const c = lu[o] || o;
        i += `${c}(${u}) `;
      }
      n && (e[o] = u);
    }
  }
  return i = i.trim(), n ? i = n(e, s ? "" : i) : s && (i = "none"), i;
}
function Si(t, e, n) {
  const { style: i, vars: s, transformOrigin: r } = t;
  let o = !1, a = !1;
  for (const l in e) {
    const u = e[l];
    if (Xt.has(l)) {
      o = !0;
      continue;
    } else if (ko(l)) {
      s[l] = u;
      continue;
    } else {
      const c = fr(u, pi[l]);
      l.startsWith("origin") ? (a = !0, r[l] = c) : i[l] = c;
    }
  }
  if (e.transform || (o || n ? i.transform = uu(e, t.transform, n) : i.transform && (i.transform = "none")), a) {
    const { originX: l = "50%", originY: u = "50%", originZ: c = 0 } = r;
    i.transformOrigin = `${l} ${u} ${c}`;
  }
}
function Cr(t, { style: e, vars: n }, i, s) {
  const r = t.style;
  let o;
  for (o in e)
    r[o] = e[o];
  s == null || s.applyProjectionStyles(r, i);
  for (o in n)
    r.setProperty(o, n[o]);
}
function cs(t, e) {
  return e.max === e.min ? 0 : t / (e.max - e.min) * 100;
}
const Zt = {
  correct: (t, e) => {
    if (!e.target)
      return t;
    if (typeof t == "string")
      if (b.test(t))
        t = parseFloat(t);
      else
        return t;
    const n = cs(t, e.target.x), i = cs(t, e.target.y);
    return `${n}% ${i}%`;
  }
}, hu = {
  correct: (t, { treeScale: e, projectionDelta: n }) => {
    const i = t, s = ut.parse(t);
    if (s.length > 5)
      return i;
    const r = ut.createTransformer(t), o = typeof s[0] != "number" ? 1 : 0, a = n.x.scale * e.x, l = n.y.scale * e.y;
    s[0 + o] /= a, s[1 + o] /= l;
    const u = F(a, l, 0.5);
    return typeof s[2 + o] == "number" && (s[2 + o] /= u), typeof s[3 + o] == "number" && (s[3 + o] /= u), r(s);
  }
}, $n = {
  borderRadius: {
    ...Zt,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: Zt,
  borderTopRightRadius: Zt,
  borderBottomLeftRadius: Zt,
  borderBottomRightRadius: Zt,
  boxShadow: hu
};
function Vr(t, { layout: e, layoutId: n }) {
  return Xt.has(t) || t.startsWith("origin") || (e || n !== void 0) && (!!$n[t] || t === "opacity");
}
function bi(t, e, n) {
  var o;
  const i = t.style, s = e == null ? void 0 : e.style, r = {};
  if (!i)
    return r;
  for (const a in i)
    (K(i[a]) || s && K(s[a]) || Vr(a, t) || ((o = n == null ? void 0 : n.getValue(a)) == null ? void 0 : o.liveStyle) !== void 0) && (r[a] = i[a]);
  return r;
}
function fu(t) {
  return window.getComputedStyle(t);
}
class Dr extends Sr {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = Cr;
  }
  readValueFromInstance(e, n) {
    var i;
    if (Xt.has(n))
      return (i = this.projection) != null && i.isProjecting ? Dn(n) : Il(e, n);
    {
      const s = fu(e), r = (ko(n) ? s.getPropertyValue(n) : s[n]) || 0;
      return typeof r == "string" ? r.trim() : r;
    }
  }
  measureInstanceViewportBox(e, { transformPagePoint: n }) {
    return Er(e, n);
  }
  build(e, n, i) {
    Si(e, n, i.transformTemplate);
  }
  scrapeMotionValuesFromProps(e, n, i) {
    return bi(e, n, i);
  }
}
function du(t, e) {
  return t in e;
}
class mu extends wr {
  constructor() {
    super(...arguments), this.type = "object";
  }
  readValueFromInstance(e, n) {
    if (du(n, e)) {
      const i = e[n];
      if (typeof i == "string" || typeof i == "number")
        return i;
    }
  }
  getBaseTargetFromProps() {
  }
  removeValueFromRenderState(e, n) {
    delete n.output[e];
  }
  measureInstanceViewportBox() {
    return H();
  }
  build(e, n) {
    Object.assign(e.output, n);
  }
  renderInstance(e, { output: n }) {
    Object.assign(e, n);
  }
  sortInstanceNodePosition() {
    return 0;
  }
}
const pu = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, gu = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function yu(t, e, n = 1, i = 0, s = !0) {
  t.pathLength = 1;
  const r = s ? pu : gu;
  t[r.offset] = `${-i}`, t[r.array] = `${e} ${n}`;
}
const vu = [
  "offsetDistance",
  "offsetPath",
  "offsetRotate",
  "offsetAnchor"
];
function Mr(t, {
  attrX: e,
  attrY: n,
  attrScale: i,
  pathLength: s,
  pathSpacing: r = 1,
  pathOffset: o = 0,
  // This is object creation, which we try to avoid per-frame.
  ...a
}, l, u, c) {
  if (Si(t, a, u), l) {
    t.style.viewBox && (t.attrs.viewBox = t.style.viewBox);
    return;
  }
  t.attrs = t.style, t.style = {};
  const { attrs: h, style: f } = t;
  h.transform && (f.transform = h.transform, delete h.transform), (f.transform || h.transformOrigin) && (f.transformOrigin = h.transformOrigin ?? "50% 50%", delete h.transformOrigin), f.transform && (f.transformBox = (c == null ? void 0 : c.transformBox) ?? "fill-box", delete h.transformBox);
  for (const d of vu)
    h[d] !== void 0 && (f[d] = h[d], delete h[d]);
  e !== void 0 && (h.x = e), n !== void 0 && (h.y = n), i !== void 0 && (h.scale = i), s !== void 0 && yu(h, s, r, o, !1);
}
const Rr = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]), Lr = (t) => typeof t == "string" && t.toLowerCase() === "svg";
function Tu(t, e, n, i) {
  Cr(t, e, void 0, i);
  for (const s in e.attrs)
    t.setAttribute(Rr.has(s) ? s : di(s), e.attrs[s]);
}
function kr(t, e, n) {
  const i = bi(t, e, n);
  for (const s in t)
    if (K(t[s]) || K(e[s])) {
      const r = Yt.indexOf(s) !== -1 ? "attr" + s.charAt(0).toUpperCase() + s.substring(1) : s;
      i[r] = t[s];
    }
  return i;
}
class Ir extends Sr {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = H;
  }
  getBaseTargetFromProps(e, n) {
    return e[n];
  }
  readValueFromInstance(e, n) {
    if (Xt.has(n)) {
      const i = ur(n);
      return i && i.default || 0;
    }
    return n = Rr.has(n) ? n : di(n), e.getAttribute(n);
  }
  scrapeMotionValuesFromProps(e, n, i) {
    return kr(e, n, i);
  }
  build(e, n, i) {
    Mr(e, n, this.isSVGTag, i.transformTemplate, i.style);
  }
  renderInstance(e, n, i, s) {
    Tu(e, n, i, s);
  }
  mount(e) {
    this.isSVGTag = Lr(e.tagName), super.mount(e);
  }
}
const xu = xi.length;
function Br(t) {
  if (!t)
    return;
  if (!t.isControllingVariants) {
    const n = t.parent ? Br(t.parent) || {} : {};
    return t.props.initial !== void 0 && (n.initial = t.props.initial), n;
  }
  const e = {};
  for (let n = 0; n < xu; n++) {
    const i = xi[n], s = t.props[i];
    (ce(s) || s === !1) && (e[i] = s);
  }
  return e;
}
function Fr(t, e) {
  if (!Array.isArray(e))
    return !1;
  const n = e.length;
  if (n !== t.length)
    return !1;
  for (let i = 0; i < n; i++)
    if (e[i] !== t[i])
      return !1;
  return !0;
}
const wu = [...Ti].reverse(), Su = Ti.length;
function bu(t) {
  return (e) => Promise.all(e.map(({ animation: n, options: i }) => Pc(t, n, i)));
}
function Pu(t) {
  let e = bu(t), n = us(), i = !0, s = !1;
  const r = (u) => (c, h) => {
    var d;
    const f = Bt(t, h, u === "exit" ? (d = t.presenceContext) == null ? void 0 : d.custom : void 0);
    if (f) {
      const { transition: m, transitionEnd: y, ...p } = f;
      c = { ...c, ...p, ...y };
    }
    return c;
  };
  function o(u) {
    e = u(t);
  }
  function a(u) {
    const { props: c } = t, h = Br(t.parent) || {}, f = [], d = /* @__PURE__ */ new Set();
    let m = {}, y = 1 / 0;
    for (let g = 0; g < Su; g++) {
      const v = wu[g], T = n[v], x = c[v] !== void 0 ? c[v] : h[v], S = ce(x), E = v === u ? T.isActive : null;
      E === !1 && (y = g);
      let V = x === h[v] && x !== c[v] && S;
      if (V && (i || s) && t.manuallyAnimateOnMount && (V = !1), T.protectedKeys = { ...m }, // If it isn't active and hasn't *just* been set as inactive
      !T.isActive && E === null || // If we didn't and don't have any defined prop for this animation type
      !x && !T.prevProp || // Or if the prop doesn't define an animation
      qe(x) || typeof x == "boolean")
        continue;
      if (v === "exit" && T.isActive && E !== !0) {
        T.prevResolvedValues && (m = {
          ...m,
          ...T.prevResolvedValues
        });
        continue;
      }
      const P = Au(T.prevProp, x);
      let A = P || // If we're making this variant active, we want to always make it active
      v === u && T.isActive && !V && S || // If we removed a higher-priority variant (i is in reverse order)
      g > y && S, w = !1;
      const C = Array.isArray(x) ? x : [x];
      let D = C.reduce(r(v), {});
      E === !1 && (D = {});
      const { prevResolvedValues: W = {} } = T, X = {
        ...W,
        ...D
      }, q = (L) => {
        A = !0, d.has(L) && (w = !0, d.delete(L)), T.needsAnimating[L] = !0;
        const N = t.getValue(L);
        N && (N.liveStyle = !1);
      };
      for (const L in X) {
        const N = D[L], Z = W[L];
        if (m.hasOwnProperty(L))
          continue;
        let nt = !1;
        Bn(N) && Bn(Z) ? nt = !Fr(N, Z) : nt = N !== Z, nt ? N != null ? q(L) : d.add(L) : N !== void 0 && d.has(L) ? q(L) : T.protectedKeys[L] = !0;
      }
      T.prevProp = x, T.prevResolvedValues = D, T.isActive && (m = { ...m, ...D }), (i || s) && t.blockInitialAnimation && (A = !1);
      const R = V && P;
      A && (!R || w) && f.push(...C.map((L) => {
        const N = { type: v };
        if (typeof L == "string" && (i || s) && !R && t.manuallyAnimateOnMount && t.parent) {
          const { parent: Z } = t, nt = Bt(Z, L);
          if (Z.enteringChildren && nt) {
            const { delayChildren: st } = nt.transition || {};
            N.delay = nr(Z.enteringChildren, t, st);
          }
        }
        return {
          animation: L,
          options: N
        };
      }));
    }
    if (d.size) {
      const g = {};
      if (typeof c.initial != "boolean") {
        const v = Bt(t, Array.isArray(c.initial) ? c.initial[0] : c.initial);
        v && v.transition && (g.transition = v.transition);
      }
      d.forEach((v) => {
        const T = t.getBaseTarget(v), x = t.getValue(v);
        x && (x.liveStyle = !0), g[v] = T ?? null;
      }), f.push({ animation: g });
    }
    let p = !!f.length;
    return i && (c.initial === !1 || c.initial === c.animate) && !t.manuallyAnimateOnMount && (p = !1), i = !1, s = !1, p ? e(f) : Promise.resolve();
  }
  function l(u, c) {
    var f;
    if (n[u].isActive === c)
      return Promise.resolve();
    (f = t.variantChildren) == null || f.forEach((d) => {
      var m;
      return (m = d.animationState) == null ? void 0 : m.setActive(u, c);
    }), n[u].isActive = c;
    const h = a(u);
    for (const d in n)
      n[d].protectedKeys = {};
    return h;
  }
  return {
    animateChanges: a,
    setActive: l,
    setAnimateFunction: o,
    getState: () => n,
    reset: () => {
      n = us(), s = !0;
    }
  };
}
function Au(t, e) {
  return typeof e == "string" ? e !== t : Array.isArray(e) ? !Fr(e, t) : !1;
}
function Dt(t = !1) {
  return {
    isActive: t,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function us() {
  return {
    animate: Dt(!0),
    whileInView: Dt(),
    whileHover: Dt(),
    whileTap: Dt(),
    whileDrag: Dt(),
    whileFocus: Dt(),
    exit: Dt()
  };
}
function Un(t, e) {
  t.min = e.min, t.max = e.max;
}
function at(t, e) {
  Un(t.x, e.x), Un(t.y, e.y);
}
function hs(t, e) {
  t.translate = e.translate, t.scale = e.scale, t.originPoint = e.originPoint, t.origin = e.origin;
}
const Or = 1e-4, Eu = 1 - Or, Cu = 1 + Or, Nr = 0.01, Vu = 0 - Nr, Du = 0 + Nr;
function Q(t) {
  return t.max - t.min;
}
function Mu(t, e, n) {
  return Math.abs(t - e) <= n;
}
function fs(t, e, n, i = 0.5) {
  t.origin = i, t.originPoint = F(e.min, e.max, t.origin), t.scale = Q(n) / Q(e), t.translate = F(n.min, n.max, t.origin) - t.originPoint, (t.scale >= Eu && t.scale <= Cu || isNaN(t.scale)) && (t.scale = 1), (t.translate >= Vu && t.translate <= Du || isNaN(t.translate)) && (t.translate = 0);
}
function ie(t, e, n, i) {
  fs(t.x, e.x, n.x, i ? i.originX : void 0), fs(t.y, e.y, n.y, i ? i.originY : void 0);
}
function ds(t, e, n, i = 0) {
  const s = i ? F(n.min, n.max, i) : n.min;
  t.min = s + e.min, t.max = t.min + Q(e);
}
function Ru(t, e, n, i) {
  ds(t.x, e.x, n.x, i == null ? void 0 : i.x), ds(t.y, e.y, n.y, i == null ? void 0 : i.y);
}
function ms(t, e, n, i = 0) {
  const s = i ? F(n.min, n.max, i) : n.min;
  t.min = e.min - s, t.max = t.min + Q(e);
}
function $e(t, e, n, i) {
  ms(t.x, e.x, n.x, i == null ? void 0 : i.x), ms(t.y, e.y, n.y, i == null ? void 0 : i.y);
}
function ps(t, e, n, i, s) {
  return t -= e, t = He(t, 1 / n, i), s !== void 0 && (t = He(t, 1 / s, i)), t;
}
function Lu(t, e = 0, n = 1, i = 0.5, s, r = t, o = t) {
  if (pt.test(e) && (e = parseFloat(e), e = F(o.min, o.max, e / 100) - o.min), typeof e != "number")
    return;
  let a = F(r.min, r.max, i);
  t === r && (a -= e), t.min = ps(t.min, e, n, a, s), t.max = ps(t.max, e, n, a, s);
}
function gs(t, e, [n, i, s], r, o) {
  Lu(t, e[n], e[i], e[s], e.scale, r, o);
}
const ku = ["x", "scaleX", "originX"], Iu = ["y", "scaleY", "originY"];
function ys(t, e, n, i) {
  gs(t.x, e, ku, n ? n.x : void 0, i ? i.x : void 0), gs(t.y, e, Iu, n ? n.y : void 0, i ? i.y : void 0);
}
function vs(t) {
  return t.translate === 0 && t.scale === 1;
}
function jr(t) {
  return vs(t.x) && vs(t.y);
}
function Ts(t, e) {
  return t.min === e.min && t.max === e.max;
}
function Bu(t, e) {
  return Ts(t.x, e.x) && Ts(t.y, e.y);
}
function xs(t, e) {
  return Math.round(t.min) === Math.round(e.min) && Math.round(t.max) === Math.round(e.max);
}
function Wr(t, e) {
  return xs(t.x, e.x) && xs(t.y, e.y);
}
function ws(t) {
  return Q(t.x) / Q(t.y);
}
function Ss(t, e) {
  return t.translate === e.translate && t.scale === e.scale && t.originPoint === e.originPoint;
}
function dt(t) {
  return [t("x"), t("y")];
}
function Fu(t, e, n) {
  let i = "";
  const s = t.x.translate / e.x, r = t.y.translate / e.y, o = (n == null ? void 0 : n.z) || 0;
  if ((s || r || o) && (i = `translate3d(${s}px, ${r}px, ${o}px) `), (e.x !== 1 || e.y !== 1) && (i += `scale(${1 / e.x}, ${1 / e.y}) `), n) {
    const { transformPerspective: u, rotate: c, rotateX: h, rotateY: f, skewX: d, skewY: m } = n;
    u && (i = `perspective(${u}px) ${i}`), c && (i += `rotate(${c}deg) `), h && (i += `rotateX(${h}deg) `), f && (i += `rotateY(${f}deg) `), d && (i += `skewX(${d}deg) `), m && (i += `skewY(${m}deg) `);
  }
  const a = t.x.scale * e.x, l = t.y.scale * e.y;
  return (a !== 1 || l !== 1) && (i += `scale(${a}, ${l})`), i || "none";
}
const Hr = [
  "borderTopLeftRadius",
  "borderTopRightRadius",
  "borderBottomLeftRadius",
  "borderBottomRightRadius"
], Ou = Hr.length, bs = (t) => typeof t == "string" ? parseFloat(t) : t, Ps = (t) => typeof t == "number" || b.test(t);
function Nu(t, e, n, i, s, r) {
  s ? (t.opacity = F(0, n.opacity ?? 1, ju(i)), t.opacityExit = F(e.opacity ?? 1, 0, Wu(i))) : r && (t.opacity = F(e.opacity ?? 1, n.opacity ?? 1, i));
  for (let o = 0; o < Ou; o++) {
    const a = Hr[o];
    let l = As(e, a), u = As(n, a);
    if (l === void 0 && u === void 0)
      continue;
    l || (l = 0), u || (u = 0), l === 0 || u === 0 || Ps(l) === Ps(u) ? (t[a] = Math.max(F(bs(l), bs(u), i), 0), (pt.test(u) || pt.test(l)) && (t[a] += "%")) : t[a] = u;
  }
  (e.rotate || n.rotate) && (t.rotate = F(e.rotate || 0, n.rotate || 0, i));
}
function As(t, e) {
  return t[e] !== void 0 ? t[e] : t.borderRadius;
}
const ju = /* @__PURE__ */ $r(0, 0.5, Ao), Wu = /* @__PURE__ */ $r(0.5, 0.95, rt);
function $r(t, e, n) {
  return (i) => i < t ? 0 : i > e ? 1 : n(/* @__PURE__ */ _t(t, e, i));
}
function Ur(t, e, n) {
  const i = K(t) ? t : At(t);
  return i.start(hi("", i, e, n)), i.animation;
}
function ue(t, e, n, i = { passive: !0 }) {
  return t.addEventListener(e, n, i), () => t.removeEventListener(e, n);
}
const Hu = (t, e) => t.depth - e.depth;
class $u {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(e) {
    Jn(this.children, e), this.isDirty = !0;
  }
  remove(e) {
    Ut(this.children, e), this.isDirty = !0;
  }
  forEach(e) {
    this.isDirty && this.children.sort(Hu), this.isDirty = !1, this.children.forEach(e);
  }
}
function Uu(t, e) {
  const n = J.now(), i = ({ timestamp: s }) => {
    const r = s - n;
    r >= e && (Tt(i), t(r - e));
  };
  return B.setup(i, !0), () => Tt(i);
}
function Ie(t) {
  return K(t) ? t.get() : t;
}
class _u {
  constructor() {
    this.members = [];
  }
  add(e) {
    Jn(this.members, e);
    for (let n = this.members.length - 1; n >= 0; n--) {
      const i = this.members[n];
      if (i === e || i === this.lead || i === this.prevLead)
        continue;
      const s = i.instance;
      (!s || s.isConnected === !1) && !i.snapshot && (Ut(this.members, i), i.unmount());
    }
    e.scheduleRender();
  }
  remove(e) {
    if (Ut(this.members, e), e === this.prevLead && (this.prevLead = void 0), e === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(e) {
    var n;
    for (let i = this.members.indexOf(e) - 1; i >= 0; i--) {
      const s = this.members[i];
      if (s.isPresent !== !1 && ((n = s.instance) == null ? void 0 : n.isConnected) !== !1)
        return this.promote(s), !0;
    }
    return !1;
  }
  promote(e, n) {
    var s;
    const i = this.lead;
    if (e !== i && (this.prevLead = i, this.lead = e, e.show(), i)) {
      i.updateSnapshot(), e.scheduleRender();
      const { layoutDependency: r } = i.options, { layoutDependency: o } = e.options;
      (r === void 0 || r !== o) && (e.resumeFrom = i, n && (i.preserveOpacity = !0), i.snapshot && (e.snapshot = i.snapshot, e.snapshot.latestValues = i.animationValues || i.latestValues), (s = e.root) != null && s.isUpdating && (e.isLayoutDirty = !0)), e.options.crossfade === !1 && i.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((e) => {
      var n, i, s, r, o;
      (i = (n = e.options).onExitComplete) == null || i.call(n), (o = (s = e.resumingFrom) == null ? void 0 : (r = s.options).onExitComplete) == null || o.call(r);
    });
  }
  scheduleRender() {
    this.members.forEach((e) => e.instance && e.scheduleRender(!1));
  }
  removeLeadSnapshot() {
    var e;
    (e = this.lead) != null && e.snapshot && (this.lead.snapshot = void 0);
  }
}
const Be = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
}, fn = ["", "X", "Y", "Z"], Ku = 1e3;
let zu = 0;
function dn(t, e, n, i) {
  const { latestValues: s } = e;
  s[t] && (n[t] = s[t], e.setStaticValue(t, 0), i && (i[t] = 0));
}
function _r(t) {
  if (t.hasCheckedOptimisedAppear = !0, t.root === t)
    return;
  const { visualElement: e } = t.options;
  if (!e)
    return;
  const n = ar(e);
  if (window.MotionHasOptimisedAnimation(n, "transform")) {
    const { layout: s, layoutId: r } = t.options;
    window.MotionCancelOptimisedAnimation(n, "transform", B, !(s || r));
  }
  const { parent: i } = t;
  i && !i.hasCheckedOptimisedAppear && _r(i);
}
function Kr({ attachResizeListener: t, defaultParent: e, measureScroll: n, checkIsScrollRoot: i, resetTransform: s }) {
  return class {
    constructor(o = {}, a = e == null ? void 0 : e()) {
      this.id = zu++, this.animationId = 0, this.animationCommitId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.layoutVersion = 0, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, this.nodes.forEach(Xu), this.nodes.forEach(eh), this.nodes.forEach(nh), this.nodes.forEach(qu);
      }, this.resolvedRelativeTargetAt = 0, this.linkedParentVersion = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = o, this.root = a ? a.root || a : this, this.path = a ? [...a.path, a] : [], this.parent = a, this.depth = a ? a.depth + 1 : 0;
      for (let l = 0; l < this.path.length; l++)
        this.path[l].shouldResetTransform = !0;
      this.root === this && (this.nodes = new $u());
    }
    addEventListener(o, a) {
      return this.eventHandlers.has(o) || this.eventHandlers.set(o, new Qn()), this.eventHandlers.get(o).add(a);
    }
    notifyListeners(o, ...a) {
      const l = this.eventHandlers.get(o);
      l && l.notify(...a);
    }
    hasListeners(o) {
      return this.eventHandlers.has(o);
    }
    /**
     * Lifecycles
     */
    mount(o) {
      if (this.instance)
        return;
      this.isSVG = Xe(o) && !yr(o), this.instance = o;
      const { layoutId: a, layout: l, visualElement: u } = this.options;
      if (u && !u.current && u.mount(o), this.root.nodes.add(this), this.parent && this.parent.children.add(this), this.root.hasTreeAnimated && (l || a) && (this.isLayoutDirty = !0), t) {
        let c, h = 0;
        const f = () => this.root.updateBlockedByResize = !1;
        B.read(() => {
          h = window.innerWidth;
        }), t(o, () => {
          const d = window.innerWidth;
          d !== h && (h = d, this.root.updateBlockedByResize = !0, c && c(), c = Uu(f, 250), Be.hasAnimatedSinceResize && (Be.hasAnimatedSinceResize = !1, this.nodes.forEach(Vs)));
        });
      }
      a && this.root.registerSharedNode(a, this), this.options.animate !== !1 && u && (a || l) && this.addEventListener("didUpdate", ({ delta: c, hasLayoutChanged: h, hasRelativeLayoutChanged: f, layout: d }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const m = this.options.transition || u.getDefaultTransition() || ah, { onLayoutAnimationStart: y, onLayoutAnimationComplete: p } = u.getProps(), g = !this.targetLayout || !Wr(this.targetLayout, d), v = !h && f;
        if (this.options.layoutRoot || this.resumeFrom || v || h && (g || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0);
          const T = {
            ...ui(m, "layout"),
            onPlay: y,
            onComplete: p
          };
          (u.shouldReduceMotion || this.options.layoutRoot) && (T.delay = 0, T.type = !1), this.startAnimation(T), this.setAnimationOrigin(c, v);
        } else
          h || Vs(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = d;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const o = this.getStack();
      o && o.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, this.eventHandlers.clear(), Tt(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(ih), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: o } = this.options;
      return o && o.getProps().transformTemplate;
    }
    willUpdate(o = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && _r(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let c = 0; c < this.path.length; c++) {
        const h = this.path[c];
        h.shouldResetTransform = !0, (typeof h.latestValues.x == "string" || typeof h.latestValues.y == "string") && (h.isLayoutDirty = !0), h.updateScroll("snapshot"), h.options.layoutRoot && h.willUpdate(!1);
      }
      const { layoutId: a, layout: l } = this.options;
      if (a === void 0 && !l)
        return;
      const u = this.getTransformTemplate();
      this.prevTransformTemplateValue = u ? u(this.latestValues, "") : void 0, this.updateSnapshot(), o && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        const l = this.updateBlockedByResize;
        this.unblockUpdate(), this.updateBlockedByResize = !1, this.clearAllSnapshots(), l && this.nodes.forEach(Ju), this.nodes.forEach(Es);
        return;
      }
      if (this.animationId <= this.animationCommitId) {
        this.nodes.forEach(Cs);
        return;
      }
      this.animationCommitId = this.animationId, this.isUpdating ? (this.isUpdating = !1, this.nodes.forEach(Qu), this.nodes.forEach(th), this.nodes.forEach(Gu), this.nodes.forEach(Yu)) : this.nodes.forEach(Cs), this.clearAllSnapshots();
      const a = J.now();
      Y.delta = gt(0, 1e3 / 60, a - Y.timestamp), Y.timestamp = a, Y.isProcessing = !0, sn.update.process(Y), sn.preRender.process(Y), sn.render.process(Y), Y.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, yi.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(Zu), this.sharedNodes.forEach(sh);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, B.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      B.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !Q(this.snapshot.measuredBox.x) && !Q(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let l = 0; l < this.path.length; l++)
          this.path[l].updateScroll();
      const o = this.layout;
      this.layout = this.measure(!1), this.layoutVersion++, this.layoutCorrected || (this.layoutCorrected = H()), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: a } = this.options;
      a && a.notify("LayoutMeasure", this.layout.layoutBox, o ? o.layoutBox : void 0);
    }
    updateScroll(o = "measure") {
      let a = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === o && (a = !1), a && this.instance) {
        const l = i(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: o,
          isRoot: l,
          offset: n(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : l
        };
      }
    }
    resetTransform() {
      if (!s)
        return;
      const o = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, a = this.projectionDelta && !jr(this.projectionDelta), l = this.getTransformTemplate(), u = l ? l(this.latestValues, "") : void 0, c = u !== this.prevTransformTemplateValue;
      o && this.instance && (a || Rt(this.latestValues) || c) && (s(this.instance, u), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(o = !0) {
      const a = this.measurePageBox();
      let l = this.removeElementScroll(a);
      return o && (l = this.removeTransform(l)), lh(l), {
        animationId: this.root.animationId,
        measuredBox: a,
        layoutBox: l,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var u;
      const { visualElement: o } = this.options;
      if (!o)
        return H();
      const a = o.measureViewportBox();
      if (!(((u = this.scroll) == null ? void 0 : u.wasRoot) || this.path.some(ch))) {
        const { scroll: c } = this.root;
        c && (mt(a.x, c.offset.x), mt(a.y, c.offset.y));
      }
      return a;
    }
    removeElementScroll(o) {
      var l;
      const a = H();
      if (at(a, o), (l = this.scroll) != null && l.wasRoot)
        return a;
      for (let u = 0; u < this.path.length; u++) {
        const c = this.path[u], { scroll: h, options: f } = c;
        c !== this.root && h && f.layoutScroll && (h.wasRoot && at(a, o), mt(a.x, h.offset.x), mt(a.y, h.offset.y));
      }
      return a;
    }
    applyTransform(o, a = !1, l) {
      var c, h;
      const u = l || H();
      at(u, o);
      for (let f = 0; f < this.path.length; f++) {
        const d = this.path[f];
        !a && d.options.layoutScroll && d.scroll && d !== d.root && (mt(u.x, -d.scroll.offset.x), mt(u.y, -d.scroll.offset.y)), Rt(d.latestValues) && ke(u, d.latestValues, (c = d.layout) == null ? void 0 : c.layoutBox);
      }
      return Rt(this.latestValues) && ke(u, this.latestValues, (h = this.layout) == null ? void 0 : h.layoutBox), u;
    }
    removeTransform(o) {
      var l;
      const a = H();
      at(a, o);
      for (let u = 0; u < this.path.length; u++) {
        const c = this.path[u];
        if (!Rt(c.latestValues))
          continue;
        let h;
        c.instance && (Wn(c.latestValues) && c.updateSnapshot(), h = H(), at(h, c.measurePageBox())), ys(a, c.latestValues, (l = c.snapshot) == null ? void 0 : l.layoutBox, h);
      }
      return Rt(this.latestValues) && ys(a, this.latestValues), a;
    }
    setTargetDelta(o) {
      this.targetDelta = o, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(o) {
      this.options = {
        ...this.options,
        ...o,
        crossfade: o.crossfade !== void 0 ? o.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== Y.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(o = !1) {
      var d;
      const a = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = a.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = a.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = a.isSharedProjectionDirty);
      const l = !!this.resumingFrom || this !== a;
      if (!(o || l && this.isSharedProjectionDirty || this.isProjectionDirty || (d = this.parent) != null && d.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: c, layoutId: h } = this.options;
      if (!this.layout || !(c || h))
        return;
      this.resolvedRelativeTargetAt = Y.timestamp;
      const f = this.getClosestProjectingParent();
      f && this.linkedParentVersion !== f.layoutVersion && !f.options.layoutRoot && this.removeRelativeTarget(), !this.targetDelta && !this.relativeTarget && (this.options.layoutAnchor !== !1 && f && f.layout ? this.createRelativeTarget(f, this.layout.layoutBox, f.layout.layoutBox) : this.removeRelativeTarget()), !(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = H(), this.targetWithTransforms = H()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), Ru(this.target, this.relativeTarget, this.relativeParent.target, this.options.layoutAnchor || void 0)) : this.targetDelta ? (this.resumingFrom ? this.applyTransform(this.layout.layoutBox, !1, this.target) : at(this.target, this.layout.layoutBox), Ar(this.target, this.targetDelta)) : at(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget && (this.attemptToResolveRelativeTarget = !1, this.options.layoutAnchor !== !1 && f && !!f.resumingFrom == !!this.resumingFrom && !f.options.layoutScroll && f.target && this.animationProgress !== 1 ? this.createRelativeTarget(f, this.target, f.target) : this.relativeParent = this.relativeTarget = void 0));
    }
    getClosestProjectingParent() {
      if (!(!this.parent || Wn(this.parent.latestValues) || Pr(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    createRelativeTarget(o, a, l) {
      this.relativeParent = o, this.linkedParentVersion = o.layoutVersion, this.forceRelativeParentToResolveTarget(), this.relativeTarget = H(), this.relativeTargetOrigin = H(), $e(this.relativeTargetOrigin, a, l, this.options.layoutAnchor || void 0), at(this.relativeTarget, this.relativeTargetOrigin);
    }
    removeRelativeTarget() {
      this.relativeParent = this.relativeTarget = void 0;
    }
    calcProjection() {
      var m;
      const o = this.getLead(), a = !!this.resumingFrom || this !== o;
      let l = !0;
      if ((this.isProjectionDirty || (m = this.parent) != null && m.isProjectionDirty) && (l = !1), a && (this.isSharedProjectionDirty || this.isTransformDirty) && (l = !1), this.resolvedRelativeTargetAt === Y.timestamp && (l = !1), l)
        return;
      const { layout: u, layoutId: c } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(u || c))
        return;
      at(this.layoutCorrected, this.layout.layoutBox);
      const h = this.treeScale.x, f = this.treeScale.y;
      ru(this.layoutCorrected, this.treeScale, this.path, a), o.layout && !o.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (o.target = o.layout.layoutBox, o.targetWithTransforms = H());
      const { target: d } = o;
      if (!d) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (hs(this.prevProjectionDelta.x, this.projectionDelta.x), hs(this.prevProjectionDelta.y, this.projectionDelta.y)), ie(this.projectionDelta, this.layoutCorrected, d, this.latestValues), (this.treeScale.x !== h || this.treeScale.y !== f || !Ss(this.projectionDelta.x, this.prevProjectionDelta.x) || !Ss(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", d));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(o = !0) {
      var a;
      if ((a = this.options.visualElement) == null || a.scheduleRender(), o) {
        const l = this.getStack();
        l && l.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = $t(), this.projectionDelta = $t(), this.projectionDeltaWithTransform = $t();
    }
    setAnimationOrigin(o, a = !1) {
      const l = this.snapshot, u = l ? l.latestValues : {}, c = { ...this.latestValues }, h = $t();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !a;
      const f = H(), d = l ? l.source : void 0, m = this.layout ? this.layout.source : void 0, y = d !== m, p = this.getStack(), g = !p || p.members.length <= 1, v = !!(y && !g && this.options.crossfade === !0 && !this.path.some(rh));
      this.animationProgress = 0;
      let T;
      this.mixTargetDelta = (x) => {
        const S = x / 1e3;
        Ds(h.x, o.x, S), Ds(h.y, o.y, S), this.setTargetDelta(h), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && ($e(f, this.layout.layoutBox, this.relativeParent.layout.layoutBox, this.options.layoutAnchor || void 0), oh(this.relativeTarget, this.relativeTargetOrigin, f, S), T && Bu(this.relativeTarget, T) && (this.isProjectionDirty = !1), T || (T = H()), at(T, this.relativeTarget)), y && (this.animationValues = c, Nu(c, u, this.latestValues, S, v, g)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = S;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(o) {
      var a, l, u;
      this.notifyListeners("animationStart"), (a = this.currentAnimation) == null || a.stop(), (u = (l = this.resumingFrom) == null ? void 0 : l.currentAnimation) == null || u.stop(), this.pendingAnimation && (Tt(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = B.update(() => {
        Be.hasAnimatedSinceResize = !0, this.motionValue || (this.motionValue = At(0)), this.motionValue.jump(0, !1), this.currentAnimation = Ur(this.motionValue, [0, 1e3], {
          ...o,
          velocity: 0,
          isSync: !0,
          onUpdate: (c) => {
            this.mixTargetDelta(c), o.onUpdate && o.onUpdate(c);
          },
          onStop: () => {
          },
          onComplete: () => {
            o.onComplete && o.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const o = this.getStack();
      o && o.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(Ku), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const o = this.getLead();
      let { targetWithTransforms: a, target: l, layout: u, latestValues: c } = o;
      if (!(!a || !l || !u)) {
        if (this !== o && this.layout && u && zr(this.options.animationType, this.layout.layoutBox, u.layoutBox)) {
          l = this.target || H();
          const h = Q(this.layout.layoutBox.x);
          l.x.min = o.target.x.min, l.x.max = l.x.min + h;
          const f = Q(this.layout.layoutBox.y);
          l.y.min = o.target.y.min, l.y.max = l.y.min + f;
        }
        at(a, l), ke(a, c), ie(this.projectionDeltaWithTransform, this.layoutCorrected, a, c);
      }
    }
    registerSharedNode(o, a) {
      this.sharedNodes.has(o) || this.sharedNodes.set(o, new _u()), this.sharedNodes.get(o).add(a);
      const u = a.options.initialPromotionConfig;
      a.promote({
        transition: u ? u.transition : void 0,
        preserveFollowOpacity: u && u.shouldPreserveFollowOpacity ? u.shouldPreserveFollowOpacity(a) : void 0
      });
    }
    isLead() {
      const o = this.getStack();
      return o ? o.lead === this : !0;
    }
    getLead() {
      var a;
      const { layoutId: o } = this.options;
      return o ? ((a = this.getStack()) == null ? void 0 : a.lead) || this : this;
    }
    getPrevLead() {
      var a;
      const { layoutId: o } = this.options;
      return o ? (a = this.getStack()) == null ? void 0 : a.prevLead : void 0;
    }
    getStack() {
      const { layoutId: o } = this.options;
      if (o)
        return this.root.sharedNodes.get(o);
    }
    promote({ needsReset: o, transition: a, preserveFollowOpacity: l } = {}) {
      const u = this.getStack();
      u && u.promote(this, l), o && (this.projectionDelta = void 0, this.needsReset = !0), a && this.setOptions({ transition: a });
    }
    relegate() {
      const o = this.getStack();
      return o ? o.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: o } = this.options;
      if (!o)
        return;
      let a = !1;
      const { latestValues: l } = o;
      if ((l.z || l.rotate || l.rotateX || l.rotateY || l.rotateZ || l.skewX || l.skewY) && (a = !0), !a)
        return;
      const u = {};
      l.z && dn("z", o, u, this.animationValues);
      for (let c = 0; c < fn.length; c++)
        dn(`rotate${fn[c]}`, o, u, this.animationValues), dn(`skew${fn[c]}`, o, u, this.animationValues);
      o.render();
      for (const c in u)
        o.setStaticValue(c, u[c]), this.animationValues && (this.animationValues[c] = u[c]);
      o.scheduleRender();
    }
    applyProjectionStyles(o, a) {
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible) {
        o.visibility = "hidden";
        return;
      }
      const l = this.getTransformTemplate();
      if (this.needsReset) {
        this.needsReset = !1, o.visibility = "", o.opacity = "", o.pointerEvents = Ie(a == null ? void 0 : a.pointerEvents) || "", o.transform = l ? l(this.latestValues, "") : "none";
        return;
      }
      const u = this.getLead();
      if (!this.projectionDelta || !this.layout || !u.target) {
        this.options.layoutId && (o.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, o.pointerEvents = Ie(a == null ? void 0 : a.pointerEvents) || ""), this.hasProjected && !Rt(this.latestValues) && (o.transform = l ? l({}, "") : "none", this.hasProjected = !1);
        return;
      }
      o.visibility = "";
      const c = u.animationValues || u.latestValues;
      this.applyTransformsToTarget();
      let h = Fu(this.projectionDeltaWithTransform, this.treeScale, c);
      l && (h = l(c, h)), o.transform = h;
      const { x: f, y: d } = this.projectionDelta;
      o.transformOrigin = `${f.origin * 100}% ${d.origin * 100}% 0`, u.animationValues ? o.opacity = u === this ? c.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : c.opacityExit : o.opacity = u === this ? c.opacity !== void 0 ? c.opacity : "" : c.opacityExit !== void 0 ? c.opacityExit : 0;
      for (const m in $n) {
        if (c[m] === void 0)
          continue;
        const { correct: y, applyTo: p, isCSSVariable: g } = $n[m], v = h === "none" ? c[m] : y(c[m], u);
        if (p) {
          const T = p.length;
          for (let x = 0; x < T; x++)
            o[p[x]] = v;
        } else
          g ? this.options.visualElement.renderState.vars[m] = v : o[m] = v;
      }
      this.options.layoutId && (o.pointerEvents = u === this ? Ie(a == null ? void 0 : a.pointerEvents) || "" : "none");
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((o) => {
        var a;
        return (a = o.currentAnimation) == null ? void 0 : a.stop();
      }), this.root.nodes.forEach(Es), this.root.sharedNodes.clear();
    }
  };
}
function Gu(t) {
  t.updateLayout();
}
function Yu(t) {
  var n;
  const e = ((n = t.resumeFrom) == null ? void 0 : n.snapshot) || t.snapshot;
  if (t.isLead() && t.layout && e && t.hasListeners("didUpdate")) {
    const { layoutBox: i, measuredBox: s } = t.layout, { animationType: r } = t.options, o = e.source !== t.layout.source;
    if (r === "size")
      dt((h) => {
        const f = o ? e.measuredBox[h] : e.layoutBox[h], d = Q(f);
        f.min = i[h].min, f.max = f.min + d;
      });
    else if (r === "x" || r === "y") {
      const h = r === "x" ? "y" : "x";
      Un(o ? e.measuredBox[h] : e.layoutBox[h], i[h]);
    } else zr(r, e.layoutBox, i) && dt((h) => {
      const f = o ? e.measuredBox[h] : e.layoutBox[h], d = Q(i[h]);
      f.max = f.min + d, t.relativeTarget && !t.currentAnimation && (t.isProjectionDirty = !0, t.relativeTarget[h].max = t.relativeTarget[h].min + d);
    });
    const a = $t();
    ie(a, i, e.layoutBox);
    const l = $t();
    o ? ie(l, t.applyTransform(s, !0), e.measuredBox) : ie(l, i, e.layoutBox);
    const u = !jr(a);
    let c = !1;
    if (!t.resumeFrom) {
      const h = t.getClosestProjectingParent();
      if (h && !h.resumeFrom) {
        const { snapshot: f, layout: d } = h;
        if (f && d) {
          const m = t.options.layoutAnchor || void 0, y = H();
          $e(y, e.layoutBox, f.layoutBox, m);
          const p = H();
          $e(p, i, d.layoutBox, m), Wr(y, p) || (c = !0), h.options.layoutRoot && (t.relativeTarget = p, t.relativeTargetOrigin = y, t.relativeParent = h);
        }
      }
    }
    t.notifyListeners("didUpdate", {
      layout: i,
      snapshot: e,
      delta: l,
      layoutDelta: a,
      hasLayoutChanged: u,
      hasRelativeLayoutChanged: c
    });
  } else if (t.isLead()) {
    const { onExitComplete: i } = t.options;
    i && i();
  }
  t.options.transition = void 0;
}
function Xu(t) {
  t.parent && (t.isProjecting() || (t.isProjectionDirty = t.parent.isProjectionDirty), t.isSharedProjectionDirty || (t.isSharedProjectionDirty = !!(t.isProjectionDirty || t.parent.isProjectionDirty || t.parent.isSharedProjectionDirty)), t.isTransformDirty || (t.isTransformDirty = t.parent.isTransformDirty));
}
function qu(t) {
  t.isProjectionDirty = t.isSharedProjectionDirty = t.isTransformDirty = !1;
}
function Zu(t) {
  t.clearSnapshot();
}
function Es(t) {
  t.clearMeasurements();
}
function Ju(t) {
  t.isLayoutDirty = !0, t.updateLayout();
}
function Cs(t) {
  t.isLayoutDirty = !1;
}
function Qu(t) {
  t.isAnimationBlocked && t.layout && !t.isLayoutDirty && (t.snapshot = t.layout, t.isLayoutDirty = !0);
}
function th(t) {
  const { visualElement: e } = t.options;
  e && e.getProps().onBeforeLayoutMeasure && e.notify("BeforeLayoutMeasure"), t.resetTransform();
}
function Vs(t) {
  t.finishAnimation(), t.targetDelta = t.relativeTarget = t.target = void 0, t.isProjectionDirty = !0;
}
function eh(t) {
  t.resolveTargetDelta();
}
function nh(t) {
  t.calcProjection();
}
function ih(t) {
  t.resetSkewAndRotation();
}
function sh(t) {
  t.removeLeadSnapshot();
}
function Ds(t, e, n) {
  t.translate = F(e.translate, 0, n), t.scale = F(e.scale, 1, n), t.origin = e.origin, t.originPoint = e.originPoint;
}
function Ms(t, e, n, i) {
  t.min = F(e.min, n.min, i), t.max = F(e.max, n.max, i);
}
function oh(t, e, n, i) {
  Ms(t.x, e.x, n.x, i), Ms(t.y, e.y, n.y, i);
}
function rh(t) {
  return t.animationValues && t.animationValues.opacityExit !== void 0;
}
const ah = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, Rs = (t) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(t), Ls = Rs("applewebkit/") && !Rs("chrome/") ? Math.round : rt;
function ks(t) {
  t.min = Ls(t.min), t.max = Ls(t.max);
}
function lh(t) {
  ks(t.x), ks(t.y);
}
function zr(t, e, n) {
  return t === "position" || t === "preserve-aspect" && !Mu(ws(e), ws(n), 0.2);
}
function ch(t) {
  var e;
  return t !== t.root && ((e = t.scroll) == null ? void 0 : e.wasRoot);
}
const uh = Kr({
  attachResizeListener: (t, e) => ue(t, "resize", e),
  measureScroll: () => {
    var t, e;
    return {
      x: document.documentElement.scrollLeft || ((t = document.body) == null ? void 0 : t.scrollLeft) || 0,
      y: document.documentElement.scrollTop || ((e = document.body) == null ? void 0 : e.scrollTop) || 0
    };
  },
  checkIsScrollRoot: () => !0
}), mn = {
  current: void 0
}, Gr = Kr({
  measureScroll: (t) => ({
    x: t.scrollLeft,
    y: t.scrollTop
  }),
  defaultParent: () => {
    if (!mn.current) {
      const t = new uh({});
      t.mount(window), t.setOptions({ layoutScroll: !0 }), mn.current = t;
    }
    return mn.current;
  },
  resetTransform: (t, e) => {
    t.style.transform = e !== void 0 ? e : "none";
  },
  checkIsScrollRoot: (t) => window.getComputedStyle(t).position === "fixed"
}), Je = Et({
  transformPagePoint: (t) => t,
  isStatic: !1,
  reducedMotion: "never"
});
function Is(t, e) {
  if (typeof t == "function")
    return t(e);
  t != null && (t.current = e);
}
function hh(...t) {
  return (e) => {
    let n = !1;
    const i = t.map((s) => {
      const r = Is(s, e);
      return !n && typeof r == "function" && (n = !0), r;
    });
    if (n)
      return () => {
        for (let s = 0; s < i.length; s++) {
          const r = i[s];
          typeof r == "function" ? r() : Is(t[s], null);
        }
      };
  };
}
function fh(...t) {
  return Ke.useCallback(hh(...t), t);
}
class dh extends Ke.Component {
  getSnapshotBeforeUpdate(e) {
    const n = this.props.childRef.current;
    if (Ve(n) && e.isPresent && !this.props.isPresent && this.props.pop !== !1) {
      const i = n.offsetParent, s = Ve(i) && i.offsetWidth || 0, r = Ve(i) && i.offsetHeight || 0, o = getComputedStyle(n), a = this.props.sizeRef.current;
      a.height = parseFloat(o.height), a.width = parseFloat(o.width), a.top = n.offsetTop, a.left = n.offsetLeft, a.right = s - a.width - a.left, a.bottom = r - a.height - a.top;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function mh({ children: t, isPresent: e, anchorX: n, anchorY: i, root: s, pop: r }) {
  var f;
  const o = Yn(), a = j(null), l = j({
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  }), { nonce: u } = _(Je), c = ((f = t.props) == null ? void 0 : f.ref) ?? (t == null ? void 0 : t.ref), h = fh(a, c);
  return Xn(() => {
    const { width: d, height: m, top: y, left: p, right: g, bottom: v } = l.current;
    if (e || r === !1 || !a.current || !d || !m)
      return;
    const T = n === "left" ? `left: ${p}` : `right: ${g}`, x = i === "bottom" ? `bottom: ${v}` : `top: ${y}`;
    a.current.dataset.motionPopId = o;
    const S = document.createElement("style");
    u && (S.nonce = u);
    const E = s ?? document.head;
    return E.appendChild(S), S.sheet && S.sheet.insertRule(`
          [data-motion-pop-id="${o}"] {
            position: absolute !important;
            width: ${d}px !important;
            height: ${m}px !important;
            ${T}px !important;
            ${x}px !important;
          }
        `), () => {
      var V;
      (V = a.current) == null || V.removeAttribute("data-motion-pop-id"), E.contains(S) && E.removeChild(S);
    };
  }, [e]), U(dh, { isPresent: e, childRef: a, sizeRef: l, pop: r, children: r === !1 ? t : Ke.cloneElement(t, { ref: h }) });
}
const ph = ({ children: t, initial: e, isPresent: n, onExitComplete: i, custom: s, presenceAffectsLayout: r, mode: o, anchorX: a, anchorY: l, root: u }) => {
  const c = de(gh), h = Yn();
  let f = !0, d = vt(() => (f = !1, {
    id: h,
    initial: e,
    isPresent: n,
    custom: s,
    onExitComplete: (m) => {
      c.set(m, !0);
      for (const y of c.values())
        if (!y)
          return;
      i && i();
    },
    register: (m) => (c.set(m, !1), () => c.delete(m))
  }), [n, c, i]);
  return r && f && (d = { ...d }), vt(() => {
    c.forEach((m, y) => c.set(y, !1));
  }, [n]), Ke.useEffect(() => {
    !n && !c.size && i && i();
  }, [n]), t = U(mh, { pop: o === "popLayout", isPresent: n, anchorX: a, anchorY: l, root: u, children: t }), U(ze.Provider, { value: d, children: t });
};
function gh() {
  return /* @__PURE__ */ new Map();
}
function Yr(t = !0) {
  const e = _(ze);
  if (e === null)
    return [!0, null];
  const { isPresent: n, onExitComplete: i, register: s } = e, r = Yn();
  ht(() => {
    if (t)
      return s(r);
  }, [t]);
  const o = fe(() => t && i && i(r), [r, i, t]);
  return !n && i ? [!1, o] : [!0];
}
const Se = (t) => t.key || "";
function Bs(t) {
  const e = [];
  return ho.forEach(t, (n) => {
    Sa(n) && e.push(n);
  }), e;
}
const yh = ({ children: t, custom: e, initial: n = !0, onExitComplete: i, presenceAffectsLayout: s = !0, mode: r = "sync", propagate: o = !1, anchorX: a = "left", anchorY: l = "top", root: u }) => {
  const [c, h] = Yr(o), f = vt(() => Bs(t), [t]), d = o && !c ? [] : f.map(Se), m = j(!0), y = j(f), p = de(() => /* @__PURE__ */ new Map()), g = j(/* @__PURE__ */ new Set()), [v, T] = ct(f), [x, S] = ct(f);
  Zn(() => {
    m.current = !1, y.current = f;
    for (let P = 0; P < x.length; P++) {
      const A = Se(x[P]);
      d.includes(A) ? (p.delete(A), g.current.delete(A)) : p.get(A) !== !0 && p.set(A, !1);
    }
  }, [x, d.length, d.join("-")]);
  const E = [];
  if (f !== v) {
    let P = [...f];
    for (let A = 0; A < x.length; A++) {
      const w = x[A], C = Se(w);
      d.includes(C) || (P.splice(A, 0, w), E.push(w));
    }
    return r === "wait" && E.length && (P = E), S(Bs(P)), T(f), null;
  }
  process.env.NODE_ENV !== "production" && r === "wait" && x.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`);
  const { forceRender: V } = _(qn);
  return U(co, { children: x.map((P) => {
    const A = Se(P), w = o && !c ? !1 : f === x || d.includes(A), C = () => {
      if (g.current.has(A))
        return;
      if (p.has(A))
        g.current.add(A), p.set(A, !0);
      else
        return;
      let D = !0;
      p.forEach((W) => {
        W || (D = !1);
      }), D && (V == null || V(), S(y.current), o && (h == null || h()), i && i());
    };
    return U(ph, { isPresent: w, initial: !m.current || n ? void 0 : !1, custom: e, presenceAffectsLayout: s, mode: r, root: u, onExitComplete: w ? void 0 : C, anchorX: a, anchorY: l, children: P }, A);
  }) });
}, Xr = Et({ strict: !1 }), Fs = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
};
let Os = !1;
function vh() {
  if (Os)
    return;
  const t = {};
  for (const e in Fs)
    t[e] = {
      isEnabled: (n) => Fs[e].some((i) => !!n[i])
    };
  xr(t), Os = !0;
}
function qr() {
  return vh(), iu();
}
function Th(t) {
  const e = qr();
  for (const n in t)
    e[n] = {
      ...e[n],
      ...t[n]
    };
  xr(e);
}
const xh = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "propagate",
  "ignoreStrict",
  "viewport"
]);
function Ue(t) {
  return t.startsWith("while") || t.startsWith("drag") && t !== "draggable" || t.startsWith("layout") || t.startsWith("onTap") || t.startsWith("onPan") || t.startsWith("onLayout") || xh.has(t);
}
let Zr = (t) => !Ue(t);
function wh(t) {
  typeof t == "function" && (Zr = (e) => e.startsWith("on") ? !Ue(e) : t(e));
}
try {
  wh(require("@emotion/is-prop-valid").default);
} catch {
}
function Sh(t, e, n) {
  const i = {};
  for (const s in t)
    s === "values" && typeof t.values == "object" || K(t[s]) || (Zr(s) || n === !0 && Ue(s) || !e && !Ue(s) || // If trying to use native HTML drag events, forward drag listeners
    t.draggable && s.startsWith("onDrag")) && (i[s] = t[s]);
  return i;
}
const Qe = /* @__PURE__ */ Et({});
function bh(t, e) {
  if (Ze(t)) {
    const { initial: n, animate: i } = t;
    return {
      initial: n === !1 || ce(n) ? n : void 0,
      animate: ce(i) ? i : void 0
    };
  }
  return t.inherit !== !1 ? e : {};
}
function Ph(t) {
  const { initial: e, animate: n } = bh(t, _(Qe));
  return vt(() => ({ initial: e, animate: n }), [Ns(e), Ns(n)]);
}
function Ns(t) {
  return Array.isArray(t) ? t.join(" ") : t;
}
const Pi = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function Jr(t, e, n) {
  for (const i in e)
    !K(e[i]) && !Vr(i, n) && (t[i] = e[i]);
}
function Ah({ transformTemplate: t }, e) {
  return vt(() => {
    const n = Pi();
    return Si(n, e, t), Object.assign({}, n.vars, n.style);
  }, [e]);
}
function Eh(t, e) {
  const n = t.style || {}, i = {};
  return Jr(i, n, t), Object.assign(i, Ah(t, e)), i;
}
function Ch(t, e) {
  const n = {}, i = Eh(t, e);
  return t.drag && t.dragListener !== !1 && (n.draggable = !1, i.userSelect = i.WebkitUserSelect = i.WebkitTouchCallout = "none", i.touchAction = t.drag === !0 ? "none" : `pan-${t.drag === "x" ? "y" : "x"}`), t.tabIndex === void 0 && (t.onTap || t.onTapStart || t.whileTap) && (n.tabIndex = 0), n.style = i, n;
}
const Qr = () => ({
  ...Pi(),
  attrs: {}
});
function Vh(t, e, n, i) {
  const s = vt(() => {
    const r = Qr();
    return Mr(r, e, Lr(i), t.transformTemplate, t.style), {
      ...r.attrs,
      style: { ...r.style }
    };
  }, [e]);
  if (t.style) {
    const r = {};
    Jr(r, t.style, t), s.style = { ...r, ...s.style };
  }
  return s;
}
const Dh = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function Ai(t) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof t != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    t.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(Dh.indexOf(t) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(t))
    )
  );
}
function Mh(t, e, n, { latestValues: i }, s, r = !1, o) {
  const l = (o ?? Ai(t) ? Vh : Ch)(e, i, s, t), u = Sh(e, typeof t == "string", r), c = t !== fo ? { ...u, ...l, ref: n } : {}, { children: h } = e, f = vt(() => K(h) ? h.get() : h, [h]);
  return ba(t, {
    ...c,
    children: f
  });
}
function Rh({ scrapeMotionValuesFromProps: t, createRenderState: e }, n, i, s) {
  return {
    latestValues: Lh(n, i, s, t),
    renderState: e()
  };
}
function Lh(t, e, n, i) {
  const s = {}, r = i(t, {});
  for (const f in r)
    s[f] = Ie(r[f]);
  let { initial: o, animate: a } = t;
  const l = Ze(t), u = vr(t);
  e && u && !l && t.inherit !== !1 && (o === void 0 && (o = e.initial), a === void 0 && (a = e.animate));
  let c = n ? n.initial === !1 : !1;
  c = c || o === !1;
  const h = c ? a : o;
  if (h && typeof h != "boolean" && !qe(h)) {
    const f = Array.isArray(h) ? h : [h];
    for (let d = 0; d < f.length; d++) {
      const m = fi(t, f[d]);
      if (m) {
        const { transitionEnd: y, transition: p, ...g } = m;
        for (const v in g) {
          let T = g[v];
          if (Array.isArray(T)) {
            const x = c ? T.length - 1 : 0;
            T = T[x];
          }
          T !== null && (s[v] = T);
        }
        for (const v in y)
          s[v] = y[v];
      }
    }
  }
  return s;
}
const ta = (t) => (e, n) => {
  const i = _(Qe), s = _(ze), r = () => Rh(t, e, i, s);
  return n ? r() : de(r);
}, kh = /* @__PURE__ */ ta({
  scrapeMotionValuesFromProps: bi,
  createRenderState: Pi
}), Ih = /* @__PURE__ */ ta({
  scrapeMotionValuesFromProps: kr,
  createRenderState: Qr
}), Bh = Symbol.for("motionComponentSymbol");
function Fh(t, e, n) {
  const i = j(n);
  Xn(() => {
    i.current = n;
  });
  const s = j(null);
  return fe((r) => {
    var a;
    r && ((a = t.onMount) == null || a.call(t, r));
    const o = i.current;
    if (typeof o == "function")
      if (r) {
        const l = o(r);
        typeof l == "function" && (s.current = l);
      } else s.current ? (s.current(), s.current = null) : o(r);
    else o && (o.current = r);
    e && (r ? e.mount(r) : e.unmount());
  }, [e]);
}
const ea = Et({});
function Nt(t) {
  return t && typeof t == "object" && Object.prototype.hasOwnProperty.call(t, "current");
}
function Oh(t, e, n, i, s, r) {
  var T, x;
  const { visualElement: o } = _(Qe), a = _(Xr), l = _(ze), u = _(Je), c = u.reducedMotion, h = u.skipAnimations, f = j(null), d = j(!1);
  i = i || a.renderer, !f.current && i && (f.current = i(t, {
    visualState: e,
    parent: o,
    props: n,
    presenceContext: l,
    blockInitialAnimation: l ? l.initial === !1 : !1,
    reducedMotionConfig: c,
    skipAnimations: h,
    isSVG: r
  }), d.current && f.current && (f.current.manuallyAnimateOnMount = !0));
  const m = f.current, y = _(ea);
  m && !m.projection && s && (m.type === "html" || m.type === "svg") && Nh(f.current, n, s, y);
  const p = j(!1);
  Xn(() => {
    m && p.current && m.update(n, l);
  });
  const g = n[rr], v = j(!!g && typeof window < "u" && !((T = window.MotionHandoffIsComplete) != null && T.call(window, g)) && ((x = window.MotionHasOptimisedAnimation) == null ? void 0 : x.call(window, g)));
  return Zn(() => {
    d.current = !0, m && (p.current = !0, window.MotionIsMounted = !0, m.updateFeatures(), m.scheduleRenderMicrotask(), v.current && m.animationState && m.animationState.animateChanges());
  }), ht(() => {
    m && (!v.current && m.animationState && m.animationState.animateChanges(), v.current && (queueMicrotask(() => {
      var S;
      (S = window.MotionHandoffMarkAsComplete) == null || S.call(window, g);
    }), v.current = !1), m.enteringChildren = void 0);
  }), m;
}
function Nh(t, e, n, i) {
  const { layoutId: s, layout: r, drag: o, dragConstraints: a, layoutScroll: l, layoutRoot: u, layoutAnchor: c, layoutCrossfade: h } = e;
  t.projection = new n(t.latestValues, e["data-framer-portal-id"] ? void 0 : na(t.parent)), t.projection.setOptions({
    layoutId: s,
    layout: r,
    alwaysMeasureLayout: !!o || a && Nt(a),
    visualElement: t,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof r == "string" ? r : "both",
    initialPromotionConfig: i,
    crossfade: h,
    layoutScroll: l,
    layoutRoot: u,
    layoutAnchor: c
  });
}
function na(t) {
  if (t)
    return t.options.allowProjection !== !1 ? t.projection : na(t.parent);
}
function pn(t, { forwardMotionProps: e = !1, type: n } = {}, i, s) {
  i && Th(i);
  const r = n ? n === "svg" : Ai(t), o = r ? Ih : kh;
  function a(u, c) {
    let h;
    const f = {
      ..._(Je),
      ...u,
      layoutId: jh(u)
    }, { isStatic: d } = f, m = Ph(u), y = o(u, d);
    if (!d && typeof window < "u") {
      Wh(f, i);
      const p = Hh(f);
      h = p.MeasureLayout, m.visualElement = Oh(t, y, f, s, p.ProjectionNode, r);
    }
    return Qt(Qe.Provider, { value: m, children: [h && m.visualElement ? U(h, { visualElement: m.visualElement, ...f }) : null, Mh(t, u, Fh(y, m.visualElement, c), y, d, e, r)] });
  }
  a.displayName = `motion.${typeof t == "string" ? t : `create(${t.displayName ?? t.name ?? ""})`}`;
  const l = Ft(a);
  return l[Bh] = t, l;
}
function jh({ layoutId: t }) {
  const e = _(qn).id;
  return e && t !== void 0 ? e + "-" + t : t;
}
function Wh(t, e) {
  const n = _(Xr).strict;
  if (process.env.NODE_ENV !== "production" && e && n) {
    const i = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    t.ignoreStrict ? zt(!1, i, "lazy-strict-mode") : ft(!1, i, "lazy-strict-mode");
  }
}
function Hh(t) {
  const e = qr(), { drag: n, layout: i } = e;
  if (!n && !i)
    return {};
  const s = { ...n, ...i };
  return {
    MeasureLayout: n != null && n.isEnabled(t) || i != null && i.isEnabled(t) ? s.MeasureLayout : void 0,
    ProjectionNode: s.ProjectionNode
  };
}
function $h(t, e) {
  if (typeof Proxy > "u")
    return pn;
  const n = /* @__PURE__ */ new Map(), i = (r, o) => pn(r, o, t, e), s = (r, o) => (process.env.NODE_ENV !== "production" && Ge(!1, "motion() is deprecated. Use motion.create() instead."), i(r, o));
  return new Proxy(s, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (r, o) => o === "create" ? i : (n.has(o) || n.set(o, pn(o, void 0, t, e)), n.get(o))
  });
}
const Uh = (t, e) => e.isSVG ?? Ai(t) ? new Ir(e) : new Dr(e, {
  allowProjection: t !== fo
});
class _h extends Ct {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(e) {
    super(e), e.animationState || (e.animationState = Pu(e));
  }
  updateAnimationControlsSubscription() {
    const { animate: e } = this.node.getProps();
    qe(e) && (this.unmountControls = e.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: e } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    e !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var e;
    this.node.animationState.reset(), (e = this.unmountControls) == null || e.call(this);
  }
}
let Kh = 0;
class zh extends Ct {
  constructor() {
    super(...arguments), this.id = Kh++, this.isExitComplete = !1;
  }
  update() {
    var r;
    if (!this.node.presenceContext)
      return;
    const { isPresent: e, onExitComplete: n } = this.node.presenceContext, { isPresent: i } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || e === i)
      return;
    if (e && i === !1) {
      if (this.isExitComplete) {
        const { initial: o, custom: a } = this.node.getProps();
        if (typeof o == "string") {
          const l = Bt(this.node, o, a);
          if (l) {
            const { transition: u, transitionEnd: c, ...h } = l;
            for (const f in h)
              (r = this.node.getValue(f)) == null || r.jump(h[f]);
          }
        }
        this.node.animationState.reset(), this.node.animationState.animateChanges();
      } else
        this.node.animationState.setActive("exit", !1);
      this.isExitComplete = !1;
      return;
    }
    const s = this.node.animationState.setActive("exit", !e);
    n && !e && s.then(() => {
      this.isExitComplete = !0, n(this.id);
    });
  }
  mount() {
    const { register: e, onExitComplete: n } = this.node.presenceContext || {};
    n && n(this.id), e && (this.unmount = e(this.id));
  }
  unmount() {
  }
}
const Gh = {
  animation: {
    Feature: _h
  },
  exit: {
    Feature: zh
  }
};
function ye(t) {
  return {
    point: {
      x: t.pageX,
      y: t.pageY
    }
  };
}
const Yh = (t) => (e) => vi(e) && t(e, ye(e));
function se(t, e, n, i) {
  return ue(t, e, Yh(n), i);
}
const ia = ({ current: t }) => t ? t.ownerDocument.defaultView : null, js = (t, e) => Math.abs(t - e);
function Xh(t, e) {
  const n = js(t.x, e.x), i = js(t.y, e.y);
  return Math.sqrt(n ** 2 + i ** 2);
}
const Ws = /* @__PURE__ */ new Set(["auto", "scroll"]);
class sa {
  constructor(e, n, { transformPagePoint: i, contextWindow: s = window, dragSnapToOrigin: r = !1, distanceThreshold: o = 3, element: a } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.lastRawMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.scrollPositions = /* @__PURE__ */ new Map(), this.removeScrollListeners = null, this.onElementScroll = (d) => {
      this.handleScroll(d.target);
    }, this.onWindowScroll = () => {
      this.handleScroll(window);
    }, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      this.lastRawMoveEventInfo && (this.lastMoveEventInfo = be(this.lastRawMoveEventInfo, this.transformPagePoint));
      const d = gn(this.lastMoveEventInfo, this.history), m = this.startEvent !== null, y = Xh(d.offset, { x: 0, y: 0 }) >= this.distanceThreshold;
      if (!m && !y)
        return;
      const { point: p } = d, { timestamp: g } = Y;
      this.history.push({ ...p, timestamp: g });
      const { onStart: v, onMove: T } = this.handlers;
      m || (v && v(this.lastMoveEvent, d), this.startEvent = this.lastMoveEvent), T && T(this.lastMoveEvent, d);
    }, this.handlePointerMove = (d, m) => {
      this.lastMoveEvent = d, this.lastRawMoveEventInfo = m, this.lastMoveEventInfo = be(m, this.transformPagePoint), B.update(this.updatePoint, !0);
    }, this.handlePointerUp = (d, m) => {
      this.end();
      const { onEnd: y, onSessionEnd: p, resumeAnimation: g } = this.handlers;
      if ((this.dragSnapToOrigin || !this.startEvent) && g && g(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const v = gn(d.type === "pointercancel" ? this.lastMoveEventInfo : be(m, this.transformPagePoint), this.history);
      this.startEvent && y && y(d, v), p && p(d, v);
    }, !vi(e))
      return;
    this.dragSnapToOrigin = r, this.handlers = n, this.transformPagePoint = i, this.distanceThreshold = o, this.contextWindow = s || window;
    const l = ye(e), u = be(l, this.transformPagePoint), { point: c } = u, { timestamp: h } = Y;
    this.history = [{ ...c, timestamp: h }];
    const { onSessionStart: f } = n;
    f && f(e, gn(u, this.history)), this.removeListeners = me(se(this.contextWindow, "pointermove", this.handlePointerMove), se(this.contextWindow, "pointerup", this.handlePointerUp), se(this.contextWindow, "pointercancel", this.handlePointerUp)), a && this.startScrollTracking(a);
  }
  /**
   * Start tracking scroll on ancestors and window.
   */
  startScrollTracking(e) {
    let n = e.parentElement;
    for (; n; ) {
      const i = getComputedStyle(n);
      (Ws.has(i.overflowX) || Ws.has(i.overflowY)) && this.scrollPositions.set(n, {
        x: n.scrollLeft,
        y: n.scrollTop
      }), n = n.parentElement;
    }
    this.scrollPositions.set(window, {
      x: window.scrollX,
      y: window.scrollY
    }), window.addEventListener("scroll", this.onElementScroll, {
      capture: !0
    }), window.addEventListener("scroll", this.onWindowScroll), this.removeScrollListeners = () => {
      window.removeEventListener("scroll", this.onElementScroll, {
        capture: !0
      }), window.removeEventListener("scroll", this.onWindowScroll);
    };
  }
  /**
   * Handle scroll compensation during drag.
   *
   * For element scroll: adjusts history origin since pageX/pageY doesn't change.
   * For window scroll: adjusts lastMoveEventInfo since pageX/pageY would change.
   */
  handleScroll(e) {
    const n = this.scrollPositions.get(e);
    if (!n)
      return;
    const i = e === window, s = i ? { x: window.scrollX, y: window.scrollY } : {
      x: e.scrollLeft,
      y: e.scrollTop
    }, r = { x: s.x - n.x, y: s.y - n.y };
    r.x === 0 && r.y === 0 || (i ? this.lastMoveEventInfo && (this.lastMoveEventInfo.point.x += r.x, this.lastMoveEventInfo.point.y += r.y) : this.history.length > 0 && (this.history[0].x -= r.x, this.history[0].y -= r.y), this.scrollPositions.set(e, s), B.update(this.updatePoint, !0));
  }
  updateHandlers(e) {
    this.handlers = e;
  }
  end() {
    this.removeListeners && this.removeListeners(), this.removeScrollListeners && this.removeScrollListeners(), this.scrollPositions.clear(), Tt(this.updatePoint);
  }
}
function be(t, e) {
  return e ? { point: e(t.point) } : t;
}
function Hs(t, e) {
  return { x: t.x - e.x, y: t.y - e.y };
}
function gn({ point: t }, e) {
  return {
    point: t,
    delta: Hs(t, oa(e)),
    offset: Hs(t, qh(e)),
    velocity: Zh(e, 0.1)
  };
}
function qh(t) {
  return t[0];
}
function oa(t) {
  return t[t.length - 1];
}
function Zh(t, e) {
  if (t.length < 2)
    return { x: 0, y: 0 };
  let n = t.length - 1, i = null;
  const s = oa(t);
  for (; n >= 0 && (i = t[n], !(s.timestamp - i.timestamp > /* @__PURE__ */ tt(e))); )
    n--;
  if (!i)
    return { x: 0, y: 0 };
  i === t[0] && t.length > 2 && s.timestamp - i.timestamp > /* @__PURE__ */ tt(e) * 2 && (i = t[1]);
  const r = /* @__PURE__ */ ot(s.timestamp - i.timestamp);
  if (r === 0)
    return { x: 0, y: 0 };
  const o = {
    x: (s.x - i.x) / r,
    y: (s.y - i.y) / r
  };
  return o.x === 1 / 0 && (o.x = 0), o.y === 1 / 0 && (o.y = 0), o;
}
function Jh(t, { min: e, max: n }, i) {
  return e !== void 0 && t < e ? t = i ? F(e, t, i.min) : Math.max(t, e) : n !== void 0 && t > n && (t = i ? F(n, t, i.max) : Math.min(t, n)), t;
}
function $s(t, e, n) {
  return {
    min: e !== void 0 ? t.min + e : void 0,
    max: n !== void 0 ? t.max + n - (t.max - t.min) : void 0
  };
}
function Qh(t, { top: e, left: n, bottom: i, right: s }) {
  return {
    x: $s(t.x, n, s),
    y: $s(t.y, e, i)
  };
}
function Us(t, e) {
  let n = e.min - t.min, i = e.max - t.max;
  return e.max - e.min < t.max - t.min && ([n, i] = [i, n]), { min: n, max: i };
}
function tf(t, e) {
  return {
    x: Us(t.x, e.x),
    y: Us(t.y, e.y)
  };
}
function ef(t, e) {
  let n = 0.5;
  const i = Q(t), s = Q(e);
  return s > i ? n = /* @__PURE__ */ _t(e.min, e.max - i, t.min) : i > s && (n = /* @__PURE__ */ _t(t.min, t.max - s, e.min)), gt(0, 1, n);
}
function nf(t, e) {
  const n = {};
  return e.min !== void 0 && (n.min = e.min - t.min), e.max !== void 0 && (n.max = e.max - t.min), n;
}
const _n = 0.35;
function sf(t = _n) {
  return t === !1 ? t = 0 : t === !0 && (t = _n), {
    x: _s(t, "left", "right"),
    y: _s(t, "top", "bottom")
  };
}
function _s(t, e, n) {
  return {
    min: Ks(t, e),
    max: Ks(t, n)
  };
}
function Ks(t, e) {
  return typeof t == "number" ? t : t[e] || 0;
}
const of = /* @__PURE__ */ new WeakMap();
class rf {
  constructor(e) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = H(), this.latestPointerEvent = null, this.latestPanInfo = null, this.visualElement = e;
  }
  start(e, { snapToCursor: n = !1, distanceThreshold: i } = {}) {
    const { presenceContext: s } = this.visualElement;
    if (s && s.isPresent === !1)
      return;
    const r = (h) => {
      n && this.snapToCursor(ye(h).point), this.stopAnimation();
    }, o = (h, f) => {
      const { drag: d, dragPropagation: m, onDragStart: y } = this.getProps();
      if (d && !m && (this.openDragLock && this.openDragLock(), this.openDragLock = Fc(d), !this.openDragLock))
        return;
      this.latestPointerEvent = h, this.latestPanInfo = f, this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), dt((g) => {
        let v = this.getAxisMotionValue(g).get() || 0;
        if (pt.test(v)) {
          const { projection: T } = this.visualElement;
          if (T && T.layout) {
            const x = T.layout.layoutBox[g];
            x && (v = Q(x) * (parseFloat(v) / 100));
          }
        }
        this.originPoint[g] = v;
      }), y && B.update(() => y(h, f), !1, !0), Fn(this.visualElement, "transform");
      const { animationState: p } = this.visualElement;
      p && p.setActive("whileDrag", !0);
    }, a = (h, f) => {
      this.latestPointerEvent = h, this.latestPanInfo = f;
      const { dragPropagation: d, dragDirectionLock: m, onDirectionLock: y, onDrag: p } = this.getProps();
      if (!d && !this.openDragLock)
        return;
      const { offset: g } = f;
      if (m && this.currentDirection === null) {
        this.currentDirection = lf(g), this.currentDirection !== null && y && y(this.currentDirection);
        return;
      }
      this.updateAxis("x", f.point, g), this.updateAxis("y", f.point, g), this.visualElement.render(), p && B.update(() => p(h, f), !1, !0);
    }, l = (h, f) => {
      this.latestPointerEvent = h, this.latestPanInfo = f, this.stop(h, f), this.latestPointerEvent = null, this.latestPanInfo = null;
    }, u = () => {
      const { dragSnapToOrigin: h } = this.getProps();
      (h || this.constraints) && this.startAnimation({ x: 0, y: 0 });
    }, { dragSnapToOrigin: c } = this.getProps();
    this.panSession = new sa(e, {
      onSessionStart: r,
      onStart: o,
      onMove: a,
      onSessionEnd: l,
      resumeAnimation: u
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: c,
      distanceThreshold: i,
      contextWindow: ia(this.visualElement),
      element: this.visualElement.current
    });
  }
  /**
   * @internal
   */
  stop(e, n) {
    const i = e || this.latestPointerEvent, s = n || this.latestPanInfo, r = this.isDragging;
    if (this.cancel(), !r || !s || !i)
      return;
    const { velocity: o } = s;
    this.startAnimation(o);
    const { onDragEnd: a } = this.getProps();
    a && B.postRender(() => a(i, s));
  }
  /**
   * @internal
   */
  cancel() {
    this.isDragging = !1;
    const { projection: e, animationState: n } = this.visualElement;
    e && (e.isAnimationBlocked = !1), this.endPanSession();
    const { dragPropagation: i } = this.getProps();
    !i && this.openDragLock && (this.openDragLock(), this.openDragLock = null), n && n.setActive("whileDrag", !1);
  }
  /**
   * Clean up the pan session without modifying other drag state.
   * This is used during unmount to ensure event listeners are removed
   * without affecting projection animations or drag locks.
   * @internal
   */
  endPanSession() {
    this.panSession && this.panSession.end(), this.panSession = void 0;
  }
  updateAxis(e, n, i) {
    const { drag: s } = this.getProps();
    if (!i || !Pe(e, s, this.currentDirection))
      return;
    const r = this.getAxisMotionValue(e);
    let o = this.originPoint[e] + i[e];
    this.constraints && this.constraints[e] && (o = Jh(o, this.constraints[e], this.elastic[e])), r.set(o);
  }
  resolveConstraints() {
    var r;
    const { dragConstraints: e, dragElastic: n } = this.getProps(), i = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (r = this.visualElement.projection) == null ? void 0 : r.layout, s = this.constraints;
    e && Nt(e) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : e && i ? this.constraints = Qh(i.layoutBox, e) : this.constraints = !1, this.elastic = sf(n), s !== this.constraints && !Nt(e) && i && this.constraints && !this.hasMutatedConstraints && dt((o) => {
      this.constraints !== !1 && this.getAxisMotionValue(o) && (this.constraints[o] = nf(i.layoutBox[o], this.constraints[o]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: e, onMeasureDragConstraints: n } = this.getProps();
    if (!e || !Nt(e))
      return !1;
    const i = e.current;
    ft(i !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
    const { projection: s } = this.visualElement;
    if (!s || !s.layout)
      return !1;
    const r = au(i, s.root, this.visualElement.getTransformPagePoint());
    let o = tf(s.layout.layoutBox, r);
    if (n) {
      const a = n(su(o));
      this.hasMutatedConstraints = !!a, a && (o = br(a));
    }
    return o;
  }
  startAnimation(e) {
    const { drag: n, dragMomentum: i, dragElastic: s, dragTransition: r, dragSnapToOrigin: o, onDragTransitionEnd: a } = this.getProps(), l = this.constraints || {}, u = dt((c) => {
      if (!Pe(c, n, this.currentDirection))
        return;
      let h = l && l[c] || {};
      (o === !0 || o === c) && (h = { min: 0, max: 0 });
      const f = s ? 200 : 1e6, d = s ? 40 : 1e7, m = {
        type: "inertia",
        velocity: i ? e[c] : 0,
        bounceStiffness: f,
        bounceDamping: d,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...r,
        ...h
      };
      return this.startAxisValueAnimation(c, m);
    });
    return Promise.all(u).then(a);
  }
  startAxisValueAnimation(e, n) {
    const i = this.getAxisMotionValue(e);
    return Fn(this.visualElement, e), i.start(hi(e, i, 0, n, this.visualElement, !1));
  }
  stopAnimation() {
    dt((e) => this.getAxisMotionValue(e).stop());
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(e) {
    const n = `_drag${e.toUpperCase()}`, i = this.visualElement.getProps(), s = i[n];
    return s || this.visualElement.getValue(e, (i.initial ? i.initial[e] : void 0) || 0);
  }
  snapToCursor(e) {
    dt((n) => {
      const { drag: i } = this.getProps();
      if (!Pe(n, i, this.currentDirection))
        return;
      const { projection: s } = this.visualElement, r = this.getAxisMotionValue(n);
      if (s && s.layout) {
        const { min: o, max: a } = s.layout.layoutBox[n], l = r.get() || 0;
        r.set(e[n] - F(o, a, 0.5) + l);
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: e, dragConstraints: n } = this.getProps(), { projection: i } = this.visualElement;
    if (!Nt(n) || !i || !this.constraints)
      return;
    this.stopAnimation();
    const s = { x: 0, y: 0 };
    dt((o) => {
      const a = this.getAxisMotionValue(o);
      if (a && this.constraints !== !1) {
        const l = a.get();
        s[o] = ef({ min: l, max: l }, this.constraints[o]);
      }
    });
    const { transformTemplate: r } = this.visualElement.getProps();
    this.visualElement.current.style.transform = r ? r({}, "") : "none", i.root && i.root.updateScroll(), i.updateLayout(), this.constraints = !1, this.resolveConstraints(), dt((o) => {
      if (!Pe(o, e, null))
        return;
      const a = this.getAxisMotionValue(o), { min: l, max: u } = this.constraints[o];
      a.set(F(l, u, s[o]));
    }), this.visualElement.render();
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    of.set(this.visualElement, this);
    const e = this.visualElement.current, n = se(e, "pointerdown", (u) => {
      const { drag: c, dragListener: h = !0 } = this.getProps(), f = u.target, d = f !== e && $c(f);
      c && h && !d && this.start(u);
    });
    let i;
    const s = () => {
      const { dragConstraints: u } = this.getProps();
      Nt(u) && u.current && (this.constraints = this.resolveRefConstraints(), i || (i = af(e, u.current, () => this.scalePositionWithinConstraints())));
    }, { projection: r } = this.visualElement, o = r.addEventListener("measure", s);
    r && !r.layout && (r.root && r.root.updateScroll(), r.updateLayout()), B.read(s);
    const a = ue(window, "resize", () => this.scalePositionWithinConstraints()), l = r.addEventListener("didUpdate", ({ delta: u, hasLayoutChanged: c }) => {
      this.isDragging && c && (dt((h) => {
        const f = this.getAxisMotionValue(h);
        f && (this.originPoint[h] += u[h].translate, f.set(f.get() + u[h].translate));
      }), this.visualElement.render());
    });
    return () => {
      a(), n(), o(), l && l(), i && i();
    };
  }
  getProps() {
    const e = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: i = !1, dragPropagation: s = !1, dragConstraints: r = !1, dragElastic: o = _n, dragMomentum: a = !0 } = e;
    return {
      ...e,
      drag: n,
      dragDirectionLock: i,
      dragPropagation: s,
      dragConstraints: r,
      dragElastic: o,
      dragMomentum: a
    };
  }
}
function zs(t) {
  let e = !0;
  return () => {
    if (e) {
      e = !1;
      return;
    }
    t();
  };
}
function af(t, e, n) {
  const i = Qi(t, zs(n)), s = Qi(e, zs(n));
  return () => {
    i(), s();
  };
}
function Pe(t, e, n) {
  return (e === !0 || e === t) && (n === null || n === t);
}
function lf(t, e = 10) {
  let n = null;
  return Math.abs(t.y) > e ? n = "y" : Math.abs(t.x) > e && (n = "x"), n;
}
class cf extends Ct {
  constructor(e) {
    super(e), this.removeGroupControls = rt, this.removeListeners = rt, this.controls = new rf(e);
  }
  mount() {
    const { dragControls: e } = this.node.getProps();
    e && (this.removeGroupControls = e.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || rt;
  }
  update() {
    const { dragControls: e } = this.node.getProps(), { dragControls: n } = this.node.prevProps || {};
    e !== n && (this.removeGroupControls(), e && (this.removeGroupControls = e.subscribe(this.controls)));
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners(), this.controls.isDragging || this.controls.endPanSession();
  }
}
const yn = (t) => (e, n) => {
  t && B.update(() => t(e, n), !1, !0);
};
class uf extends Ct {
  constructor() {
    super(...arguments), this.removePointerDownListener = rt;
  }
  onPointerDown(e) {
    this.session = new sa(e, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: ia(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: e, onPanStart: n, onPan: i, onPanEnd: s } = this.node.getProps();
    return {
      onSessionStart: yn(e),
      onStart: yn(n),
      onMove: yn(i),
      onEnd: (r, o) => {
        delete this.session, s && B.postRender(() => s(r, o));
      }
    };
  }
  mount() {
    this.removePointerDownListener = se(this.node.current, "pointerdown", (e) => this.onPointerDown(e));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
let vn = !1;
class hf extends Pa {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: e, layoutGroup: n, switchLayoutGroup: i, layoutId: s } = this.props, { projection: r } = e;
    r && (n.group && n.group.add(r), i && i.register && s && i.register(r), vn && r.root.didUpdate(), r.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), r.setOptions({
      ...r.options,
      layoutDependency: this.props.layoutDependency,
      onExitComplete: () => this.safeToRemove()
    })), Be.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(e) {
    const { layoutDependency: n, visualElement: i, drag: s, isPresent: r } = this.props, { projection: o } = i;
    return o && (o.isPresent = r, e.layoutDependency !== n && o.setOptions({
      ...o.options,
      layoutDependency: n
    }), vn = !0, s || e.layoutDependency !== n || n === void 0 || e.isPresent !== r ? o.willUpdate() : this.safeToRemove(), e.isPresent !== r && (r ? o.promote() : o.relegate() || B.postRender(() => {
      const a = o.getStack();
      (!a || !a.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { visualElement: e, layoutAnchor: n } = this.props, { projection: i } = e;
    i && (i.options.layoutAnchor = n, i.root.didUpdate(), yi.postRender(() => {
      !i.currentAnimation && i.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: e, layoutGroup: n, switchLayoutGroup: i } = this.props, { projection: s } = e;
    vn = !0, s && (s.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(s), i && i.deregister && i.deregister(s));
  }
  safeToRemove() {
    const { safeToRemove: e } = this.props;
    e && e();
  }
  render() {
    return null;
  }
}
function ra(t) {
  const [e, n] = Yr(), i = _(qn);
  return U(hf, { ...t, layoutGroup: i, switchLayoutGroup: _(ea), isPresent: e, safeToRemove: n });
}
const ff = {
  pan: {
    Feature: uf
  },
  drag: {
    Feature: cf,
    ProjectionNode: Gr,
    MeasureLayout: ra
  }
};
function Gs(t, e, n) {
  const { props: i } = t;
  t.animationState && i.whileHover && t.animationState.setActive("whileHover", n === "Start");
  const s = "onHover" + n, r = i[s];
  r && B.postRender(() => r(e, ye(e)));
}
class df extends Ct {
  mount() {
    const { current: e } = this.node;
    e && (this.unmount = Nc(e, (n, i) => (Gs(this.node, i, "Start"), (s) => Gs(this.node, s, "End"))));
  }
  unmount() {
  }
}
class mf extends Ct {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let e = !1;
    try {
      e = this.node.current.matches(":focus-visible");
    } catch {
      e = !0;
    }
    !e || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = me(ue(this.node.current, "focus", () => this.onFocus()), ue(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
function Ys(t, e, n) {
  const { props: i } = t;
  if (t.current instanceof HTMLButtonElement && t.current.disabled)
    return;
  t.animationState && i.whileTap && t.animationState.setActive("whileTap", n === "Start");
  const s = "onTap" + (n === "End" ? "" : n), r = i[s];
  r && B.postRender(() => r(e, ye(e)));
}
class pf extends Ct {
  mount() {
    const { current: e } = this.node;
    if (!e)
      return;
    const { globalTapTarget: n, propagate: i } = this.node.props;
    this.unmount = _c(e, (s, r) => (Ys(this.node, r, "Start"), (o, { success: a }) => Ys(this.node, o, a ? "End" : "Cancel")), {
      useGlobalTarget: n,
      stopPropagation: (i == null ? void 0 : i.tap) === !1
    });
  }
  unmount() {
  }
}
const Kn = /* @__PURE__ */ new WeakMap(), Tn = /* @__PURE__ */ new WeakMap(), gf = (t) => {
  const e = Kn.get(t.target);
  e && e(t);
}, yf = (t) => {
  t.forEach(gf);
};
function vf({ root: t, ...e }) {
  const n = t || document;
  Tn.has(n) || Tn.set(n, {});
  const i = Tn.get(n), s = JSON.stringify(e);
  return i[s] || (i[s] = new IntersectionObserver(yf, { root: t, ...e })), i[s];
}
function Tf(t, e, n) {
  const i = vf(e);
  return Kn.set(t, n), i.observe(t), () => {
    Kn.delete(t), i.unobserve(t);
  };
}
const xf = {
  some: 0,
  all: 1
};
class wf extends Ct {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    var l;
    (l = this.stopObserver) == null || l.call(this);
    const { viewport: e = {} } = this.node.getProps(), { root: n, margin: i, amount: s = "some", once: r } = e, o = {
      root: n ? n.current : void 0,
      rootMargin: i,
      threshold: typeof s == "number" ? s : xf[s]
    }, a = (u) => {
      const { isIntersecting: c } = u;
      if (this.isInView === c || (this.isInView = c, r && !c && this.hasEnteredView))
        return;
      c && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", c);
      const { onViewportEnter: h, onViewportLeave: f } = this.node.getProps(), d = c ? h : f;
      d && d(u);
    };
    this.stopObserver = Tf(this.node.current, o, a);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: e, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(Sf(e, n)) && this.startObserver();
  }
  unmount() {
    var e;
    (e = this.stopObserver) == null || e.call(this), this.hasEnteredView = !1, this.isInView = !1;
  }
}
function Sf({ viewport: t = {} }, { viewport: e = {} } = {}) {
  return (n) => t[n] !== e[n];
}
const bf = {
  inView: {
    Feature: wf
  },
  tap: {
    Feature: pf
  },
  focus: {
    Feature: mf
  },
  hover: {
    Feature: df
  }
}, Pf = {
  layout: {
    ProjectionNode: Gr,
    MeasureLayout: ra
  }
}, Af = {
  ...Gh,
  ...bf,
  ...ff,
  ...Pf
}, bt = /* @__PURE__ */ $h(Af, Uh);
function zn(t) {
  const e = de(() => At(t)), { isStatic: n } = _(Je);
  if (n) {
    const [, i] = ct(t);
    ht(() => e.on("change", i), []);
  }
  return e;
}
function aa(t, e) {
  const n = zn(e()), i = () => n.set(e());
  return i(), Zn(() => {
    const s = () => B.preRender(i, !1, !0), r = t.map((o) => o.on("change", s));
    return () => {
      r.forEach((o) => o()), Tt(i);
    };
  }), n;
}
function Ef(t) {
  ne.current = [], t();
  const e = aa(ne.current, t);
  return ne.current = void 0, e;
}
function _e(t, e, n, i) {
  if (typeof t == "function")
    return Ef(t);
  const r = typeof e == "function" ? e : Le(e, n, i), o = Array.isArray(t) ? Xs(t, r) : Xs([t], ([l]) => r(l)), a = Array.isArray(t) ? void 0 : t.accelerate;
  return a && !a.isTransformed && typeof e != "function" && Array.isArray(n) && (i == null ? void 0 : i.clamp) !== !1 && (o.accelerate = {
    ...a,
    times: e,
    keyframes: n,
    isTransformed: !0
  }), o;
}
function Xs(t, e) {
  const n = de(() => []);
  return aa(t, () => {
    n.length = 0;
    const i = t.length;
    for (let s = 0; s < i; s++)
      n[s] = t[s].get();
    return e(n);
  });
}
function Cf() {
  !wi.current && Tr();
  const [t] = ct(je.current);
  return process.env.NODE_ENV !== "production" && Ge(t !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled"), t;
}
function Ei(t) {
  return typeof t == "object" && !Array.isArray(t);
}
function la(t, e, n, i) {
  return t == null ? [] : typeof t == "string" && Ei(e) ? gi(t, n, i) : t instanceof NodeList ? Array.from(t) : Array.isArray(t) ? t.filter((s) => s != null) : [t];
}
function Vf(t, e, n) {
  return t * (e + 1);
}
function qs(t, e, n, i) {
  return typeof e == "number" ? e : e.startsWith("-") || e.startsWith("+") ? Math.max(0, t + parseFloat(e)) : e === "<" ? n : e.startsWith("<") ? Math.max(0, n + parseFloat(e.slice(1))) : i.get(e) ?? t;
}
function Df(t, e, n) {
  for (let i = 0; i < t.length; i++) {
    const s = t[i];
    s.at > e && s.at < n && (Ut(t, s), i--);
  }
}
function Mf(t, e, n, i, s, r) {
  Df(t, s, r);
  for (let o = 0; o < e.length; o++)
    t.push({
      value: e[o],
      at: F(s, r, i[o]),
      easing: Do(n, o)
    });
}
function Rf(t, e) {
  for (let n = 0; n < t.length; n++)
    t[n] = t[n] / (e + 1);
}
function Lf(t, e) {
  return t.at === e.at ? t.value === null ? 1 : e.value === null ? -1 : 0 : t.at - e.at;
}
const kf = "easeInOut", If = 20;
function Bf(t, { defaultTransition: e = {}, ...n } = {}, i, s) {
  const r = e.duration || 0.3, o = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), l = {}, u = /* @__PURE__ */ new Map();
  let c = 0, h = 0, f = 0;
  for (let d = 0; d < t.length; d++) {
    const m = t[d];
    if (typeof m == "string") {
      u.set(m, h);
      continue;
    } else if (!Array.isArray(m)) {
      u.set(m.name, qs(h, m.at, c, u));
      continue;
    }
    let [y, p, g = {}] = m;
    g.at !== void 0 && (h = qs(h, g.at, c, u));
    let v = 0;
    const T = (x, S, E, V = 0, P = 0) => {
      const A = Ff(x), { delay: w = 0, times: C = Ko(A), type: D = e.type || "keyframes", repeat: W, repeatType: X, repeatDelay: q = 0, ...R } = S;
      let { ease: et = e.ease || "easeOut", duration: L } = S;
      const N = typeof w == "function" ? w(V, P) : w, Z = A.length, nt = ci(D) ? D : s == null ? void 0 : s[D || "keyframes"];
      if (Z <= 2 && nt) {
        let k = 100;
        if (Z === 2 && jf(A)) {
          const Vt = A[1] - A[0];
          k = Math.abs(Vt);
        }
        const z = {
          ...e,
          ...R
        };
        L !== void 0 && (z.duration = /* @__PURE__ */ tt(L));
        const G = Ho(z, k, nt);
        et = G.ease, L = G.duration;
      }
      L ?? (L = r);
      const st = h + N;
      C.length === 1 && C[0] === 0 && (C[1] = 1);
      const M = C.length - A.length;
      if (M > 0 && _o(C, M), A.length === 1 && A.unshift(null), W) {
        ft(W < If, "Repeat count too high, must be less than 20", "repeat-count-high"), L = Vf(L, W);
        const k = [...A], z = [...C];
        et = Array.isArray(et) ? [...et] : [et];
        const G = [...et];
        for (let Vt = 0; Vt < W; Vt++) {
          A.push(...k);
          for (let Ot = 0; Ot < k.length; Ot++)
            C.push(z[Ot] + (Vt + 1)), et.push(Ot === 0 ? "linear" : Do(G, Ot - 1));
        }
        Rf(C, W);
      }
      const I = st + L;
      Mf(E, A, et, C, st, I), v = Math.max(N + L, v), f = Math.max(I, f);
    };
    if (K(y)) {
      const x = Zs(y, a);
      T(p, g, Js("default", x));
    } else {
      const x = la(y, p, i, l), S = x.length;
      for (let E = 0; E < S; E++) {
        p = p, g = g;
        const V = x[E], P = Zs(V, a);
        for (const A in p)
          T(p[A], Of(g, A), Js(A, P), E, S);
      }
    }
    c = h, h += v;
  }
  return a.forEach((d, m) => {
    for (const y in d) {
      const p = d[y];
      p.sort(Lf);
      const g = [], v = [], T = [];
      for (let V = 0; V < p.length; V++) {
        const { at: P, value: A, easing: w } = p[V];
        g.push(A), v.push(/* @__PURE__ */ _t(0, f, P)), T.push(w || "easeOut");
      }
      v[0] !== 0 && (v.unshift(0), g.unshift(g[0]), T.unshift(kf)), v[v.length - 1] !== 1 && (v.push(1), g.push(null)), o.has(m) || o.set(m, {
        keyframes: {},
        transition: {}
      });
      const x = o.get(m);
      x.keyframes[y] = g;
      const { type: S, ...E } = e;
      x.transition[y] = {
        ...E,
        duration: f,
        ease: T,
        times: v,
        ...n
      };
    }
  }), o;
}
function Zs(t, e) {
  return !e.has(t) && e.set(t, {}), e.get(t);
}
function Js(t, e) {
  return e[t] || (e[t] = []), e[t];
}
function Ff(t) {
  return Array.isArray(t) ? t : [t];
}
function Of(t, e) {
  return t && t[e] ? {
    ...t,
    ...t[e]
  } : { ...t };
}
const Nf = (t) => typeof t == "number", jf = (t) => t.every(Nf);
function Wf(t) {
  const e = {
    presenceContext: null,
    props: {},
    visualState: {
      renderState: {
        transform: {},
        transformOrigin: {},
        style: {},
        vars: {},
        attrs: {}
      },
      latestValues: {}
    }
  }, n = Xe(t) && !yr(t) ? new Ir(e) : new Dr(e);
  n.mount(t), le.set(t, n);
}
function Hf(t) {
  const e = {
    presenceContext: null,
    props: {},
    visualState: {
      renderState: {
        output: {}
      },
      latestValues: {}
    }
  }, n = new mu(e);
  n.mount(t), le.set(t, n);
}
function $f(t, e) {
  return K(t) || typeof t == "number" || typeof t == "string" && !Ei(e);
}
function ca(t, e, n, i) {
  const s = [];
  if ($f(t, e))
    s.push(Ur(t, Ei(e) && e.default || e, n && (n.default || n)));
  else {
    if (t == null)
      return s;
    const r = la(t, e, i), o = r.length;
    ft(!!o, "No valid elements provided.", "no-valid-elements");
    for (let a = 0; a < o; a++) {
      const l = r[a], u = l instanceof Element ? Wf : Hf;
      le.has(l) || u(l);
      const c = le.get(l), h = { ...n };
      "delay" in h && typeof h.delay == "function" && (h.delay = h.delay(a, o)), s.push(...mi(c, { ...e, transition: h }, {}));
    }
  }
  return s;
}
function Uf(t, e, n) {
  const i = [], s = t.map((o) => {
    if (Array.isArray(o) && typeof o[0] == "function") {
      const a = o[0], l = At(0);
      return l.on("change", a), o.length === 1 ? [l, [0, 1]] : o.length === 2 ? [l, [0, 1], o[1]] : [l, o[1], o[2]];
    }
    return o;
  });
  return Bf(s, e, n, { spring: ae }).forEach(({ keyframes: o, transition: a }, l) => {
    i.push(...ca(l, o, a));
  }), i;
}
function _f(t) {
  return Array.isArray(t) && t.some(Array.isArray);
}
function Kf(t = {}) {
  const { scope: e, reduceMotion: n } = t;
  function i(s, r, o) {
    let a = [], l;
    if (_f(s)) {
      const { onComplete: c, ...h } = r || {};
      typeof c == "function" && (l = c), a = Uf(s, n !== void 0 ? { reduceMotion: n, ...h } : h, e);
    } else {
      const { onComplete: c, ...h } = o || {};
      typeof c == "function" && (l = c), a = ca(s, r, n !== void 0 ? { reduceMotion: n, ...h } : h, e);
    }
    const u = new sc(a);
    return l && u.finished.then(l), e && (e.animations.push(u), u.finished.then(() => {
      Ut(e.animations, u);
    })), u;
  }
  return i;
}
const Qs = Kf();
var to = "calc(100% - env(safe-area-inset-top) - 34px)", he = typeof window > "u", zf = {
  ease: "easeOut",
  duration: 0.2
}, Gf = {
  ease: "linear",
  duration: 0.01
}, Yf = 0.6, Xf = 500, ve = he ? ht : uo;
function qf({
  y: t,
  rootId: e,
  sheetRef: n
}) {
  const i = j(he ? 0 : window.innerHeight);
  function s() {
    const o = document.querySelector(`#${e}`), a = document.querySelector("body");
    o && (a.style.backgroundColor = "#000", o.style.overflow = "hidden", o.style.transitionTimingFunction = "cubic-bezier(0.32, 0.72, 0, 1)", o.style.transitionProperty = "transform, border-radius", o.style.transitionDuration = "0.5s", o.style.transformOrigin = "center top");
  }
  function r() {
    const o = document.querySelector(`#${e}`), a = document.querySelector("body");
    o && setTimeout(() => {
      a.style.removeProperty("background-color"), o.style.removeProperty("overflow"), o.style.removeProperty("transition-timing-function"), o.style.removeProperty("transition-property"), o.style.removeProperty("transition-duration"), o.style.removeProperty("transform-origin"), o.style.removeProperty("transform"), o.style.removeProperty("border-top-right-radius"), o.style.removeProperty("border-top-left-radius");
    }, 100);
  }
  ve(() => () => {
    e && r();
  }, []), ht(() => {
    const o = document.querySelector(`#${e}`);
    if (!o) return;
    function a() {
      t.get() - 10 >= i.current && r();
    }
    const l = t.on("animationStart", () => {
      var f;
      i.current = ((f = n.current) == null ? void 0 : f.offsetHeight) || window.innerHeight, s();
    }), u = t.on("change", (f) => {
      if (o) {
        const d = Math.max(0, 1 - f / i.current), m = window.innerWidth, y = (m - 16) / m, p = Le(d, [0, 1], [0, 24]), g = Le(d, [0, 1], [1, y]), v = Le(d, [0, 1], [0, 10]), T = "env(safe-area-inset-top)";
        o.style.transform = `scale(${g}) translate3d(0, calc(${T} + ${p}px), 0)`, o.style.borderTopRightRadius = `${v}px`, o.style.borderTopLeftRadius = `${v}px`;
      }
    }), c = t.on("animationComplete", a), h = t.on("animationCancel", a);
    return () => {
      l(), u(), c(), h();
    };
  }, [t, e]);
}
function Zf(t, e) {
  const n = Qf(t), i = j(!1), s = fe(() => {
    var r, o, a, l;
    i.current ? ((l = (a = e.current).onCloseEnd) == null || l.call(a), i.current = !1) : ((o = (r = e.current).onOpenEnd) == null || o.call(r), i.current = !0);
  }, [t, n]);
  return ht(() => {
    var r, o, a, l;
    !n && t ? (o = (r = e.current).onOpenStart) == null || o.call(r) : !t && n && ((l = (a = e.current).onCloseStart) == null || l.call(a));
  }, [t, n]), { handleAnimationComplete: s };
}
function Jf() {
  const [t, e] = ct({
    height: he ? 0 : window.innerHeight,
    width: he ? 0 : window.innerWidth
  });
  return ve(() => {
    function n() {
      e({
        height: window.innerHeight,
        width: window.innerWidth
      });
    }
    return n(), window.addEventListener("resize", n), () => {
      window.removeEventListener("resize", n);
    };
  }, []), t;
}
function Qf(t) {
  const e = j(void 0);
  return ht(() => {
    e.current = t;
  }), e.current;
}
function xn(t) {
  const e = j(void 0);
  return ve(() => {
    e.current = t;
  }), fe((...n) => {
    const i = e.current;
    return i == null ? void 0 : i(...n);
  }, []);
}
var td = { bottom: 0, top: 0, left: 0, right: 0 };
function ua() {
  const t = j(null), e = fe(() => td, []);
  return { constraintsRef: t, onMeasureDragConstraints: e };
}
var ha = Et(
  void 0
), tn = () => {
  const t = _(ha);
  if (!t) throw new Error("Sheet context error");
  return t;
}, fa = Et(void 0);
function ed({
  children: t
}) {
  const e = tn(), [n, i] = ct(!!e.disableDrag);
  function s() {
    e.disableDrag || i(!1);
  }
  function r() {
    n || i(!0);
  }
  return /* @__PURE__ */ it.createElement(
    fa.Provider,
    {
      value: { disableDrag: n, setDragEnabled: s, setDragDisabled: r }
    },
    t
  );
}
var da = () => {
  const t = _(fa);
  if (!t) throw new Error("Sheet scroller context error");
  return t;
};
function eo(t, e) {
  let n = t[0], i = Math.abs(t[0] - e);
  for (let s = 1; s < t.length; s++) {
    const r = Math.abs(t[s] - e);
    r < i && (n = t[s], i = r);
  }
  return n;
}
function nd(t) {
  for (let e = 0; e < t.length; e++)
    if (t[e + 1] > t[e]) return !1;
  return !0;
}
function no({
  snapTo: t,
  sheetHeight: e
}) {
  return t < 0 && console.warn(
    `Snap point is out of bounds. Sheet height is ${e} but snap point is ${e + Math.abs(t)}.`
  ), Math.max(Math.round(t), 0);
}
function Ci(t) {
  return (e) => {
    t.forEach((n) => {
      typeof n == "function" ? n(e) : n && (n.current = e);
    });
  };
}
function id() {
  return typeof window > "u" ? !1 : "ontouchstart" in window || navigator.maxTouchPoints > 0;
}
function Vi(t) {
  var e;
  return typeof window < "u" && window.navigator != null ? t.test(
    // @ts-expect-error
    ((e = window.navigator.userAgentData) == null ? void 0 : e.platform) || window.navigator.platform
  ) : !1;
}
function en(t) {
  let e = null;
  return () => (e == null && (e = t()), e);
}
var sd = en(function() {
  return Vi(/^Mac/i);
}), od = en(function() {
  return Vi(/^iPhone/i);
}), rd = en(function() {
  return Vi(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  sd() && navigator.maxTouchPoints > 1;
}), ad = en(function() {
  return od() || rd();
}), ld = 24;
function Gn(...t) {
  return (...e) => {
    for (const n of t)
      typeof n == "function" && n(...e);
  };
}
var wn = typeof document < "u" && window.visualViewport;
function io(t, e) {
  if (!t)
    return !1;
  const n = window.getComputedStyle(t);
  let i = /(auto|scroll)/.test(
    n.overflow + n.overflowX + n.overflowY
  );
  return i && e && (i = t.scrollHeight !== t.clientHeight || t.scrollWidth !== t.clientWidth), i;
}
function ma(t, e) {
  let n = t;
  for (io(n, e) && (n = n.parentElement); n && !io(n, e); )
    n = n.parentElement;
  return n || document.scrollingElement || document.documentElement;
}
var cd = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]), Ae = 0, Ee;
function ud(t = {}) {
  const { isDisabled: e } = t;
  ve(() => {
    if (!e)
      return Ae++, Ae === 1 && (ad() ? Ee = fd() : Ee = hd()), () => {
        Ae--, Ae === 0 && (Ee == null || Ee());
      };
  }, [e]);
}
function hd() {
  return Gn(
    oe(
      document.documentElement,
      "paddingRight",
      `${window.innerWidth - document.documentElement.clientWidth}px`
    ),
    oe(document.documentElement, "overflow", "hidden")
  );
}
function fd() {
  let t, e = 0;
  const n = (h) => {
    var f;
    const d = (f = h.composedPath()) == null ? void 0 : f[0];
    t = ma(d, !0), !(t === document.documentElement && t === document.body) && (e = h.changedTouches[0].pageY);
  }, i = (h) => {
    if (t === void 0)
      return;
    if (!t || t === document.documentElement || t === document.body) {
      h.preventDefault();
      return;
    }
    const f = h.changedTouches[0].pageY, d = t.scrollTop, m = t.scrollHeight - t.clientHeight;
    m !== 0 && ((d <= 0 && f > e || d >= m && f < e) && h.preventDefault(), e = f);
  }, s = (h) => {
    var f;
    const d = (f = h.composedPath()) == null ? void 0 : f[0];
    oo(d) && d !== document.activeElement && (h.preventDefault(), d.style.transform = "translateY(-2000px)", d.focus(), requestAnimationFrame(() => {
      d.style.transform = "";
    }));
  }, r = (h) => {
    var f;
    const d = (f = h.composedPath()) == null ? void 0 : f[0];
    oo(d) && (d.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      d.style.transform = "", wn && (wn.height < window.innerHeight ? requestAnimationFrame(() => {
        so(d);
      }) : wn.addEventListener(
        "resize",
        () => so(d),
        { once: !0 }
      ));
    }));
  }, o = () => {
    window.scrollTo(0, 0);
  }, a = window.pageXOffset, l = window.pageYOffset, u = Gn(
    oe(
      document.documentElement,
      "paddingRight",
      `${window.innerWidth - document.documentElement.clientWidth}px`
    ),
    oe(document.documentElement, "overflow", "hidden"),
    oe(document.body, "marginTop", `-${l}px`)
  );
  window.scrollTo(0, 0);
  const c = Gn(
    Jt(document, "touchstart", n, {
      passive: !1,
      capture: !0
    }),
    Jt(document, "touchmove", i, {
      passive: !1,
      capture: !0
    }),
    Jt(document, "touchend", s, {
      passive: !1,
      capture: !0
    }),
    Jt(document, "focus", r, !0),
    Jt(window, "scroll", o)
  );
  return () => {
    u(), c(), window.scrollTo(a, l);
  };
}
function oe(t, e, n) {
  const i = t.style[e];
  return t.style[e] = n, () => {
    t.style[e] = i;
  };
}
function Jt(t, e, n, i) {
  return t.addEventListener(e, n, i), () => {
    t.removeEventListener(e, n, i);
  };
}
function so(t) {
  const e = document.scrollingElement || document.documentElement;
  for (; t && t !== e; ) {
    const n = ma(t);
    if (n !== document.documentElement && n !== document.body && n !== t) {
      const i = n.getBoundingClientRect().top, s = t.getBoundingClientRect().top, r = t.getBoundingClientRect().bottom, o = n.getBoundingClientRect().bottom + ld;
      r > o && (n.scrollTop += s - i);
    }
    t = n.parentElement;
  }
}
function oo(t) {
  return t instanceof HTMLInputElement && !cd.has(t.type) || t instanceof HTMLTextAreaElement || t instanceof HTMLElement && t.isContentEditable;
}
var yt = {
  wrapper: {
    position: "fixed",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    overflow: "hidden",
    pointerEvents: "none"
  },
  backdrop: {
    zIndex: 1,
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.2)",
    touchAction: "none",
    // Disable iOS body scrolling
    border: "none",
    WebkitTapHighlightColor: "transparent"
  },
  container: {
    zIndex: 2,
    position: "absolute",
    left: 0,
    bottom: 0,
    width: "100%",
    backgroundColor: "#fff",
    borderTopRightRadius: "8px",
    borderTopLeftRadius: "8px",
    boxShadow: "0px -2px 16px rgba(0, 0, 0, 0.3)",
    display: "flex",
    flexDirection: "column",
    pointerEvents: "auto"
  },
  headerWrapper: {
    width: "100%"
  },
  header: {
    height: "40px",
    width: "100%",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  indicator: {
    width: "18px",
    height: "4px",
    borderRadius: "99px",
    backgroundColor: "#ddd"
  },
  content: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    minHeight: "0px",
    position: "relative"
  },
  scroller: {
    height: "100%",
    overflowY: "auto"
  }
}, pa = Ft(
  ({
    onOpenStart: t,
    onOpenEnd: e,
    onClose: n,
    onCloseStart: i,
    onCloseEnd: s,
    onSnap: r,
    children: o,
    disableScrollLocking: a = !1,
    isOpen: l,
    snapPoints: u,
    rootId: c,
    mountPoint: h,
    style: f,
    detent: d = "full-height",
    initialSnap: m = 0,
    disableDrag: y = !1,
    prefersReducedMotion: p = !1,
    tweenConfig: g = zf,
    dragVelocityThreshold: v = Xf,
    dragCloseThreshold: T = Yf,
    ...x
  }, S) => {
    const E = j(null), V = zn(0), { height: P } = Jf(), A = Cf(), w = !!(p || A), C = {
      type: "tween",
      ...w ? Gf : g
    }, D = zn(P), W = _e(
      D,
      (M) => M + 2 >= P ? -1 : (f == null ? void 0 : f.zIndex) ?? 9999
    ), X = _e(
      D,
      (M) => M + 2 >= P ? "hidden" : "visible"
    ), q = j({
      onOpenStart: t,
      onOpenEnd: e,
      onCloseStart: i,
      onCloseEnd: s
    });
    ve(() => {
      q.current = {
        onOpenStart: t,
        onOpenEnd: e,
        onCloseStart: i,
        onCloseEnd: s
      };
    });
    let R = u;
    R && (R = R.map((M) => M > 0 && M <= 1 ? Math.round(M * P) : M < 0 ? P + M : M), console.assert(
      nd(R) || P === 0,
      `Snap points need to be in descending order got: [${R.join(
        ", "
      )}]`
    ));
    const et = xn((M, { delta: I }) => {
      const k = D.getVelocity();
      k > 0 && V.set(10), k < 0 && V.set(-10), D.set(Math.max(D.get() + I.y, 0));
    }), L = xn(() => {
      const M = document.activeElement;
      if (!M || !E.current) return;
      (M.tagName === "INPUT" || M.tagName === "TEXTAREA") && E.current.contains(M) && M.blur();
    }), N = xn((M, { velocity: I }) => {
      if (I.y > v)
        n();
      else {
        const k = E.current.getBoundingClientRect().height, z = D.get();
        let G = 0;
        if (R) {
          const qt = R.map(
            (nn) => k - Math.min(nn, k)
          );
          d === "content-height" && !qt.includes(0) && qt.unshift(0), G = eo(qt, z);
        } else z / k > T && (G = k);
        if (G = no({ snapTo: G, sheetHeight: k }), Qs(D, G, C), R && r) {
          const qt = Math.abs(Math.round(R[0] - G)), nn = R.indexOf(
            eo(R, qt)
          );
          r(nn);
        }
        const Vt = Math.round(k);
        G + 2 >= Vt && n();
      }
      V.set(0);
    });
    ht(() => {
      if (!R || !r) return;
      const M = l ? m : R.length - 1;
      r(M);
    }, [l]), Aa(S, () => ({
      y: D,
      snapTo: (M) => {
        const I = E.current;
        if ((R == null ? void 0 : R[M]) !== void 0 && I) {
          const k = I.getBoundingClientRect().height, z = R[M], G = no({
            snapTo: k - z,
            sheetHeight: k
          });
          Qs(D, G, C), r && r(M), G >= k && n();
        }
      }
    })), qf({
      y: D,
      rootId: c,
      sheetRef: E
    }), ud({ isDisabled: a || !l });
    const Z = vt(() => y ? void 0 : {
      drag: "y",
      dragElastic: 0,
      dragMomentum: !1,
      dragPropagation: !1,
      onDrag: et,
      onDragStart: L,
      onDragEnd: N
    }, [y, P]), nt = {
      y: D,
      sheetRef: E,
      isOpen: l,
      initialSnap: m,
      snapPoints: R,
      detent: d,
      indicatorRotation: V,
      callbacks: q,
      dragProps: Z,
      windowHeight: P,
      animationOptions: C,
      reduceMotion: w,
      disableDrag: y
    }, st = /* @__PURE__ */ it.createElement(ha.Provider, { value: nt }, /* @__PURE__ */ it.createElement(
      bt.div,
      {
        ...x,
        ref: S,
        style: { ...yt.wrapper, zIndex: W, visibility: X, ...f }
      },
      /* @__PURE__ */ it.createElement(yh, null, l ? /* @__PURE__ */ it.createElement(ed, null, ho.map(
        o,
        (M, I) => Ea(M, { key: `sheet-child-${I}` })
      )) : null)
    ));
    return he ? st : Va(st, h ?? document.body);
  }
);
pa.displayName = "Sheet";
var ga = Ft(
  ({ children: t, style: e = {}, className: n = "", ...i }, s) => {
    const {
      y: r,
      isOpen: o,
      callbacks: a,
      snapPoints: l,
      initialSnap: u = 0,
      sheetRef: c,
      windowHeight: h,
      detent: f,
      animationOptions: d,
      reduceMotion: m
    } = tn(), { handleAnimationComplete: y } = Zf(o, a), p = l ? l[0] - l[u] : 0, g = l ? l[0] : null, v = g !== null ? `min(${g}px, ${to})` : to;
    return /* @__PURE__ */ it.createElement(
      bt.div,
      {
        ...i,
        ref: Ci([c, s]),
        className: `react-modal-sheet-container ${n}`,
        style: {
          ...yt.container,
          ...e,
          ...f === "full-height" && { height: v },
          ...f === "content-height" && { maxHeight: v },
          y: r
        },
        initial: m ? !1 : { y: h },
        animate: { y: p, transition: d },
        exit: { y: h, transition: d },
        onAnimationComplete: y
      },
      t
    );
  }
);
ga.displayName = "SheetContainer";
var ya = Ft(
  ({ children: t, style: e, disableDrag: n, className: i = "", ...s }, r) => {
    const o = tn(), a = da(), { constraintsRef: l, onMeasureDragConstraints: u } = ua(), c = n || a.disableDrag ? void 0 : o.dragProps;
    return /* @__PURE__ */ it.createElement(
      bt.div,
      {
        ...s,
        ref: Ci([r, l]),
        className: `react-modal-sheet-content ${i}`,
        style: { ...yt.content, ...e },
        ...c,
        dragConstraints: l,
        onMeasureDragConstraints: u
      },
      t
    );
  }
);
ya.displayName = "SheetContent";
var va = Ft(
  ({ children: t, style: e, disableDrag: n, ...i }, s) => {
    const { indicatorRotation: r, dragProps: o } = tn(), { constraintsRef: a, onMeasureDragConstraints: l } = ua(), u = n ? void 0 : o, c = _e(
      r,
      (f) => `translateX(2px) rotate(${f}deg)`
    ), h = _e(
      r,
      (f) => `translateX(-2px) rotate(${-1 * f}deg)`
    );
    return /* @__PURE__ */ it.createElement(
      bt.div,
      {
        ...i,
        ref: Ci([s, a]),
        style: { ...yt.headerWrapper, ...e },
        ...u,
        dragConstraints: a,
        onMeasureDragConstraints: l
      },
      t || /* @__PURE__ */ it.createElement("div", { className: "react-modal-sheet-header", style: yt.header }, /* @__PURE__ */ it.createElement(
        bt.span,
        {
          className: "react-modal-sheet-drag-indicator",
          style: { ...yt.indicator, transform: c }
        }
      ), /* @__PURE__ */ it.createElement(
        bt.span,
        {
          className: "react-modal-sheet-drag-indicator",
          style: { ...yt.indicator, transform: h }
        }
      ))
    );
  }
);
va.displayName = "SheetHeader";
var ro = (t) => !!t.onClick || !!t.onTap, Ta = Ft(
  ({ style: t = {}, className: e = "", ...n }, i) => {
    const s = ro(n) ? bt.button : bt.div, r = ro(n) ? "auto" : "none";
    return /* @__PURE__ */ it.createElement(
      s,
      {
        ...n,
        ref: i,
        className: `react-modal-sheet-backdrop ${e}`,
        style: { ...yt.backdrop, ...t, pointerEvents: r },
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 }
      }
    );
  }
);
Ta.displayName = "SheetBackdrop";
var xa = Ft(
  ({ draggableAt: t = "top", children: e, style: n, className: i = "", ...s }, r) => {
    const o = da();
    function a(h) {
      const { scrollTop: f, scrollHeight: d, clientHeight: m } = h;
      if (!(d > m)) return;
      const p = f <= 0, g = d - f === m;
      t === "top" && p || t === "bottom" && g || t === "both" && (p || g) ? o.setDragEnabled() : o.setDragDisabled();
    }
    function l(h) {
      a(h.currentTarget), s.onScroll && s.onScroll(h);
    }
    function u(h) {
      a(h.currentTarget), s.onTouchStart && s.onTouchStart(h);
    }
    const c = id() ? { onScroll: l, onTouchStart: u } : void 0;
    return /* @__PURE__ */ it.createElement(
      "div",
      {
        ...s,
        ref: r,
        className: `react-modal-sheet-scroller ${i}`,
        style: { ...yt.scroller, ...n },
        ...c
      },
      e
    );
  }
);
xa.displayName = "SheetScroller";
var Mt = Object.assign(pa, {
  Container: ga,
  Header: va,
  Content: ya,
  Backdrop: Ta,
  Scroller: xa
});
const wa = () => /* @__PURE__ */ U("div", { className: "flex items-center justify-center pb-12", children: /* @__PURE__ */ U("div", { className: "h-4 w-48 rounded-full bg-interaction-neutral-disable-main" }) });
wa.displayName = "BottomSheetIndicator";
const ao = 0.94, dd = 0.5, md = 1, pd = (t) => {
  var M;
  const {
    isOpen: e,
    header: n,
    headerType: i = "default",
    footer: s,
    footerType: r = "default",
    noDragIndicator: o,
    os: a,
    height: l,
    contentDisableDrag: u,
    dialogOptions: c = {},
    onClose: h,
    children: f,
    onSnap: d,
    onCloseEnd: m,
    onOpenEnd: y,
    onBackdropClick: p,
    zIndex: g,
    mode: v = "overflow",
    hasBottomGradation: T = !0,
    bottomSheetBodyRef: x,
    onAnimationEnd: S,
    onScroll: E,
    ...V
  } = t, P = a === "etc", A = j(null), w = j(null), [C, D] = ct(void 0), [W, X] = ct(!1), [q, R] = ct(!1), [et, L] = ct(0), [N, Z] = ct(!1);
  Ma({ show: e, mode: v }), Da(() => {
    const I = Di();
    if (!I) return;
    const k = "_ROOT_NDS_BOTTOM_SHEET_";
    let z = document.getElementById(k);
    z || (z = document.createElement("div"), z.id = k, document.body.appendChild(z)), z.className = I, D(z);
  }, []);
  const nt = vt(() => {
    switch (l) {
      case "contents":
        return { detent: "content-height" };
      case "half":
        return {
          detent: "content-height",
          initialSnap: 1,
          snapPoints: [ao, dd, 0]
        };
      case "full":
        return {
          detent: "full-height"
        };
      default:
        return l ? { initialSnap: 1, snapPoints: [ao, l, 0] } : {};
    }
  }, [l]), st = La(() => {
    if (w.current) {
      const { scrollTop: I, scrollHeight: k, clientHeight: z } = w.current, G = I + z >= k - md;
      R(!G);
    }
  }, 100);
  return ht(() => {
    if (N && w.current) {
      const { scrollHeight: I, clientHeight: k } = w.current;
      X(typeof l == "number" ? I > l : I > k);
    }
  }, [N, l]), ht(() => {
    var I;
    if (!(!e && !N))
      return st(), (I = w.current) == null || I.addEventListener("scroll", st), () => {
        var k;
        (k = w.current) == null || k.removeEventListener("scroll", st);
      };
  }, [N, e]), /* @__PURE__ */ U(co, { children: P ? (
    /**
     * pc일 경우 pc-dialog-sheet 호출
     * TODO: 추후 사용성을 보고 독립적으로 사용할지 고려 필요
     */
    /* @__PURE__ */ U(
      Ra,
      {
        body: f,
        bodyType: c.bodyType,
        bottomSheetBodyRef: x,
        className: c.className,
        containerClassName: Di(),
        footer: s,
        footerType: c.footerType,
        hasBottomGradation: T,
        height: c.height,
        id: c.id,
        noCloseIcon: c.noCloseIcon,
        onAnimationEnd: S,
        onBackdropClick: c.onBackdropClick,
        onClose: h,
        onScroll: E,
        show: e,
        title: n,
        titleType: c.titleType,
        zIndex: g
      }
    )
  ) : /* @__PURE__ */ Qt(
    Mt,
    {
      ...nt,
      dragCloseThreshold: 0.4,
      dragVelocityThreshold: 100,
      isOpen: e,
      mountPoint: C,
      onClose: h,
      ...V,
      disableScrollLocking: !0,
      onCloseEnd: () => {
        Z(!1), m == null || m();
      },
      onOpenEnd: () => {
        Z(!0), y == null || y();
      },
      onScroll: E,
      onSnap: (I) => {
        L(I), d == null || d(I), st();
      },
      ref: A,
      rootId: "root",
      style: {
        zIndex: g
      },
      children: [
        /* @__PURE__ */ U("div", { className: "absolute inset-y-0 left-1/2 z-[2] w-full max-w-mobile-size -translate-x-1/2 overflow-hidden", children: /* @__PURE__ */ Qt(
          Mt.Container,
          {
            className: "!rounded-t-28 will-change-transform shadow-3",
            style: { paddingBottom: "var(--safe-area-bottom)" },
            children: [
              /* @__PURE__ */ Qt(Mt.Header, { className: Te("py-12", { "px-24": i === "default" }), children: [
                !o && /* @__PURE__ */ U(wa, {}),
                !!n && (i === "default" ? /* @__PURE__ */ U("div", { className: "flex items-center justify-center pb-4 pt-16 typography-subtitle-20-bold", children: n }) : n)
              ] }),
              /* @__PURE__ */ Qt(Mt.Content, { disableDrag: u, children: [
                /* @__PURE__ */ U(
                  Mt.Scroller,
                  {
                    className: Te({ "!overflow-hidden": W && et !== 0 }),
                    ref: Ca([w, x]),
                    children: f
                  }
                ),
                W && T ? /* @__PURE__ */ U(
                  "div",
                  {
                    className: Te(
                      "pointer-events-none absolute inset-x-0 bottom-0 z-50 h-80 opacity-0 transition-opacity duration-500",
                      {
                        "opacity-100": q
                      }
                    ),
                    style: {
                      background: "linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FFF 82.36%)"
                    }
                  }
                ) : null
              ] }),
              /* @__PURE__ */ U(
                Mt.Content,
                {
                  className: "!shrink-0 !grow-0",
                  style: { paddingBottom: l !== "contents" ? (M = A.current) == null ? void 0 : M.y : 0 },
                  children: !!s && /* @__PURE__ */ U("div", { className: Te("", { "px-20 py-12": r === "default" }), children: s })
                }
              )
            ]
          }
        ) }),
        /* @__PURE__ */ U(
          Mt.Backdrop,
          {
            className: "!bg-scrim",
            onTap: (I) => {
              setTimeout(() => {
                p == null || p(I), h();
              }, 50);
            }
          }
        )
      ]
    }
  ) });
};
pd.displayName = "NDS.BottomSheet";
export {
  pd as B
};
